// import React, { useState, useEffect, useMemo } from "react";
// import { styled } from "@mui/material/styles";
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   CircularProgress,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Snackbar,
//   Alert,
//   LinearProgress,
//   Backdrop,
//   IconButton,
//   Tooltip,
//   Chip,
//   Avatar,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   InputAdornment,
//   Pagination,
//   Stepper,
//   Step,
//   StepLabel,
//   Divider,
//   Menu,
// } from "@mui/material";
// import {
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Add as AddIcon,
//   Close as CloseIcon,
//   Visibility as VisibilityIcon,
//   CalendarToday as CalendarTodayIcon,
//   Schedule as ScheduleIcon,
//   LocationOn as LocationOnIcon,
//   People as PeopleIcon,
//   Assignment as AssignmentIcon,
//   FilterList as FilterListIcon,
//   Refresh as RefreshIcon,
//   Search as SearchIcon,
//   Clear as ClearIcon,
//   PictureAsPdf as PictureAsPdfIcon,
//   ArrowBack as ArrowBackIcon,
//   PictureAsPdf as PDFIcon,
//   Translate as TranslateIcon,
//   Language as LanguageIcon,
//   Download as DownloadIcon,
//   Upload as UploadIcon,
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   AccessTime as AccessTimeIcon,
//   Work as WorkIcon,
//   Person as PersonIcon,
//   MoreVert as MoreVertIcon,
//   ArrowForward as ArrowForwardIcon,
// } from "@mui/icons-material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { useTheme, useMediaQuery } from "@mui/material";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchLocations,
//   fetchEmployeesByLocation,
//   fetchShifts,
//   postRoster,
//   postSchedule,
//   fetchRosterDetails,
//   fetchAllRosterDetails,
//   setSelectedDates,
//   setSelectedShifts,
//   setSelectedLocation,
//   clearSelectedEmployees,
// } from "../actions/RosterActions";

// const AlertComponent = React.forwardRef(function Alert(props, ref) {
//   return <Alert elevation={6} ref={ref} variant="filled" {...props} />;
// });

// // ------------ Translation Texts ------------
// const translations = {
//   en: {
//     title: "Roster Management System",
//     subtitle: "Create and manage employee duty rosters",
//     createRoster: "Create Roster",
//     viewAssignments: "View Assignments",
//     manageShifts: "Manage Shifts",
//     selectDates: "Select Dates",
//     selectShifts: "Select Shifts",
//     selectLocation: "Select Location",
//     selectEmployees: "Select Employees",
//     reviewAssign: "Review & Assign",
//     step1Desc: "Choose dates for the roster",
//     step2Desc: "Choose time shifts",
//     step3Desc: "Select work location",
//     step4Desc: "Select employees to assign",
//     step5Desc: "Review and confirm assignment",
//     datePicker: "Select Date",
//     location: "Location",
//     allLocations: "All Locations",
//     shift: "Shift",
//     allShifts: "All Shifts",
//     employee: "Employee",
//     serviceNo: "Service No",
//     searchEmployees: "Search employees...",
//     selectAll: "Select All",
//     deselectAll: "Deselect All",
//     selected: "Selected",
//     employees: "Employees",
//     dates: "Dates",
//     shifts: "Shifts",
//     assignRoster: "Assign Roster",
//     assigning: "Assigning...",
//     rosterAssigned: "Roster assigned successfully!",
//     assignmentFailed: "Failed to assign roster",
//     startOver: "Start Over",
//     back: "Back",
//     next: "Next",
//     addNewShift: "Add New Shift",
//     shiftCode: "Shift Code",
//     shiftName: "Shift Name",
//     startTime: "Start Time",
//     endTime: "End Time",
//     addShift: "Add Shift",
//     adding: "Adding...",
//     shiftAdded: "Shift added successfully!",
//     shiftFailed: "Failed to add shift",
//     filter: "Filter",
//     clear: "Clear",
//     applyFilters: "Apply Filters",
//     noData: "No data available",
//     noAssignments: "No roster assignments found",
//     loading: "Loading...",
//     loadingLocations: "Loading locations...",
//     loadingShifts: "Loading shifts...",
//     loadingEmployees: "Loading employees...",
//     exportPdf: "Export PDF",
//     exporting: "Exporting...",
//     pdfSuccess: "PDF exported successfully!",
//     pdfError: "Failed to export PDF",
//     reportTitle: "Roster Assignments Report",
//     reportDate: "Report Date",
//     page: "Page",
//     of: "of",
//     generatedOn: "Generated on",
//     language: "Language",
//     totalAssignments: "Total Assignments",
//     filterByDate: "Filter by Date",
//     filterByLocation: "Filter by Location",
//     filterByEmployee: "Filter by Employee",
//     filterByShift: "Filter by Shift",
//     totalStrength: "Total Employees",
//     attendance: "Present",
//     absent: "Absent",
//     employeeName: "Employee Name",
//     position: "Position",
//     department: "Department",
//     workDate: "Work Date",
//     time: "Time",
//     status: "Status",
//     active: "Active",
//     inactive: "Inactive",
//     refresh: "Refresh",
//     noShifts: "No shifts available",
//     createFirstRoster: "Create your first roster assignment",
//     welcomeMessage: "Welcome to Roster Management",
//     summary: "Summary",
//     details: "Details",
//     calendar: "Calendar",
//     list: "List",
//     week: "Week",
//     month: "Month",
//     today: "Today",
//     previous: "Previous",
//     nextMonth: "Next",
//     sun: "Sun",
//     mon: "Mon",
//     tue: "Tue",
//     wed: "Wed",
//     thu: "Thu",
//     fri: "Fri",
//     sat: "Sat",
//     actions: "Actions",
//     edit: "Edit",
//     delete: "Delete",
//     save: "Save",
//     cancel: "Cancel",
//     confirm: "Confirm",
//     areYouSure: "Are you sure?",
//     thisActionCannotBeUndone: "This action cannot be undone.",
//     yes: "Yes",
//     no: "No",
//     success: "Success",
//     error: "Error",
//     info: "Information",
//     warning: "Warning",
//   },
//   si: {
//     title: "රෝස්ටර් කළමනාකරණ පද්ධතිය",
//     subtitle: "සේවක රෝස්ටර් නිර්මාණය සහ කළමනාකරණය",
//     createRoster: "රෝස්ටර් සාදන්න",
//     viewAssignments: "නියමයන් බලන්න",
//     manageShifts: "පැය කළමනාකරණය",
//     selectDates: "දින තෝරන්න",
//     selectShifts: "පැය තෝරන්න",
//     selectLocation: "ස්ථානය තෝරන්න",
//     selectEmployees: "සේවකයන් තෝරන්න",
//     reviewAssign: "සමාලෝචනය සහ නියම කරන්න",
//     step1Desc: "රෝස්ටර් සඳහා දින තෝරන්න",
//     step2Desc: "කාල පැය තෝරන්න",
//     step3Desc: "වැඩ ස්ථානය තෝරන්න",
//     step4Desc: "නියම කිරීම සඳහා සේවකයන් තෝරන්න",
//     step5Desc: "සමාලෝචනය කර තහවුරු කරන්න",
//     datePicker: "දිනය තෝරන්න",
//     location: "ස්ථානය",
//     allLocations: "සියලු ස්ථාන",
//     shift: "පැය",
//     allShifts: "සියලු පැය",
//     employee: "සේවකයා",
//     serviceNo: "සේවා අංකය",
//     searchEmployees: "සේවකයන් සොයන්න...",
//     selectAll: "සියල්ල තෝරන්න",
//     deselectAll: "සියල්ල ඉවත් කරන්න",
//     selected: "තෝරාගත්",
//     employees: "සේවකයන්",
//     dates: "දින",
//     shifts: "පැය",
//     assignRoster: "රෝස්ටර් නියම කරන්න",
//     assigning: "නියම කරමින්...",
//     rosterAssigned: "රෝස්ටර් සාර්ථකව නියම කරන ලදී!",
//     assignmentFailed: "රෝස්ටර් නියම කිරීම අසාර්ථක විය",
//     startOver: "යලි ආරම්භ කරන්න",
//     back: "ආපසු",
//     next: "ඊළඟ",
//     addNewShift: "නව පැයක් එකතු කරන්න",
//     shiftCode: "පැය කේතය",
//     shiftName: "පැය නම",
//     startTime: "ආරම්භක වේලාව",
//     endTime: "අවසන් වේලාව",
//     addShift: "පැය එකතු කරන්න",
//     adding: "එකතු කරමින්...",
//     shiftAdded: "පැය සාර්ථකව එකතු කරන ලදී!",
//     shiftFailed: "පැය එකතු කිරීම අසාර්ථක විය",
//     filter: "පෙරහන",
//     clear: "මකන්න",
//     applyFilters: "පෙරහන යොදන්න",
//     noData: "දත්ත නොමැත",
//     noAssignments: "රෝස්ටර් නියමයන් නොමැත",
//     loading: "පූරණය වෙමින්...",
//     loadingLocations: "ස්ථාන පූරණය වෙමින්...",
//     loadingShifts: "පැය පූරණය වෙමින්...",
//     loadingEmployees: "සේවකයන් පූරණය වෙමින්...",
//     exportPdf: "PDF බාගත කරන්න",
//     exporting: "PDF බාගත කරමින්...",
//     pdfSuccess: "PDF සාර්ථකව බාගත කරන ලදී!",
//     pdfError: "PDF බාගත කිරීම අසාර්ථක විය",
//     reportTitle: "රෝස්ටර් නියමයන් වාර්තාව",
//     reportDate: "වාර්තා දිනය",
//     page: "පිටුව",
//     of: "යි",
//     generatedOn: "සෑදූ දිනය",
//     language: "භාෂාව",
//     totalAssignments: "මුළු නියමයන්",
//     filterByDate: "දිනය අනුව පෙරහන්",
//     filterByLocation: "ස්ථානය අනුව පෙරහන්",
//     filterByEmployee: "සේවකයා අනුව පෙරහන්",
//     filterByShift: "පැය අනුව පෙරහන්",
//     totalStrength: "මුළු සේවකයන්",
//     attendance: "පැමිණි",
//     absent: "පැමිණ නැත",
//     employeeName: "සේවකයාගේ නම",
//     position: "තනතුර",
//     department: "විධානය",
//     workDate: "වැඩ දිනය",
//     time: "වේලාව",
//     status: "තත්ත්වය",
//     active: "සක්‍රිය",
//     inactive: "අක්‍රිය",
//     refresh: "නැවත පූරණය කරන්න",
//     noShifts: "පැය නොමැත",
//     createFirstRoster: "ඔබගේ පළමු රෝස්ටර් නියමය සාදන්න",
//     welcomeMessage: "රෝස්ටර් කළමනාකරණයට සාදරයෙන් පිළිගනිමු",
//     summary: "සාරාංශය",
//     details: "විස්තර",
//     calendar: "දින දර්ශනය",
//     list: "ලැයිස්තුව",
//     week: "සතිය",
//     month: "මාසය",
//     today: "අද",
//     previous: "පෙර",
//     nextMonth: "ඊළඟ",
//     sun: "ඉරි",
//     mon: "සඳු",
//     tue: "අඟ",
//     wed: "බදා",
//     thu: "බ්‍රහ",
//     fri: "සිකු",
//     sat: "සෙන",
//     actions: "ක්‍රියා",
//     edit: "සංස්කරණය",
//     delete: "මකන්න",
//     save: "සුරකින්න",
//     cancel: "අවලංගු කරන්න",
//     confirm: "තහවුරු කරන්න",
//     areYouSure: "ඔබට විශ්වාසද?",
//     thisActionCannotBeUndone: "මෙම ක්‍රියාව අහෝසි කළ නොහැක.",
//     yes: "ඔව්",
//     no: "නැත",
//     success: "සාර්ථකයි",
//     error: "දෝෂය",
//     info: "තොරතුරු",
//     warning: "අවවාදය",
//   },
// };

// // ------------ Styles matching your interface ------------
// const PageContainer = styled(Box)(({ theme }) => ({
//   maxWidth: "1200px",
//   margin: "0 auto",
//   padding: "12px 16px",
//   fontFamily: "'Poppins', sans-serif",
//   backgroundColor: "#f8fafc",
//   minHeight: "calc(100vh - 120px)",
//   [theme.breakpoints.down("sm")]: {
//     padding: "8px 12px",
//   },
// }));

// const StickyHeader = styled(Box)(({ theme }) => ({
//   position: "sticky",
//   top: 0,
//   backgroundColor: "#ffffff",
//   zIndex: 100,
//   padding: "12px 0",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
//   borderRadius: "8px",
//   marginBottom: "12px",
//   [theme.breakpoints.down("sm")]: {
//     padding: "8px 0",
//   },
// }));

// const ScrollableContent = styled(Box)(({ theme }) => ({
//   [theme.breakpoints.down("sm")]: {
//     maxHeight: "calc(100vh - 280px)",
//     overflowY: "auto",
//   },
// }));

// const EmployeeCard = styled(Card)(({ theme }) => ({
//   padding: "12px 16px",
//   borderRadius: "12px",
//   marginBottom: "10px",
//   boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.08)",
//   backgroundColor: "#fff",
//   border: "1px solid #e0e0e0",
//   transition: "all 0.2s ease",
//   cursor: "pointer",
//   "&:hover": {
//     backgroundColor: "rgba(21, 76, 121, 0.04)",
//     transform: "translateY(-2px)",
//     boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
//     borderColor: "#154c79",
//   },
//   [theme.breakpoints.down("sm")]: {
//     padding: "10px 12px",
//   },
// }));

// const CalendarDay = styled(Paper)(({ theme, selected, today }) => ({
//   aspectRatio: "1",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   cursor: "pointer",
//   borderRadius: "8px",
//   backgroundColor: selected ? "#154c79" : today ? "#e8f0fa" : "#ffffff",
//   color: selected ? "#ffffff" : today ? "#154c79" : "#424242",
//   fontWeight: selected || today ? "bold" : "normal",
//   border: today ? "2px solid #154c79" : "1px solid #e0e0e0",
//   transition: "all 0.2s ease",
//   fontSize: "0.9rem",
//   "&:hover": {
//     backgroundColor: selected ? "#0D47A1" : "#f5f5f5",
//     transform: "scale(1.05)",
//   },
// }));

// const ShiftCard = styled(Card)(({ theme, selected }) => ({
//   cursor: "pointer",
//   border: selected ? "2px solid #154c79" : "1px solid #e0e0e0",
//   backgroundColor: selected ? "rgba(21, 76, 121, 0.08)" : "#ffffff",
//   transition: "all 0.2s ease",
//   borderRadius: "10px",
//   "&:hover": {
//     borderColor: "#154c79",
//     transform: "translateY(-3px)",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//   },
// }));

// const LocationCard = styled(Card)(({ theme, selected }) => ({
//   cursor: "pointer",
//   border: selected ? "2px solid #154c79" : "1px solid #e0e0e0",
//   backgroundColor: selected ? "rgba(21, 76, 121, 0.08)" : "#ffffff",
//   transition: "all 0.2s ease",
//   borderRadius: "10px",
//   "&:hover": {
//     borderColor: "#154c79",
//     transform: "translateY(-2px)",
//   },
// }));

// // Table Styles matching your interface
// const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
//   borderRadius: "12px",
//   boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
//   border: "1px solid #e0e0e0",
//   backgroundColor: "#ffffff",
//   overflow: "hidden",
//   "& .MuiTable-root": {
//     borderCollapse: "separate",
//     borderSpacing: 0,
//   },
//   "&::-webkit-scrollbar": {
//     width: "6px",
//     height: "6px",
//   },
//   "&::-webkit-scrollbar-thumb": {
//     backgroundColor: "#888",
//     borderRadius: "3px",
//   },
//   "&::-webkit-scrollbar-thumb:hover": {
//     backgroundColor: "#555",
//   },
//   [theme.breakpoints.up("sm")]: {
//     maxHeight: "500px",
//     overflowY: "auto",
//     overflowX: "auto",
//   },
//   [theme.breakpoints.down("sm")]: {
//     maxHeight: "400px",
//     overflowY: "auto",
//     overflowX: "auto",
//   },
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontFamily: "'Poppins', sans-serif",
//   padding: "10px 8px",
//   fontSize: "13px",
//   textAlign: "center",
//   "&.MuiTableCell-head": {
//     backgroundColor: "#154c79",
//     color: "#ffffff",
//     fontWeight: 600,
//     letterSpacing: "0.3px",
//     borderBottom: "none",
//     position: "sticky",
//     top: 0,
//     zIndex: 10,
//     "&:first-of-type": {
//       borderTopLeftRadius: "12px",
//     },
//     "&:last-of-type": {
//       borderTopRightRadius: "12px",
//     },
//   },
//   [theme.breakpoints.down("sm")]: {
//     padding: "8px 6px",
//     fontSize: "12px",
//     "&.MuiTableCell-head": {
//       fontSize: "13px",
//     },
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   transition: "all 0.15s ease",
//   "&:nth-of-type(odd)": {
//     backgroundColor: "rgba(243, 246, 250, 0.6)",
//   },
//   "&:hover": {
//     backgroundColor: "rgba(21, 76, 121, 0.06)",
//     cursor: "pointer",
//   },
//   "&:last-of-type td:first-of-type": {
//     borderBottomLeftRadius: "12px",
//   },
//   "&:last-of-type td:last-of-type": {
//     borderBottomRightRadius: "12px",
//   },
// }));

// const ProgressBackdrop = styled(Backdrop)(({ theme }) => ({
//   color: "#fff",
//   zIndex: theme.zIndex.drawer + 1,
//   backgroundColor: "rgba(0, 0, 0, 0.7)",
// }));

// const RosterManagement = () => {
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   // Redux state
//   const {
//     locations,
//     loadingLocations,
//     employeesByLocation,
//     loadingEmployees,
//     shifts,
//     loadingShifts,
//     postingRoster,
//     postRosterSuccess,
//     postRosterError,
//     postingSchedule,
//     postScheduleSuccess,
//     postScheduleError,
//     rosterDetails,
//     loadingRosterDetails,
//     allRosterDetails,
//     loadingAllRosterDetails,
//     selectedDates: reduxSelectedDates,
//     selectedShifts: reduxSelectedShifts,
//     selectedLocation: reduxSelectedLocation,
//   } = useSelector((state) => state.roster);

//   // State variables
//   const [activeStep, setActiveStep] = useState(0);
//   const [currentDate, setCurrentDate] = useState(new Date());
//   const [selectedDates, setSelectedDatesState] = useState([]);
//   const [selectedShifts, setSelectedShiftsState] = useState([]);
//   const [selectedLocation, setSelectedLocationState] = useState(null);
//   const [selectedEmployees, setSelectedEmployees] = useState([]);
//   const [filteredEmployees, setFilteredEmployees] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [tabValue, setTabValue] = useState(0);
//   const [page, setPage] = useState(1);
//   const [language, setLanguage] = useState("en");
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [openAddScheduleDialog, setOpenAddScheduleDialog] = useState(false);
//   const [openFilterDialog, setOpenFilterDialog] = useState(false);
//   const [filters, setFilters] = useState({
//     location: "",
//     employeeNo: "",
//     shiftCode: "",
//     workDate: null,
//   });
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const [exporting, setExporting] = useState(false);
//   const [exportProgress, setExportProgress] = useState(0);

//   const rowsPerPage = 10;
//   const t = translations[language];

//   // Helper functions
//   const formatDate = (dateObj) => {
//     const d = new Date(dateObj);
//     return d.toISOString().split("T")[0];
//   };

//   const formatDateDisplay = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       weekday: "short",
//       month: "short",
//       day: "numeric",
//       year: "numeric",
//     });
//   };

//   const getMonthName = () => {
//     return currentDate.toLocaleDateString(language === "si" ? "si-LK" : "en-US", {
//       month: "long",
//       year: "numeric",
//     });
//   };

//   // Load initial data
//   useEffect(() => {
//     dispatch(fetchLocations());
//     dispatch(fetchShifts());
//     dispatch(fetchRosterDetails());
//     dispatch(fetchAllRosterDetails({}));
//   }, [dispatch]);

//   // Sync with Redux state
//   useEffect(() => {
//     if (reduxSelectedDates) setSelectedDatesState(reduxSelectedDates);
//     if (reduxSelectedShifts) setSelectedShiftsState(reduxSelectedShifts);
//     if (reduxSelectedLocation) setSelectedLocationState(reduxSelectedLocation);
//   }, [reduxSelectedDates, reduxSelectedShifts, reduxSelectedLocation]);

//   // Filter employees based on search
//   useEffect(() => {
//     if (selectedLocation && employeesByLocation[selectedLocation]) {
//       const employees = employeesByLocation[selectedLocation];
//       if (searchTerm) {
//         const filtered = employees.filter(
//           (emp) =>
//             emp.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             emp.service_no?.includes(searchTerm)
//         );
//         setFilteredEmployees(filtered);
//       } else {
//         setFilteredEmployees(employees);
//       }
//     }
//   }, [searchTerm, selectedLocation, employeesByLocation]);

//   // Event handlers
//   const handleDateSelection = (date) => {
//     const dateStr = formatDate(date);
//     const newDates = selectedDates.includes(dateStr)
//       ? selectedDates.filter((d) => d !== dateStr)
//       : [...selectedDates, dateStr];

//     setSelectedDatesState(newDates);
//     dispatch(setSelectedDates(newDates));
//   };

//   const handleShiftSelection = (shift) => {
//     const newShifts = selectedShifts.includes(shift)
//       ? selectedShifts.filter((s) => s !== shift)
//       : [...selectedShifts, shift];

//     setSelectedShiftsState(newShifts);
//     dispatch(setSelectedShifts(newShifts));
//   };

//   const handleLocationChange = (locationCode) => {
//     setSelectedLocationState(locationCode);
//     dispatch(setSelectedLocation(locationCode));
//     dispatch(fetchEmployeesByLocation(locationCode));
//     setSelectedEmployees([]);
//   };

//   const handleEmployeeSelection = (employee) => {
//     const isSelected = selectedEmployees.some(
//       (emp) => emp.service_no === employee.service_no
//     );

//     if (isSelected) {
//       setSelectedEmployees(
//         selectedEmployees.filter((emp) => emp.service_no !== employee.service_no)
//       );
//     } else {
//       setSelectedEmployees([...selectedEmployees, employee]);
//     }
//   };

//   const handleSelectAllEmployees = () => {
//     if (selectedEmployees.length === filteredEmployees.length) {
//       setSelectedEmployees([]);
//     } else {
//       setSelectedEmployees([...filteredEmployees]);
//     }
//   };

//   const handleAssignRoster = async () => {
//     if (selectedDates.length === 0 || selectedShifts.length === 0 || selectedEmployees.length === 0) {
//       showSnackbar("Please select dates, shifts, and employees", "error");
//       return;
//     }

//     const rosterData = [];
//     selectedEmployees.forEach((employee) => {
//       selectedDates.forEach((date) => {
//         selectedShifts.forEach((shift) => {
//           rosterData.push({
//             service_no: employee.service_no,
//             WorkDate: date,
//             shift_code: shift.shift_code,
//           });
//         });
//       });
//     });

//     try {
//       const result = await dispatch(postRoster(rosterData));
//       if (result.success) {
//         showSnackbar(t.rosterAssigned, "success");
//         dispatch(fetchRosterDetails());
//         dispatch(fetchAllRosterDetails({}));
//         resetForm();
//       } else {
//         showSnackbar(t.assignmentFailed, "error");
//       }
//     } catch (error) {
//       showSnackbar(t.assignmentFailed, "error");
//     }
//   };

//   const handleAddSchedule = async () => {
//     const newSchedule = {
//       shift_code: "NEW", // You'll need to get these from state
//       shift_name: "New Shift",
//       StartTime: "09:00",
//       EndTime: "17:00",
//       status: "A",
//     };

//     try {
//       const result = await dispatch(postSchedule([newSchedule]));
//       if (result.success) {
//         showSnackbar(t.shiftAdded, "success");
//         setOpenAddScheduleDialog(false);
//       } else {
//         showSnackbar(t.shiftFailed, "error");
//       }
//     } catch (error) {
//       showSnackbar(t.shiftFailed, "error");
//     }
//   };

//   const handleApplyFilters = () => {
//     const filterParams = {
//       loc: filters.location || "",
//       sno: filters.employeeNo || "",
//       scode: filters.shiftCode || "",
//       wdate: filters.workDate ? formatDate(filters.workDate) : "",
//     };
//     dispatch(fetchAllRosterDetails(filterParams));
//     setOpenFilterDialog(false);
//   };

//   const handleResetFilters = () => {
//     setFilters({
//       location: "",
//       employeeNo: "",
//       shiftCode: "",
//       workDate: null,
//     });
//     dispatch(fetchAllRosterDetails({}));
//   };

//   const resetForm = () => {
//     setSelectedDatesState([]);
//     setSelectedShiftsState([]);
//     setSelectedLocationState(null);
//     setSelectedEmployees([]);
//     setActiveStep(0);
//     dispatch(setSelectedDates([]));
//     dispatch(setSelectedShifts([]));
//     dispatch(setSelectedLocation(null));
//     dispatch(clearSelectedEmployees());
//   };

//   const showSnackbar = (message, severity = "success") => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const closeSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   // Language menu handlers
//   const handleLanguageMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleLanguageMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLanguageChange = (lang) => {
//     setLanguage(lang);
//     handleLanguageMenuClose();
//   };

//   // Calendar rendering
//   const renderCalendar = () => {
//     const year = currentDate.getFullYear();
//     const month = currentDate.getMonth();
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     const firstDay = new Date(year, month, 1).getDay();

//     const days = [];

//     // Empty cells for first week
//     for (let i = 0; i < firstDay; i++) {
//       days.push(<Box key={`empty-${i}`} sx={{ aspectRatio: "1" }} />);
//     }

//     // Days of month
//     for (let day = 1; day <= daysInMonth; day++) {
//       const date = new Date(year, month, day);
//       const dateStr = formatDate(date);
//       const isSelected = selectedDates.includes(dateStr);
//       const isToday = dateStr === formatDate(new Date());

//       days.push(
//         <CalendarDay
//           key={day}
//           selected={isSelected}
//           today={isToday}
//           onClick={() => handleDateSelection(date)}
//         >
//           {day}
//         </CalendarDay>
//       );
//     }

//     return (
//       <Grid container spacing={1}>
//         {[
//           language === "si" ? ["ඉ", "ස", "අ", "බ", "බ්‍ර", "සි", "සෙ"] : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
//         ].flat().map((day) => (
//           <Grid item xs={12 / 7} key={day}>
//             <Typography
//               align="center"
//               sx={{
//                 fontWeight: "bold",
//                 color: "#154c79",
//                 fontSize: isMobile ? "11px" : "12px",
//                 mb: 0.5,
//               }}
//             >
//               {day}
//             </Typography>
//           </Grid>
//         ))}
//         {days.map((day, index) => (
//           <Grid item xs={12 / 7} key={`day-${index}`}>
//             {day}
//           </Grid>
//         ))}
//       </Grid>
//     );
//   };

//   // Steps content
//   const steps = [
//     {
//       label: t.selectDates,
//       description: t.step1Desc,
//       icon: <CalendarTodayIcon />,
//     },
//     {
//       label: t.selectShifts,
//       description: t.step2Desc,
//       icon: <ScheduleIcon />,
//     },
//     {
//       label: t.selectLocation,
//       description: t.step3Desc,
//       icon: <LocationOnIcon />,
//     },
//     {
//       label: t.selectEmployees,
//       description: t.step4Desc,
//       icon: <PeopleIcon />,
//     },
//     {
//       label: t.reviewAssign,
//       description: t.step5Desc,
//       icon: <AssignmentIcon />,
//     },
//   ];

//   // Calculate summary statistics
//   const totalAssignments = useMemo(() => {
//     return selectedDates.length * selectedShifts.length * selectedEmployees.length;
//   }, [selectedDates, selectedShifts, selectedEmployees]);

//   // Export PDF functions
//   const handleExportSummaryPDF = async () => {
//     if (exporting) return;

//     try {
//       setExporting(true);
//       setExportProgress(10);

//       const doc = new jsPDF("p", "mm", "a4");
//       const pageWidth = doc.internal.pageSize.getWidth();

//       setExportProgress(30);

//       // Title
//       doc.setFontSize(20);
//       doc.setFont("helvetica", "bold");
//       doc.text(t.reportTitle, pageWidth / 2, 20, { align: "center" });

//       setExportProgress(50);

//       // Generate table
//       autoTable(doc, {
//         startY: 40,
//         head: [[t.workDate, t.employeeName, t.serviceNo, t.shift, t.location, t.time]],
//         body: allRosterDetails.slice(0, 100).map((item) => [
//           formatDateDisplay(item.WorkDate),
//           item.Name || "N/A",
//           item.service_no || "N/A",
//           item.shift_name || "N/A",
//           item.LocName || "N/A",
//           `${item.StartTime || ""} - ${item.EndTime || ""}`,
//         ]),
//         styles: {
//           fontSize: 9,
//           cellPadding: 4,
//         },
//         headStyles: {
//           fillColor: [21, 76, 121],
//           textColor: 255,
//           fontStyle: "bold",
//         },
//         alternateRowStyles: {
//           fillColor: [245, 248, 252],
//         },
//       });

//       setExportProgress(80);

//       // Footer
//       const pageCount = doc.internal.getNumberOfPages();
//       for (let i = 1; i <= pageCount; i++) {
//         doc.setPage(i);
//         doc.setFontSize(10);
//         doc.setTextColor(128, 128, 128);
//         doc.text(
//           `${t.page} ${i} ${t.of} ${pageCount}`,
//           pageWidth - 20,
//           doc.internal.pageSize.getHeight() - 10,
//           { align: "right" }
//         );
//         doc.text(
//           `${t.generatedOn} ${new Date().toLocaleDateString()}`,
//           20,
//           doc.internal.pageSize.getHeight() - 10
//         );
//       }

//       setExportProgress(100);

//       // Save PDF
//       const filename = language === "si"
//         ? `රෝස්ටර්_නියමයන්_වාර්තා_${formatDate(new Date())}.pdf`
//         : `Roster_Assignments_${formatDate(new Date())}.pdf`;

//       doc.save(filename);

//       showSnackbar(t.pdfSuccess, "success");

//       setTimeout(() => {
//         setExporting(false);
//         setExportProgress(0);
//       }, 1000);
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       showSnackbar(t.pdfError, "error");
//       setExporting(false);
//       setExportProgress(0);
//     }
//   };

//   // Tabs content
//   const renderTabContent = () => {
//     switch (tabValue) {
//       case 0: // Create Roster
//         return (
//           <Box sx={{ mt: 3 }}>
//             <Stepper activeStep={activeStep} orientation={isMobile ? "vertical" : "horizontal"} sx={{ mb: 4 }}>
//               {steps.map((step, index) => (
//                 <Step key={step.label}>
//                   <StepLabel
//                     StepIconComponent={() => (
//                       <Avatar
//                         sx={{
//                           bgcolor: activeStep >= index ? "#154c79" : "#e0e0e0",
//                           color: activeStep >= index ? "white" : "#616161",
//                           width: 32,
//                           height: 32,
//                         }}
//                       >
//                         {step.icon}
//                       </Avatar>
//                     )}
//                   >
//                     <Typography variant="body2" sx={{ fontWeight: "bold", color: "#154c79" }}>
//                       {step.label}
//                     </Typography>
//                     {!isMobile && (
//                       <Typography variant="caption" sx={{ color: "#757575" }}>
//                         {step.description}
//                       </Typography>
//                     )}
//                   </StepLabel>
//                 </Step>
//               ))}
//             </Stepper>

//             {/* Step Content */}
//             <Box sx={{ mt: 4 }}>
//               {activeStep === 0 && (
//                 <Card>
//                   <CardContent>
//                     <Typography variant="h6" sx={{ mb: 2, color: "#154c79" }}>
//                       {t.selectDates}
//                     </Typography>

//                     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//                       <Button
//                         onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1))}
//                         variant="outlined"
//                         size="small"
//                         startIcon={<ArrowBackIcon />}
//                       >
//                         {t.previous}
//                       </Button>
//                       <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79" }}>
//                         {getMonthName()}
//                       </Typography>
//                       <Button
//                         onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1))}
//                         variant="outlined"
//                         size="small"
//                         endIcon={<ArrowForwardIcon />}
//                       >
//                         {t.nextMonth}
//                       </Button>
//                     </Box>

//                     {renderCalendar()}

//                     {selectedDates.length > 0 && (
//                       <Box sx={{ mt: 3 }}>
//                         <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#154c79" }}>
//                           {t.selected} {t.dates} ({selectedDates.length})
//                         </Typography>
//                         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                           {selectedDates.sort().map((date) => (
//                             <Chip
//                               key={date}
//                               label={formatDateDisplay(date)}
//                               onDelete={() => handleDateSelection(new Date(date))}
//                               color="primary"
//                               size="small"
//                               sx={{ fontWeight: "bold" }}
//                             />
//                           ))}
//                         </Box>
//                       </Box>
//                     )}

//                     <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
//                       <Button disabled variant="outlined">
//                         {t.back}
//                       </Button>
//                       <Button
//                         variant="contained"
//                         onClick={() => setActiveStep(1)}
//                         disabled={selectedDates.length === 0}
//                         endIcon={<ArrowForwardIcon />}
//                       >
//                         {t.next}: {t.selectShifts}
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               )}

//               {activeStep === 1 && (
//                 <Card>
//                   <CardContent>
//                     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//                       <Typography variant="h6" sx={{ color: "#154c79" }}>
//                         {t.selectShifts}
//                       </Typography>
//                       <Button
//                         startIcon={<AddIcon />}
//                         variant="outlined"
//                         size="small"
//                         onClick={() => setOpenAddScheduleDialog(true)}
//                       >
//                         {t.addNewShift}
//                       </Button>
//                     </Box>

//                     {loadingShifts ? (
//                       <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
//                         <CircularProgress sx={{ color: "#154c79" }} />
//                         <Typography variant="body2" sx={{ mt: 1, color: "#666" }}>
//                           {t.loadingShifts}
//                         </Typography>
//                       </Box>
//                     ) : (
//                       <Grid container spacing={2}>
//                         {shifts.map((shift) => (
//                           <Grid item xs={12} sm={6} md={4} key={shift.shift_code}>
//                             <ShiftCard
//                               selected={selectedShifts.some((s) => s.shift_code === shift.shift_code)}
//                               onClick={() => handleShiftSelection(shift)}
//                             >
//                               <CardContent>
//                                 <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#154c79" }}>
//                                   {shift.shift_name}
//                                 </Typography>
//                                 <Typography variant="body2" sx={{ color: "#546e7a", mb: 1 }}>
//                                   {t.shiftCode}: {shift.shift_code}
//                                 </Typography>
//                                 <Typography variant="body2" sx={{ color: "#154c79", fontWeight: "bold" }}>
//                                   <AccessTimeIcon sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }} />
//                                   {shift.StartTime} - {shift.EndTime}
//                                 </Typography>
//                                 <Chip
//                                   label={shift.status === "A" ? t.active : t.inactive}
//                                   size="small"
//                                   color={shift.status === "A" ? "success" : "default"}
//                                   sx={{ mt: 1 }}
//                                 />
//                               </CardContent>
//                             </ShiftCard>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     )}

//                     {selectedShifts.length > 0 && (
//                       <Box sx={{ mt: 3 }}>
//                         <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#154c79" }}>
//                           {t.selected} {t.shifts} ({selectedShifts.length})
//                         </Typography>
//                         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                           {selectedShifts.map((shift) => (
//                             <Chip
//                               key={shift.shift_code}
//                               label={`${shift.shift_name} (${shift.StartTime}-${shift.EndTime})`}
//                               onDelete={() => handleShiftSelection(shift)}
//                               color="primary"
//                               size="medium"
//                               sx={{ fontWeight: "bold" }}
//                             />
//                           ))}
//                         </Box>
//                       </Box>
//                     )}

//                     <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
//                       <Button variant="outlined" onClick={() => setActiveStep(0)} startIcon={<ArrowBackIcon />}>
//                         {t.back}
//                       </Button>
//                       <Button
//                         variant="contained"
//                         onClick={() => setActiveStep(2)}
//                         disabled={selectedShifts.length === 0}
//                         endIcon={<ArrowForwardIcon />}
//                       >
//                         {t.next}: {t.selectLocation}
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               )}

//               {activeStep === 2 && (
//                 <Card>
//                   <CardContent>
//                     <Typography variant="h6" sx={{ mb: 3, color: "#154c79" }}>
//                       {t.selectLocation}
//                     </Typography>

//                     {loadingLocations ? (
//                       <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
//                         <CircularProgress sx={{ color: "#154c79" }} />
//                         <Typography variant="body2" sx={{ mt: 1, color: "#666" }}>
//                           {t.loadingLocations}
//                         </Typography>
//                       </Box>
//                     ) : (
//                       <Grid container spacing={2}>
//                         {locations.map((location) => (
//                           <Grid item xs={12} sm={6} md={4} key={location.loc_code}>
//                             <LocationCard
//                               selected={selectedLocation === location.loc_code}
//                               onClick={() => handleLocationChange(location.loc_code)}
//                             >
//                               <CardContent>
//                                 <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                                   <Avatar sx={{ bgcolor: "#154c79" }}>
//                                     <LocationOnIcon />
//                                   </Avatar>
//                                   <Box>
//                                     <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
//                                       {location.loc_name}
//                                     </Typography>
//                                     <Typography variant="body2" sx={{ color: "#546e7a", fontSize: "0.8rem" }}>
//                                       {t.location}: {location.loc_code}
//                                     </Typography>
//                                   </Box>
//                                 </Box>
//                               </CardContent>
//                             </LocationCard>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     )}

//                     <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
//                       <Button variant="outlined" onClick={() => setActiveStep(1)} startIcon={<ArrowBackIcon />}>
//                         {t.back}
//                       </Button>
//                       <Button
//                         variant="contained"
//                         onClick={() => setActiveStep(3)}
//                         disabled={!selectedLocation}
//                         endIcon={<ArrowForwardIcon />}
//                       >
//                         {t.next}: {t.selectEmployees}
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               )}

//               {activeStep === 3 && (
//                 <Card>
//                   <CardContent>
//                     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//                       <Typography variant="h6" sx={{ color: "#154c79" }}>
//                         {t.selectEmployees} - {locations.find((l) => l.loc_code === selectedLocation)?.loc_name}
//                       </Typography>
//                       <Button variant="outlined" size="small" onClick={handleSelectAllEmployees}>
//                         {selectedEmployees.length === filteredEmployees.length ? t.deselectAll : t.selectAll}
//                       </Button>
//                     </Box>

//                     <TextField
//                       fullWidth
//                       placeholder={t.searchEmployees}
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                       sx={{ mb: 3 }}
//                       InputProps={{
//                         startAdornment: <SearchIcon sx={{ mr: 1, color: "#9e9e9e" }} />,
//                         endAdornment: searchTerm && (
//                           <IconButton size="small" onClick={() => setSearchTerm("")}>
//                             <ClearIcon />
//                           </IconButton>
//                         ),
//                       }}
//                     />

//                     {loadingEmployees ? (
//                       <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
//                         <CircularProgress sx={{ color: "#154c79" }} />
//                         <Typography variant="body2" sx={{ mt: 1, color: "#666" }}>
//                           {t.loadingEmployees}
//                         </Typography>
//                       </Box>
//                     ) : filteredEmployees.length === 0 ? (
//                       <Alert severity="info">{t.noData}</Alert>
//                     ) : (
//                       <Grid container spacing={2}>
//                         {filteredEmployees.map((employee) => (
//                           <Grid item xs={12} sm={6} md={4} key={employee.service_no}>
//                             <EmployeeCard onClick={() => handleEmployeeSelection(employee)}>
//                               <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                                 <Avatar sx={{ bgcolor: "#154c79" }}>
//                                   {employee.Name?.charAt(0) || "E"}
//                                 </Avatar>
//                                 <Box sx={{ flex: 1 }}>
//                                   <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#154c79" }}>
//                                     {employee.Name}
//                                   </Typography>
//                                   <Typography variant="caption" sx={{ color: "#546e7a", display: "block" }}>
//                                     {t.serviceNo}: {employee.service_no}
//                                   </Typography>
//                                   <Typography variant="caption" sx={{ color: "#757575", display: "block" }}>
//                                     {employee.Designation} - {employee.Department}
//                                   </Typography>
//                                 </Box>
//                                 {selectedEmployees.some((e) => e.service_no === employee.service_no) ? (
//                                   <CheckCircleIcon sx={{ color: "#2e7d32" }} />
//                                 ) : null}
//                               </Box>
//                             </EmployeeCard>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     )}

//                     {selectedEmployees.length > 0 && (
//                       <Box sx={{ mt: 3 }}>
//                         <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#154c79" }}>
//                           {t.selected} {t.employees} ({selectedEmployees.length})
//                         </Typography>
//                         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                           {selectedEmployees.map((employee) => (
//                             <Chip
//                               key={employee.service_no}
//                               label={`${employee.Name} (${employee.service_no})`}
//                               onDelete={() => handleEmployeeSelection(employee)}
//                               color="primary"
//                               size="small"
//                               avatar={<Avatar sx={{ bgcolor: "#154c79", width: 24, height: 24 }}>
//                                 {employee.Name?.charAt(0)}
//                               </Avatar>}
//                             />
//                           ))}
//                         </Box>
//                       </Box>
//                     )}

//                     <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
//                       <Button variant="outlined" onClick={() => setActiveStep(2)} startIcon={<ArrowBackIcon />}>
//                         {t.back}
//                       </Button>
//                       <Button
//                         variant="contained"
//                         onClick={() => setActiveStep(4)}
//                         disabled={selectedEmployees.length === 0}
//                         endIcon={<ArrowForwardIcon />}
//                       >
//                         {t.next}: {t.reviewAssign}
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               )}

//               {activeStep === 4 && (
//                 <Card>
//                   <CardContent>
//                     <Typography variant="h6" sx={{ mb: 3, color: "#154c79" }}>
//                       {t.reviewAssign}
//                     </Typography>

//                     <Grid container spacing={2} sx={{ mb: 3 }}>
//                       <Grid item xs={12} md={4}>
//                         <Card sx={{ bgcolor: "rgba(232, 245, 233, 0.5)", border: "1px solid #c8e6c9" }}>
//                           <CardContent>
//                             <Typography variant="subtitle2" sx={{ color: "#2e7d32", mb: 1, fontWeight: "bold" }}>
//                               {t.dates}
//                             </Typography>
//                             <Typography variant="h4" sx={{ fontWeight: "bold", color: "#2e7d32" }}>
//                               {selectedDates.length}
//                             </Typography>
//                             <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                               {selectedDates.slice(0, 3).map((date) => (
//                                 <Chip
//                                   key={date}
//                                   label={formatDateDisplay(date)}
//                                   size="small"
//                                   sx={{ bgcolor: "#e8f5e9", color: "#2e7d32" }}
//                                 />
//                               ))}
//                               {selectedDates.length > 3 && (
//                                 <Chip label={`+${selectedDates.length - 3}`} size="small" />
//                               )}
//                             </Box>
//                           </CardContent>
//                         </Card>
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <Card sx={{ bgcolor: "rgba(227, 242, 253, 0.5)", border: "1px solid #bbdefb" }}>
//                           <CardContent>
//                             <Typography variant="subtitle2" sx={{ color: "#1565c0", mb: 1, fontWeight: "bold" }}>
//                               {t.shifts}
//                             </Typography>
//                             <Typography variant="h4" sx={{ fontWeight: "bold", color: "#1565c0" }}>
//                               {selectedShifts.length}
//                             </Typography>
//                             <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                               {selectedShifts.slice(0, 2).map((shift) => (
//                                 <Chip
//                                   key={shift.shift_code}
//                                   label={shift.shift_name}
//                                   size="small"
//                                   sx={{ bgcolor: "#e3f2fd", color: "#1565c0" }}
//                                 />
//                               ))}
//                               {selectedShifts.length > 2 && (
//                                 <Chip label={`+${selectedShifts.length - 2}`} size="small" />
//                               )}
//                             </Box>
//                           </CardContent>
//                         </Card>
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <Card sx={{ bgcolor: "rgba(243, 229, 245, 0.5)", border: "1px solid #e1bee7" }}>
//                           <CardContent>
//                             <Typography variant="subtitle2" sx={{ color: "#7b1fa2", mb: 1, fontWeight: "bold" }}>
//                               {t.employees}
//                             </Typography>
//                             <Typography variant="h4" sx={{ fontWeight: "bold", color: "#7b1fa2" }}>
//                               {selectedEmployees.length}
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: "#7b1fa2", mt: 1 }}>
//                               {locations.find((l) => l.loc_code === selectedLocation)?.loc_name}
//                             </Typography>
//                           </CardContent>
//                         </Card>
//                       </Grid>
//                     </Grid>

//                     <Alert severity="info" sx={{ mb: 3 }}>
//                       {t.totalAssignments}: <strong>{totalAssignments}</strong>
//                     </Alert>

//                     <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
//                       <Button
//                         variant="outlined"
//                         onClick={() => setActiveStep(3)}
//                         startIcon={<ArrowBackIcon />}
//                         sx={{ flex: 1 }}
//                       >
//                         {t.back}
//                       </Button>
//                       <Button
//                         variant="outlined"
//                         color="secondary"
//                         onClick={resetForm}
//                         startIcon={<RefreshIcon />}
//                         sx={{ flex: 1 }}
//                       >
//                         {t.startOver}
//                       </Button>
//                       <Button
//                         variant="contained"
//                         onClick={handleAssignRoster}
//                         disabled={postingRoster}
//                         startIcon={postingRoster ? <CircularProgress size={20} /> : <AssignmentIcon />}
//                         sx={{ flex: 2 }}
//                       >
//                         {postingRoster ? t.assigning : t.assignRoster}
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               )}
//             </Box>
//           </Box>
//         );

//       case 1: // View Assignments
//         return (
//           <Box sx={{ mt: 3 }}>
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//               <Typography variant="h6" sx={{ color: "#154c79" }}>
//                 {t.viewAssignments}
//               </Typography>
//               <Box sx={{ display: "flex", gap: 1 }}>
//                 <Button
//                   startIcon={<FilterListIcon />}
//                   variant="outlined"
//                   onClick={() => setOpenFilterDialog(true)}
//                   size="small"
//                 >
//                   {t.filter}
//                 </Button>
//                 <Button
//                   startIcon={<RefreshIcon />}
//                   variant="outlined"
//                   onClick={() => dispatch(fetchAllRosterDetails({}))}
//                   disabled={loadingAllRosterDetails}
//                   size="small"
//                 >
//                   {t.refresh}
//                 </Button>
//                 <Button
//                   startIcon={<PDFIcon />}
//                   variant="contained"
//                   onClick={handleExportSummaryPDF}
//                   disabled={exporting || loadingAllRosterDetails || allRosterDetails.length === 0}
//                   size="small"
//                   sx={{ backgroundColor: "#2e7d32", "&:hover": { backgroundColor: "#1b5e20" } }}
//                 >
//                   {t.exportPdf}
//                 </Button>
//               </Box>
//             </Box>

//             {loadingAllRosterDetails ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
//                 <CircularProgress sx={{ color: "#154c79" }} />
//                 <Typography variant="body2" sx={{ mt: 1, color: "#666", ml: 2 }}>
//                   {t.loading}
//                 </Typography>
//               </Box>
//             ) : allRosterDetails.length === 0 ? (
//               <Box sx={{ textAlign: "center", p: 6 }}>
//                 <ScheduleIcon sx={{ fontSize: 60, color: "#e0e0e0", mb: 2 }} />
//                 <Typography variant="h6" sx={{ color: "#666", mb: 1 }}>
//                   {t.noAssignments}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#999", mb: 3 }}>
//                   {t.createFirstRoster}
//                 </Typography>
//                 <Button
//                   variant="contained"
//                   onClick={() => setTabValue(0)}
//                   startIcon={<AddIcon />}
//                 >
//                   {t.createRoster}
//                 </Button>
//               </Box>
//             ) : (
//               <>
//                 <StyledTableContainer component={Paper}>
//                   <Table stickyHeader>
//                     <TableHead>
//                       <TableRow>
//                         <StyledTableCell>{t.workDate}</StyledTableCell>
//                         <StyledTableCell>{t.employeeName}</StyledTableCell>
//                         <StyledTableCell>{t.serviceNo}</StyledTableCell>
//                         <StyledTableCell>{t.shift}</StyledTableCell>
//                         <StyledTableCell>{t.time}</StyledTableCell>
//                         <StyledTableCell>{t.location}</StyledTableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {allRosterDetails
//                         .slice((page - 1) * rowsPerPage, page * rowsPerPage)
//                         .map((assignment, index) => (
//                           <StyledTableRow key={index} hover>
//                             <StyledTableCell>
//                               {formatDateDisplay(assignment.WorkDate)}
//                             </StyledTableCell>
//                             <StyledTableCell sx={{ fontWeight: "bold" }}>
//                               {assignment.Name}
//                             </StyledTableCell>
//                             <StyledTableCell>{assignment.service_no}</StyledTableCell>
//                             <StyledTableCell>
//                               <Chip
//                                 label={assignment.shift_name}
//                                 size="small"
//                                 color="primary"
//                                 variant="outlined"
//                                 sx={{ fontWeight: "bold" }}
//                               />
//                             </StyledTableCell>
//                             <StyledTableCell>
//                               {assignment.StartTime} - {assignment.EndTime}
//                             </StyledTableCell>
//                             <StyledTableCell>{assignment.LocName}</StyledTableCell>
//                           </StyledTableRow>
//                         ))}
//                     </TableBody>
//                   </Table>
//                 </StyledTableContainer>

//                 <Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 2 }}>
//                   <Pagination
//                     count={Math.ceil(allRosterDetails.length / rowsPerPage)}
//                     page={page}
//                     onChange={(e, value) => setPage(value)}
//                     color="primary"
//                     size={isMobile ? "small" : "medium"}
//                   />
//                 </Box>

//                 <Typography variant="body2" sx={{ color: "#757575", textAlign: "center", mb: 2 }}>
//                   {t.page} {page} {t.of} {Math.ceil(allRosterDetails.length / rowsPerPage)}
//                 </Typography>
//               </>
//             )}
//           </Box>
//         );

//       case 2: // Manage Shifts
//         return (
//           <Box sx={{ mt: 3 }}>
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//               <Typography variant="h6" sx={{ color: "#154c79" }}>
//                 {t.manageShifts}
//               </Typography>
//               <Button
//                 startIcon={<AddIcon />}
//                 variant="contained"
//                 onClick={() => setOpenAddScheduleDialog(true)}
//               >
//                 {t.addNewShift}
//               </Button>
//             </Box>

//             {loadingShifts ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
//                 <CircularProgress sx={{ color: "#154c79" }} />
//                 <Typography variant="body2" sx={{ mt: 1, color: "#666", ml: 2 }}>
//                   {t.loadingShifts}
//                 </Typography>
//               </Box>
//             ) : shifts.length === 0 ? (
//               <Box sx={{ textAlign: "center", p: 6 }}>
//                 <AccessTimeIcon sx={{ fontSize: 60, color: "#e0e0e0", mb: 2 }} />
//                 <Typography variant="h6" sx={{ color: "#666", mb: 1 }}>
//                   {t.noShifts}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#999", mb: 3 }}>
//                   {t.addNewShift} {t.toGetStarted}
//                 </Typography>
//                 <Button
//                   variant="contained"
//                   onClick={() => setOpenAddScheduleDialog(true)}
//                   startIcon={<AddIcon />}
//                 >
//                   {t.addNewShift}
//                 </Button>
//               </Box>
//             ) : (
//               <Grid container spacing={2}>
//                 {shifts.map((shift) => (
//                   <Grid item xs={12} sm={6} md={4} key={shift.shift_code}>
//                     <Card>
//                       <CardContent>
//                         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//                           <Box>
//                             <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79" }}>
//                               {shift.shift_name}
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: "#546e7a", mb: 1 }}>
//                               {t.shiftCode}: {shift.shift_code}
//                             </Typography>
//                             <Typography variant="body1" sx={{ color: "#154c79", fontWeight: "bold" }}>
//                               <AccessTimeIcon sx={{ fontSize: 16, verticalAlign: "middle", mr: 0.5 }} />
//                               {shift.StartTime} - {shift.EndTime}
//                             </Typography>
//                           </Box>
//                           <Chip
//                             label={shift.status === "A" ? t.active : t.inactive}
//                             color={shift.status === "A" ? "success" : "default"}
//                             size="small"
//                           />
//                         </Box>
//                         {shift.Duration && (
//                           <Typography variant="caption" sx={{ color: "#9e9e9e", display: "block", mt: 1 }}>
//                             {t.duration}: {shift.Duration}
//                           </Typography>
//                         )}
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             )}
//           </Box>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <PageContainer>
//         {/* Export Progress Backdrop */}
//         <ProgressBackdrop open={exporting}>
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               gap: 2,
//               p: 4,
//               bgcolor: "background.paper",
//               borderRadius: 2,
//               boxShadow: 24,
//               maxWidth: 400,
//               width: "100%",
//             }}
//           >
//             <CircularProgress size={60} thickness={4} sx={{ color: "#154c79" }} />
//             <Typography variant="h6" color="primary" fontWeight="bold">
//               {exporting ? t.exporting : t.preparingReport}
//             </Typography>
//             <Box sx={{ width: "100%", mt: 2 }}>
//               <LinearProgress
//                 variant="determinate"
//                 value={exportProgress}
//                 sx={{
//                   height: 10,
//                   borderRadius: 5,
//                   backgroundColor: "#e0e0e0",
//                   "& .MuiLinearProgress-bar": {
//                     backgroundColor: tabValue === 1 ? "#2e7d32" : "#154c79",
//                   },
//                 }}
//               />
//               <Typography variant="body2" color="text.secondary" align="center" mt={1}>
//                 {exportProgress}%
//               </Typography>
//             </Box>
//           </Box>
//         </ProgressBackdrop>

//         {/* Success/Error Snackbar */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={4000}
//           onClose={closeSnackbar}
//           anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//         >
//           <AlertComponent onClose={closeSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
//             {snackbar.message}
//           </AlertComponent>
//         </Snackbar>

//         {/* Header */}
//         <StickyHeader>
//           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//             <Box>
//               <Typography
//                 sx={{
//                   fontSize: "20px",
//                   fontWeight: 700,
//                   color: "#154c79",
//                   lineHeight: 1.2,
//                 }}
//               >
//                 {t.title}
//               </Typography>
//               <Typography
//                 sx={{
//                   fontSize: "14px",
//                   color: "#546e7a",
//                   fontWeight: 400,
//                 }}
//               >
//                 {t.subtitle}
//               </Typography>
//             </Box>

//             {/* Language Selector */}
//             <Tooltip title={t.language}>
//               <IconButton
//                 onClick={handleLanguageMenuOpen}
//                 sx={{
//                   backgroundColor: language === "si" ? "#154c79" : "#f0f0f0",
//                   color: language === "si" ? "white" : "#154c79",
//                   "&:hover": {
//                     backgroundColor: language === "si" ? "#0D47A1" : "#e0e0e0",
//                   },
//                   width: "40px",
//                   height: "40px",
//                 }}
//               >
//                 {language === "si" ? (
//                   <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>සිං</Typography>
//                 ) : (
//                   <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>EN</Typography>
//                 )}
//               </IconButton>
//             </Tooltip>

//             <Menu
//               anchorEl={anchorEl}
//               open={Boolean(anchorEl)}
//               onClose={handleLanguageMenuClose}
//               PaperProps={{
//                 sx: {
//                   mt: 1,
//                   minWidth: 120,
//                   borderRadius: "8px",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 },
//               }}
//             >
//               <MenuItem
//                 onClick={() => handleLanguageChange("en")}
//                 selected={language === "en"}
//                 sx={{
//                   backgroundColor: language === "en" ? "rgba(21, 76, 121, 0.08)" : "transparent",
//                   "&:hover": {
//                     backgroundColor: "rgba(21, 76, 121, 0.12)",
//                   },
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <LanguageIcon sx={{ fontSize: 18, color: "#154c79" }} />
//                   <Typography sx={{ fontWeight: language === "en" ? 600 : 400 }}>English</Typography>
//                 </Box>
//               </MenuItem>
//               <MenuItem
//                 onClick={() => handleLanguageChange("si")}
//                 selected={language === "si"}
//                 sx={{
//                   backgroundColor: language === "si" ? "rgba(21, 76, 121, 0.08)" : "transparent",
//                   "&:hover": {
//                     backgroundColor: "rgba(21, 76, 121, 0.12)",
//                   },
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <TranslateIcon sx={{ fontSize: 18, color: "#154c79" }} />
//                   <Typography sx={{ fontWeight: language === "si" ? 600 : 400 }}>සිංහල</Typography>
//                 </Box>
//               </MenuItem>
//             </Menu>
//           </Box>

//           {/* Tabs */}
//           <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//             <Box sx={{ display: "flex", gap: 1 }}>
//               <Button
//                 variant={tabValue === 0 ? "contained" : "outlined"}
//                 onClick={() => setTabValue(0)}
//                 startIcon={<AddIcon />}
//                 sx={{
//                   flex: 1,
//                   borderRadius: "8px",
//                   textTransform: "none",
//                   fontWeight: "bold",
//                   backgroundColor: tabValue === 0 ? "#154c79" : "transparent",
//                   color: tabValue === 0 ? "#fff" : "#154c79",
//                   borderColor: "#154c79",
//                   "&:hover": {
//                     backgroundColor: tabValue === 0 ? "#0D47A1" : "rgba(21, 76, 121, 0.08)",
//                   },
//                 }}
//               >
//                 {t.createRoster}
//               </Button>
//               <Button
//                 variant={tabValue === 1 ? "contained" : "outlined"}
//                 onClick={() => setTabValue(1)}
//                 startIcon={<VisibilityIcon />}
//                 sx={{
//                   flex: 1,
//                   borderRadius: "8px",
//                   textTransform: "none",
//                   fontWeight: "bold",
//                   backgroundColor: tabValue === 1 ? "#154c79" : "transparent",
//                   color: tabValue === 1 ? "#fff" : "#154c79",
//                   borderColor: "#154c79",
//                   "&:hover": {
//                     backgroundColor: tabValue === 1 ? "#0D47A1" : "rgba(21, 76, 121, 0.08)",
//                   },
//                 }}
//               >
//                 {t.viewAssignments}
//               </Button>
//               <Button
//                 variant={tabValue === 2 ? "contained" : "outlined"}
//                 onClick={() => setTabValue(2)}
//                 startIcon={<ScheduleIcon />}
//                 sx={{
//                   flex: 1,
//                   borderRadius: "8px",
//                   textTransform: "none",
//                   fontWeight: "bold",
//                   backgroundColor: tabValue === 2 ? "#154c79" : "transparent",
//                   color: tabValue === 2 ? "#fff" : "#154c79",
//                   borderColor: "#154c79",
//                   "&:hover": {
//                     backgroundColor: tabValue === 2 ? "#0D47A1" : "rgba(21, 76, 121, 0.08)",
//                   },
//                 }}
//               >
//                 {t.manageShifts}
//               </Button>
//             </Box>
//           </Box>
//         </StickyHeader>

//         <ScrollableContent>{renderTabContent()}</ScrollableContent>

//         {/* Add Schedule Dialog */}
//         <Dialog
//           open={openAddScheduleDialog}
//           onClose={() => setOpenAddScheduleDialog(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>
//             <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79" }}>
//               {t.addNewShift}
//             </Typography>
//           </DialogTitle>
//           <DialogContent>
//             <Box sx={{ pt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
//               <TextField
//                 fullWidth
//                 label={t.shiftCode}
//                 required
//                 size="small"
//               />
//               <TextField
//                 fullWidth
//                 label={t.shiftName}
//                 required
//                 size="small"
//               />
//               <Box sx={{ display: "flex", gap: 2 }}>
//                 <TextField
//                   fullWidth
//                   label={t.startTime}
//                   type="time"
//                   InputLabelProps={{ shrink: true }}
//                   required
//                   size="small"
//                 />
//                 <TextField
//                   fullWidth
//                   label={t.endTime}
//                   type="time"
//                   InputLabelProps={{ shrink: true }}
//                   required
//                   size="small"
//                 />
//               </Box>
//             </Box>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpenAddScheduleDialog(false)}>{t.cancel}</Button>
//             <Button
//               onClick={handleAddSchedule}
//               variant="contained"
//               disabled={postingSchedule}
//               startIcon={postingSchedule ? <CircularProgress size={20} /> : <AddIcon />}
//             >
//               {postingSchedule ? t.adding : t.addShift}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Filter Dialog */}
//         <Dialog
//           open={openFilterDialog}
//           onClose={() => setOpenFilterDialog(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>
//             <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79" }}>
//               {t.filter}
//             </Typography>
//           </DialogTitle>
//           <DialogContent>
//             <Box sx={{ pt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>{t.location}</InputLabel>
//                 <Select
//                   value={filters.location}
//                   onChange={(e) => setFilters({ ...filters, location: e.target.value })}
//                   label={t.location}
//                 >
//                   <MenuItem value="">{t.allLocations}</MenuItem>
//                   {locations.map((location) => (
//                     <MenuItem key={location.loc_code} value={location.loc_code}>
//                       {location.loc_name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               <TextField
//                 fullWidth
//                 label={t.employeeNo}
//                 value={filters.employeeNo}
//                 onChange={(e) => setFilters({ ...filters, employeeNo: e.target.value })}
//                 size="small"
//               />

//               <FormControl fullWidth size="small">
//                 <InputLabel>{t.shift}</InputLabel>
//                 <Select
//                   value={filters.shiftCode}
//                   onChange={(e) => setFilters({ ...filters, shiftCode: e.target.value })}
//                   label={t.shift}
//                 >
//                   <MenuItem value="">{t.allShifts}</MenuItem>
//                   {shifts.map((shift) => (
//                     <MenuItem key={shift.shift_code} value={shift.shift_code}>
//                       {shift.shift_name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               <DatePicker
//                 label={t.workDate}
//                 value={filters.workDate}
//                 onChange={(date) => setFilters({ ...filters, workDate: date })}
//                 slotProps={{
//                   textField: {
//                     fullWidth: true,
//                     size: "small",
//                   },
//                 }}
//               />
//             </Box>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleResetFilters}>{t.clear}</Button>
//             <Button onClick={() => setOpenFilterDialog(false)}>{t.cancel}</Button>
//             <Button onClick={handleApplyFilters} variant="contained">
//               {t.applyFilters}
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </PageContainer>
//     </LocalizationProvider>
//   );
// };

// export default RosterManagement;








// import React, { useState, useEffect, useMemo } from "react";
// import { styled } from "@mui/material/styles";
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   CircularProgress,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Snackbar,
//   Alert,
//   LinearProgress,
//   Backdrop,
//   IconButton,
//   Tooltip,
//   Chip,
//   Avatar,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   InputAdornment,
//   Pagination,
//   Stepper,
//   Step,
//   StepLabel,
//   Divider,
//   Menu,
// } from "@mui/material";
// import {
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Add as AddIcon,
//   Close as CloseIcon,
//   Visibility as VisibilityIcon,
//   CalendarToday as CalendarTodayIcon,
//   Schedule as ScheduleIcon,
//   LocationOn as LocationOnIcon,
//   People as PeopleIcon,
//   Assignment as AssignmentIcon,
//   FilterList as FilterListIcon,
//   Refresh as RefreshIcon,
//   Search as SearchIcon,
//   Clear as ClearIcon,
//   PictureAsPdf as PictureAsPdfIcon,
//   ArrowBack as ArrowBackIcon,
//   PictureAsPdf as PDFIcon,
//   Translate as TranslateIcon,
//   Language as LanguageIcon,
//   Download as DownloadIcon,
//   Upload as UploadIcon,
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   AccessTime as AccessTimeIcon,
//   Work as WorkIcon,
//   Person as PersonIcon,
//   MoreVert as MoreVertIcon,
//   ArrowForward as ArrowForwardIcon,
//   Error as ErrorIcon,
//   Warning as WarningIcon,
// } from "@mui/icons-material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { useTheme, useMediaQuery } from "@mui/material";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchLocations,
//   fetchEmployeesByLocation,
//   fetchShifts,
//   postRoster,
//   postSchedule,
//   fetchRosterDetails,
//   fetchAllRosterDetails,
//   setSelectedDates,
//   setSelectedShifts,
//   setSelectedLocation,
//   clearSelectedEmployees,
//   testAPIConnectivity,
// } from "../actions/RosterActions";

// // MUI Alert component for Snackbar - properly forwarding refs
// const AlertComponent = React.forwardRef(function AlertComponent(props, ref) {
//   return <Alert elevation={6} ref={ref} variant="filled" {...props} />;
// });

// // ------------ Translation Texts ------------
// const translations = {
//   en: {
//     title: "Roster Management System",
//     subtitle: "Create and manage employee duty rosters",
//     createRoster: "Create Roster",
//     viewAssignments: "View Assignments",
//     manageShifts: "Manage Shifts",
//     selectDates: "Select Dates",
//     selectShifts: "Select Shifts",
//     selectLocation: "Select Location",
//     selectEmployees: "Select Employees",
//     reviewAssign: "Review & Assign",
//     step1Desc: "Choose dates for the roster",
//     step2Desc: "Choose time shifts",
//     step3Desc: "Select work location",
//     step4Desc: "Select employees to assign",
//     step5Desc: "Review and confirm assignment",
//     datePicker: "Select Date",
//     location: "Location",
//     allLocations: "All Locations",
//     shift: "Shift",
//     allShifts: "All Shifts",
//     employee: "Employee",
//     serviceNo: "Service No",
//     searchEmployees: "Search employees...",
//     selectAll: "Select All",
//     deselectAll: "Deselect All",
//     selected: "Selected",
//     employees: "Employees",
//     dates: "Dates",
//     shifts: "Shifts",
//     assignRoster: "Assign Roster",
//     assigning: "Assigning...",
//     rosterAssigned: "Roster assigned successfully!",
//     assignmentFailed: "Failed to assign roster",
//     startOver: "Start Over",
//     back: "Back",
//     next: "Next",
//     addNewShift: "Add New Shift",
//     shiftCode: "Shift Code",
//     shiftName: "Shift Name",
//     startTime: "Start Time",
//     endTime: "End Time",
//     addShift: "Add Shift",
//     adding: "Adding...",
//     shiftAdded: "Shift added successfully!",
//     shiftFailed: "Failed to add shift",
//     filter: "Filter",
//     clear: "Clear",
//     applyFilters: "Apply Filters",
//     noData: "No data available",
//     noAssignments: "No roster assignments found",
//     loading: "Loading...",
//     loadingLocations: "Loading locations...",
//     loadingShifts: "Loading shifts...",
//     loadingEmployees: "Loading employees...",
//     exportPdf: "Export PDF",
//     exporting: "Exporting...",
//     pdfSuccess: "PDF exported successfully!",
//     pdfError: "Failed to export PDF",
//     reportTitle: "Roster Assignments Report",
//     reportDate: "Report Date",
//     page: "Page",
//     of: "of",
//     generatedOn: "Generated on",
//     language: "Language",
//     totalAssignments: "Total Assignments",
//     filterByDate: "Filter by Date",
//     filterByLocation: "Filter by Location",
//     filterByEmployee: "Filter by Employee",
//     filterByShift: "Filter by Shift",
//     totalStrength: "Total Employees",
//     attendance: "Present",
//     absent: "Absent",
//     employeeName: "Employee Name",
//     position: "Position",
//     department: "Department",
//     workDate: "Work Date",
//     time: "Time",
//     status: "Status",
//     active: "Active",
//     inactive: "Inactive",
//     refresh: "Refresh",
//     noShifts: "No shifts available",
//     createFirstRoster: "Create your first roster assignment",
//     welcomeMessage: "Welcome to Roster Management",
//     summary: "Summary",
//     details: "Details",
//     calendar: "Calendar",
//     list: "List",
//     week: "Week",
//     month: "Month",
//     today: "Today",
//     previous: "Previous",
//     nextMonth: "Next",
//     sun: "Sun",
//     mon: "Mon",
//     tue: "Tue",
//     wed: "Wed",
//     thu: "Thu",
//     fri: "Fri",
//     sat: "Sat",
//     actions: "Actions",
//     edit: "Edit",
//     delete: "Delete",
//     save: "Save",
//     cancel: "Cancel",
//     confirm: "Confirm",
//     areYouSure: "Are you sure?",
//     thisActionCannotBeUndone: "This action cannot be undone.",
//     yes: "Yes",
//     no: "No",
//     success: "Success",
//     error: "Error",
//     info: "Information",
//     warning: "Warning",
//     debug: "Debug",
//     testAPI: "Test API",
//     apiTestSuccess: "API connectivity test successful!",
//     apiTestFailed: "API connectivity test failed",
//     noLocationsFound: "No locations found. Please check API connection.",
//     retry: "Retry",
//   },
//   si: {
//     title: "රෝස්ටර් කළමනාකරණ පද්ධතිය",
//     subtitle: "සේවක රෝස්ටර් නිර්මාණය සහ කළමනාකරණය",
//     createRoster: "රෝස්ටර් සාදන්න",
//     viewAssignments: "නියමයන් බලන්න",
//     manageShifts: "පැය කළමනාකරණය",
//     selectDates: "දින තෝරන්න",
//     selectShifts: "පැය තෝරන්න",
//     selectLocation: "ස්ථානය තෝරන්න",
//     selectEmployees: "සේවකයන් තෝරන්න",
//     reviewAssign: "සමාලෝචනය සහ නියම කරන්න",
//     step1Desc: "රෝස්ටර් සඳහා දින තෝරන්න",
//     step2Desc: "කාල පැය තෝරන්න",
//     step3Desc: "වැඩ ස්ථානය තෝරන්න",
//     step4Desc: "නියම කිරීම සඳහා සේවකයන් තෝරන්න",
//     step5Desc: "සමාලෝචනය කර තහවුරු කරන්න",
//     datePicker: "දිනය තෝරන්න",
//     location: "ස්ථානය",
//     allLocations: "සියලු ස්ථාන",
//     shift: "පැය",
//     allShifts: "සියලු පැය",
//     employee: "සේවකයා",
//     serviceNo: "සේවා අංකය",
//     searchEmployees: "සේවකයන් සොයන්න...",
//     selectAll: "සියල්ල තෝරන්න",
//     deselectAll: "සියල්ල ඉවත් කරන්න",
//     selected: "තෝරාගත්",
//     employees: "සේවකයන්",
//     dates: "දින",
//     shifts: "පැය",
//     assignRoster: "රෝස්ටර් නියම කරන්න",
//     assigning: "නියම කරමින්...",
//     rosterAssigned: "රෝස්ටර් සාර්ථකව නියම කරන ලදී!",
//     assignmentFailed: "රෝස්ටර් නියම කිරීම අසාර්ථක විය",
//     startOver: "යලි ආරම්භ කරන්න",
//     back: "ආපසු",
//     next: "ඊළඟ",
//     addNewShift: "නව පැයක් එකතු කරන්න",
//     shiftCode: "පැය කේතය",
//     shiftName: "පැය නම",
//     startTime: "ආරම්භක වේලාව",
//     endTime: "අවසන් වේලාව",
//     addShift: "පැය එකතු කරන්න",
//     adding: "එකතු කරමින්...",
//     shiftAdded: "පැය සාර්ථකව එකතු කරන ලදී!",
//     shiftFailed: "පැය එකතු කිරීම අසාර්ථක විය",
//     filter: "පෙරහන",
//     clear: "මකන්න",
//     applyFilters: "පෙරහන යොදන්න",
//     noData: "දත්ත නොමැත",
//     noAssignments: "රෝස්ටර් නියමයන් නොමැත",
//     loading: "පූරණය වෙමින්...",
//     loadingLocations: "ස්ථාන පූරණය වෙමින්...",
//     loadingShifts: "පැය පූරණය වෙමින්...",
//     loadingEmployees: "සේවකයන් පූරණය වෙමින්...",
//     exportPdf: "PDF බාගත කරන්න",
//     exporting: "PDF බාගත කරමින්...",
//     pdfSuccess: "PDF සාර්ථකව බාගත කරන ලදී!",
//     pdfError: "PDF බාගත කිරීම අසාර්ථක විය",
//     reportTitle: "රෝස්ටර් නියමයන් වාර්තාව",
//     reportDate: "වාර්තා දිනය",
//     page: "පිටුව",
//     of: "යි",
//     generatedOn: "සෑදූ දිනය",
//     language: "භාෂාව",
//     totalAssignments: "මුළු නියමයන්",
//     filterByDate: "දිනය අනුව පෙරහන්",
//     filterByLocation: "ස්ථානය අනුව පෙරහන්",
//     filterByEmployee: "සේවකයා අනුව පෙරහන්",
//     filterByShift: "පැය අනුව පෙරහන්",
//     totalStrength: "මුළු සේවකයන්",
//     attendance: "පැමිණි",
//     absent: "පැමිණ නැත",
//     employeeName: "සේවකයාගේ නම",
//     position: "තනතුර",
//     department: "විධානය",
//     workDate: "වැඩ දිනය",
//     time: "වේලාව",
//     status: "තත්ත්වය",
//     active: "සක්‍රිය",
//     inactive: "අක්‍රිය",
//     refresh: "නැවත පූරණය කරන්න",
//     noShifts: "පැය නොමැත",
//     createFirstRoster: "ඔබගේ පළමු රෝස්ටර් නියමය සාදන්න",
//     welcomeMessage: "රෝස්ටර් කළමනාකරණයට සාදරයෙන් පිළිගනිමු",
//     summary: "සාරාංශය",
//     details: "විස්තර",
//     calendar: "දින දර්ශනය",
//     list: "ලැයිස්තුව",
//     week: "සතිය",
//     month: "මාසය",
//     today: "අද",
//     previous: "පෙර",
//     nextMonth: "ඊළඟ",
//     sun: "ඉරි",
//     mon: "සඳු",
//     tue: "අඟ",
//     wed: "බදා",
//     thu: "බ්‍රහ",
//     fri: "සිකු",
//     sat: "සෙන",
//     actions: "ක්‍රියා",
//     edit: "සංස්කරණය",
//     delete: "මකන්න",
//     save: "සුරකින්න",
//     cancel: "අවලංගු කරන්න",
//     confirm: "තහවුරු කරන්න",
//     areYouSure: "ඔබට විශ්වාසද?",
//     thisActionCannotBeUndone: "මෙම ක්‍රියාව අහෝසි කළ නොහැක.",
//     yes: "ඔව්",
//     no: "නැත",
//     success: "සාර්ථකයි",
//     error: "දෝෂය",
//     info: "තොරතුරු",
//     warning: "අවවාදය",
//     debug: "දෝෂ නිරාකරණය",
//     testAPI: "API පරීක්ෂා කරන්න",
//     apiTestSuccess: "API සම්බන්ධතා පරීක්ෂාව සාර්ථකයි!",
//     apiTestFailed: "API සම්බන්ධතා පරීක්ෂාව අසාර්ථක විය",
//     noLocationsFound: "ස්ථාන හමු නොවීය. API සම්බන්ධතාව පරීක්ෂා කරන්න.",
//     retry: "නැවත උත්සාහ කරන්න",
//   },
// };

// // ------------ Styles matching your interface ------------
// const PageContainer = styled(Box)(({ theme }) => ({
//   maxWidth: "1200px",
//   margin: "0 auto",
//   padding: "12px 16px",
//   fontFamily: "'Poppins', sans-serif",
//   backgroundColor: "#f8fafc",
//   minHeight: "calc(100vh - 120px)",
//   [theme.breakpoints.down("sm")]: {
//     padding: "8px 12px",
//   },
// }));

// const StickyHeader = styled(Box)(({ theme }) => ({
//   position: "sticky",
//   top: 0,
//   backgroundColor: "#ffffff",
//   zIndex: 100,
//   padding: "12px 0",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
//   borderRadius: "8px",
//   marginBottom: "12px",
//   [theme.breakpoints.down("sm")]: {
//     padding: "8px 0",
//   },
// }));

// const ScrollableContent = styled(Box)(({ theme }) => ({
//   [theme.breakpoints.down("sm")]: {
//     maxHeight: "calc(100vh - 280px)",
//     overflowY: "auto",
//   },
// }));

// const EmployeeCard = styled(Card)(({ theme }) => ({
//   padding: "12px 16px",
//   borderRadius: "12px",
//   marginBottom: "10px",
//   boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.08)",
//   backgroundColor: "#fff",
//   border: "1px solid #e0e0e0",
//   transition: "all 0.2s ease",
//   cursor: "pointer",
//   "&:hover": {
//     backgroundColor: "rgba(21, 76, 121, 0.04)",
//     transform: "translateY(-2px)",
//     boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
//     borderColor: "#154c79",
//   },
//   [theme.breakpoints.down("sm")]: {
//     padding: "10px 12px",
//   },
// }));

// const CalendarDay = styled(Paper)(({ theme, selected, today }) => ({
//   aspectRatio: "1",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   cursor: "pointer",
//   borderRadius: "8px",
//   backgroundColor: selected ? "#154c79" : today ? "#e8f0fa" : "#ffffff",
//   color: selected ? "#ffffff" : today ? "#154c79" : "#424242",
//   fontWeight: selected || today ? "bold" : "normal",
//   border: today ? "2px solid #154c79" : "1px solid #e0e0e0",
//   transition: "all 0.2s ease",
//   fontSize: "0.9rem",
//   "&:hover": {
//     backgroundColor: selected ? "#0D47A1" : "#f5f5f5",
//     transform: "scale(1.05)",
//   },
// }));

// const ShiftCard = styled(Card)(({ theme, selected }) => ({
//   cursor: "pointer",
//   border: selected ? "2px solid #154c79" : "1px solid #e0e0e0",
//   backgroundColor: selected ? "rgba(21, 76, 121, 0.08)" : "#ffffff",
//   transition: "all 0.2s ease",
//   borderRadius: "10px",
//   "&:hover": {
//     borderColor: "#154c79",
//     transform: "translateY(-3px)",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//   },
// }));

// const LocationCard = styled(Card)(({ theme, selected }) => ({
//   cursor: "pointer",
//   border: selected ? "2px solid #154c79" : "1px solid #e0e0e0",
//   backgroundColor: selected ? "rgba(21, 76, 121, 0.08)" : "#ffffff",
//   transition: "all 0.2s ease",
//   borderRadius: "10px",
//   "&:hover": {
//     borderColor: "#154c79",
//     transform: "translateY(-2px)",
//   },
// }));

// // Table Styles matching your interface
// const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
//   borderRadius: "12px",
//   boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
//   border: "1px solid #e0e0e0",
//   backgroundColor: "#ffffff",
//   overflow: "hidden",
//   "& .MuiTable-root": {
//     borderCollapse: "separate",
//     borderSpacing: 0,
//   },
//   "&::-webkit-scrollbar": {
//     width: "6px",
//     height: "6px",
//   },
//   "&::-webkit-scrollbar-thumb": {
//     backgroundColor: "#888",
//     borderRadius: "3px",
//   },
//   "&::-webkit-scrollbar-thumb:hover": {
//     backgroundColor: "#555",
//   },
//   [theme.breakpoints.up("sm")]: {
//     maxHeight: "500px",
//     overflowY: "auto",
//     overflowX: "auto",
//   },
//   [theme.breakpoints.down("sm")]: {
//     maxHeight: "400px",
//     overflowY: "auto",
//     overflowX: "auto",
//   },
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontFamily: "'Poppins', sans-serif",
//   padding: "10px 8px",
//   fontSize: "13px",
//   textAlign: "center",
//   "&.MuiTableCell-head": {
//     backgroundColor: "#154c79",
//     color: "#ffffff",
//     fontWeight: 600,
//     letterSpacing: "0.3px",
//     borderBottom: "none",
//     position: "sticky",
//     top: 0,
//     zIndex: 10,
//     "&:first-of-type": {
//       borderTopLeftRadius: "12px",
//     },
//     "&:last-of-type": {
//       borderTopRightRadius: "12px",
//     },
//   },
//   [theme.breakpoints.down("sm")]: {
//     padding: "8px 6px",
//     fontSize: "12px",
//     "&.MuiTableCell-head": {
//       fontSize: "13px",
//     },
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   transition: "all 0.15s ease",
//   "&:nth-of-type(odd)": {
//     backgroundColor: "rgba(243, 246, 250, 0.6)",
//   },
//   "&:hover": {
//     backgroundColor: "rgba(21, 76, 121, 0.06)",
//     cursor: "pointer",
//   },
//   "&:last-of-type td:first-of-type": {
//     borderBottomLeftRadius: "12px",
//   },
//   "&:last-of-type td:last-of-type": {
//     borderBottomRightRadius: "12px",
//   },
// }));

// const ProgressBackdrop = styled(Backdrop)(({ theme }) => ({
//   color: "#fff",
//   zIndex: theme.zIndex.drawer + 1,
//   backgroundColor: "rgba(0, 0, 0, 0.7)",
// }));

// const RosterManagement = () => {
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   // Redux state
//   const {
//     locations = [],
//     loadingLocations,
//     employeesByLocation = {},
//     loadingEmployees,
//     shifts = [],
//     loadingShifts,
//     postingRoster,
//     postRosterSuccess,
//     postRosterError,
//     postingSchedule,
//     postScheduleSuccess,
//     postScheduleError,
//     rosterDetails = [],
//     loadingRosterDetails,
//     allRosterDetails = [],
//     loadingAllRosterDetails,
//     selectedDates: reduxSelectedDates = [],
//     selectedShifts: reduxSelectedShifts = [],
//     selectedLocation: reduxSelectedLocation,
//   } = useSelector((state) => state.roster || {});

//   // State variables
//   const [activeStep, setActiveStep] = useState(0);
//   const [currentDate, setCurrentDate] = useState(new Date());
//   const [selectedDates, setSelectedDatesState] = useState([]);
//   const [selectedShifts, setSelectedShiftsState] = useState([]);
//   const [selectedLocation, setSelectedLocationState] = useState(null);
//   const [selectedEmployees, setSelectedEmployees] = useState([]);
//   const [filteredEmployees, setFilteredEmployees] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [tabValue, setTabValue] = useState(0);
//   const [page, setPage] = useState(1);
//   const [language, setLanguage] = useState("en");
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [openAddScheduleDialog, setOpenAddScheduleDialog] = useState(false);
//   const [openFilterDialog, setOpenFilterDialog] = useState(false);
//   const [newSchedule, setNewSchedule] = useState({
//     shift_code: "",
//     shift_name: "",
//     StartTime: "09:00",
//     EndTime: "17:00",
//     status: "A",
//   });
//   const [filters, setFilters] = useState({
//     location: "",
//     employeeNo: "",
//     shiftCode: "",
//     workDate: null,
//   });
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const [exporting, setExporting] = useState(false);
//   const [exportProgress, setExportProgress] = useState(0);
//   const [debugMode, setDebugMode] = useState(false);

//   const rowsPerPage = 10;
//   const t = translations[language];

//   // Helper functions
//   const formatDate = (dateObj) => {
//     if (!dateObj) return "";
//     const d = new Date(dateObj);
//     if (isNaN(d.getTime())) return "";
//     return d.toISOString().split("T")[0];
//   };

//   const formatDateDisplay = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return dateString;
//     return date.toLocaleDateString("en-US", {
//       weekday: "short",
//       month: "short",
//       day: "numeric",
//       year: "numeric",
//     });
//   };

//   const getMonthName = () => {
//     return currentDate.toLocaleDateString(language === "si" ? "si-LK" : "en-US", {
//       month: "long",
//       year: "numeric",
//     });
//   };

//   // Load initial data
//   useEffect(() => {
//     console.log("Initializing RosterManagement component...");
//     console.log("Fetching locations, shifts, roster details...");
    
//     dispatch(fetchLocations());
//     dispatch(fetchShifts());
//     dispatch(fetchRosterDetails());
//     dispatch(fetchAllRosterDetails({}));
//   }, [dispatch]);

//   // Debug effect to log state changes
//   useEffect(() => {
//     if (debugMode) {
//       console.log("=== DEBUG MODE ===");
//       console.log("Locations:", locations);
//       console.log("Loading locations:", loadingLocations);
//       console.log("Shifts:", shifts);
//       console.log("Loading shifts:", loadingShifts);
//       console.log("Employees by location:", employeesByLocation);
//       console.log("Selected location:", selectedLocation);
//       console.log("Selected dates:", selectedDates);
//       console.log("Selected shifts:", selectedShifts);
//       console.log("Selected employees:", selectedEmployees);
//       console.log("All roster details:", allRosterDetails);
//       console.log("===================");
//     }
//   }, [
//     debugMode,
//     locations,
//     loadingLocations,
//     shifts,
//     loadingShifts,
//     employeesByLocation,
//     selectedLocation,
//     selectedDates,
//     selectedShifts,
//     selectedEmployees,
//     allRosterDetails,
//   ]);

//   // Sync with Redux state
//   useEffect(() => {
//     if (reduxSelectedDates) setSelectedDatesState(reduxSelectedDates);
//     if (reduxSelectedShifts) setSelectedShiftsState(reduxSelectedShifts);
//     if (reduxSelectedLocation) setSelectedLocationState(reduxSelectedLocation);
//   }, [reduxSelectedDates, reduxSelectedShifts, reduxSelectedLocation]);

//   // Filter employees based on search
//   useEffect(() => {
//     if (selectedLocation && employeesByLocation[selectedLocation]) {
//       const employees = employeesByLocation[selectedLocation];
//       if (searchTerm) {
//         const filtered = employees.filter(
//           (emp) =>
//             (emp.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             emp.service_no?.includes(searchTerm))
//         );
//         setFilteredEmployees(filtered);
//       } else {
//         setFilteredEmployees(employees);
//       }
//     } else {
//       setFilteredEmployees([]);
//     }
//   }, [searchTerm, selectedLocation, employeesByLocation]);

//   // Event handlers
//   const handleDateSelection = (date) => {
//     if (!date) return;
//     const dateStr = formatDate(date);
//     if (!dateStr) return;
    
//     const newDates = selectedDates.includes(dateStr)
//       ? selectedDates.filter((d) => d !== dateStr)
//       : [...selectedDates, dateStr];

//     setSelectedDatesState(newDates);
//     dispatch(setSelectedDates(newDates));
//   };

//   const handleShiftSelection = (shift) => {
//     if (!shift) return;
//     const newShifts = selectedShifts.includes(shift)
//       ? selectedShifts.filter((s) => s !== shift)
//       : [...selectedShifts, shift];

//     setSelectedShiftsState(newShifts);
//     dispatch(setSelectedShifts(newShifts));
//   };

//   const handleLocationChange = (locationCode) => {
//     if (!locationCode) return;
//     setSelectedLocationState(locationCode);
//     dispatch(setSelectedLocation(locationCode));
//     dispatch(fetchEmployeesByLocation(locationCode));
//     setSelectedEmployees([]);
//     setSearchTerm("");
//   };

//   const handleEmployeeSelection = (employee) => {
//     if (!employee || !employee.service_no) return;
    
//     const isSelected = selectedEmployees.some(
//       (emp) => emp.service_no === employee.service_no
//     );

//     if (isSelected) {
//       setSelectedEmployees(
//         selectedEmployees.filter((emp) => emp.service_no !== employee.service_no)
//       );
//     } else {
//       setSelectedEmployees([...selectedEmployees, employee]);
//     }
//   };

//   const handleSelectAllEmployees = () => {
//     if (selectedEmployees.length === filteredEmployees.length) {
//       setSelectedEmployees([]);
//     } else {
//       setSelectedEmployees([...filteredEmployees]);
//     }
//   };

//   // const handleAssignRoster = async () => {
//   //   if (selectedDates.length === 0 || selectedShifts.length === 0 || selectedEmployees.length === 0) {
//   //     showSnackbar("Please select dates, shifts, and employees", "error");
//   //     return;
//   //   }

//   //   const rosterData = [];
//   //   selectedEmployees.forEach((employee) => {
//   //     selectedDates.forEach((date) => {
//   //       selectedShifts.forEach((shift) => {
//   //         rosterData.push({
//   //           service_no: employee.service_no,
//   //           WorkDate: date,
//   //           shift_code: shift.shift_code,
//   //         });
//   //       });
//   //     });
//   //   });

//   //   console.log("Assigning roster data:", rosterData);

//   //   try {
//   //     const result = await dispatch(postRoster(rosterData));
//   //     if (result.success) {
//   //       showSnackbar(t.rosterAssigned, "success");
//   //       dispatch(fetchRosterDetails());
//   //       dispatch(fetchAllRosterDetails({}));
//   //       resetForm();
//   //     } else {
//   //       showSnackbar(result.error || t.assignmentFailed, "error");
//   //     }
//   //   } catch (error) {
//   //     console.error("Error in handleAssignRoster:", error);
//   //     showSnackbar(t.assignmentFailed, "error");
//   //   }
//   // };

//   const handleAssignRoster = async () => {
//     // ── VALIDATION ──
//     if (selectedDates.length === 0 || selectedShifts.length === 0 || selectedEmployees.length === 0) {
//       showSnackbar("Please select dates, shifts, and employees", "error");
//       return;
//     }

//     // ── PREVENT DOUBLE-CLICK ──
//     if (postingRoster) {
//       console.warn("Assignment already in progress, ignoring duplicate click");
//       return;
//     }

//     // ── CREATE PAYLOAD ──
//     const rosterData = [];
//     selectedEmployees.forEach((employee) => {
//       selectedDates.forEach((date) => {
//         selectedShifts.forEach((shift) => {
//           rosterData.push({
//             service_no: employee.service_no,
//             WorkDate: date,
//             shift_code: shift.shift_code,
//           });
//         });
//       });
//     });

//     console.log(`Preparing to assign ${rosterData.length} roster entries`);
//     console.log("Roster data:", JSON.stringify(rosterData));

//     try {
//       console.log("Calling postRoster API...");

//       // ── CALL ONLY POST API ──
//       const result = await dispatch(postRoster(rosterData));

//       console.log("API Response received:", result);

//       if (result?.success) {
//         // Show success message
//         showSnackbar(
//           `${t.rosterAssigned} (${rosterData.length} entries assigned)`,
//           "success"
//         );

//         console.log("Roster assignment successful!");

//         // ── SIMPLE RESET - Only local state, no Redux dispatches ──
//         setSelectedDatesState([]);
//         setSelectedShiftsState([]);
//         setSelectedEmployees([]);
//         setSearchTerm("");
//         setActiveStep(0);

//         // ── AUTO-REDIRECT TO VIEW ASSIGNMENTS ──
//         setTimeout(() => {
//           setTabValue(1);
//           console.log("Redirected to View Assignments tab");
//         }, 1500);
//       } else {
//         const errorMsg = result?.error || t.assignmentFailed;
//         console.error("Assignment failed:", errorMsg);
//         showSnackbar(errorMsg, "error");
//       }
//     } catch (error) {
//       console.error("Roster assignment error:", error);
//       const errorMessage = error?.message || t.assignmentFailed;
//       showSnackbar(errorMessage, "error");
//     }
//   };

//   const handleAddSchedule = async () => {
//     if (!newSchedule.shift_code || !newSchedule.shift_name) {
//       showSnackbar("Please enter shift code and name", "error");
//       return;
//     }

//     console.log("Adding new schedule:", newSchedule);

//     try {
//       const result = await dispatch(postSchedule([newSchedule]));
//       if (result.success) {
//         showSnackbar(t.shiftAdded, "success");
//         setNewSchedule({
//           shift_code: "",
//           shift_name: "",
//           StartTime: "09:00",
//           EndTime: "17:00",
//           status: "A",
//         });
//         setOpenAddScheduleDialog(false);
//       } else {
//         showSnackbar(result.error || t.shiftFailed, "error");
//       }
//     } catch (error) {
//       console.error("Error in handleAddSchedule:", error);
//       showSnackbar(t.shiftFailed, "error");
//     }
//   };

//   const handleApplyFilters = () => {
//     const filterParams = {
//       loc: filters.location || "",
//       sno: filters.employeeNo || "",
//       scode: filters.shiftCode || "",
//       wdate: filters.workDate ? formatDate(filters.workDate) : "",
//     };
    
//     console.log("Applying filters:", filterParams);
//     dispatch(fetchAllRosterDetails(filterParams));
//     setOpenFilterDialog(false);
//   };

//   const handleResetFilters = () => {
//     setFilters({
//       location: "",
//       employeeNo: "",
//       shiftCode: "",
//       workDate: null,
//     });
//     dispatch(fetchAllRosterDetails({}));
//   };

//   const resetForm = () => {
//     setSelectedDatesState([]);
//     setSelectedShiftsState([]);
//     setSelectedLocationState(null);
//     setSelectedEmployees([]);
//     setSearchTerm("");
//     setActiveStep(0);
//     dispatch(setSelectedDates([]));
//     dispatch(setSelectedShifts([]));
//     dispatch(setSelectedLocation(null));
//     dispatch(clearSelectedEmployees());
//   };

//   const showSnackbar = (message, severity = "success") => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const closeSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const handleTestAPIConnectivity = async () => {
//     try {
//       const result = await dispatch(testAPIConnectivity());
//       if (result.success) {
//         showSnackbar(t.apiTestSuccess, "success");
//         // Refresh all data
//         dispatch(fetchLocations());
//         dispatch(fetchShifts());
//         dispatch(fetchAllRosterDetails({}));
//       } else {
//         showSnackbar(result.error || t.apiTestFailed, "error");
//       }
//     } catch (error) {
//       showSnackbar(t.apiTestFailed, "error");
//     }
//   };

//   // Language menu handlers
//   const handleLanguageMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleLanguageMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLanguageChange = (lang) => {
//     setLanguage(lang);
//     handleLanguageMenuClose();
//   };

//   // Calendar rendering
//   const renderCalendar = () => {
//     const year = currentDate.getFullYear();
//     const month = currentDate.getMonth();
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     const firstDay = new Date(year, month, 1).getDay();

//     const days = [];

//     // Empty cells for first week
//     for (let i = 0; i < firstDay; i++) {
//       days.push(<Box key={`empty-${i}`} sx={{ aspectRatio: "1" }} />);
//     }

//     // Days of month
//     for (let day = 1; day <= daysInMonth; day++) {
//       const date = new Date(year, month, day);
//       const dateStr = formatDate(date);
//       const isSelected = selectedDates.includes(dateStr);
//       const isToday = dateStr === formatDate(new Date());

//       days.push(
//         <CalendarDay
//           key={day}
//           selected={isSelected}
//           today={isToday}
//           onClick={() => handleDateSelection(date)}
//         >
//           {day}
//         </CalendarDay>
//       );
//     }

//     return (
//       <Grid container spacing={1}>
//         {[
//           language === "si" ? ["ඉ", "ස", "අ", "බ", "බ්‍ර", "සි", "සෙ"] : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
//         ].flat().map((day) => (
//           <Grid item xs={12 / 7} key={day}>
//             <Typography
//               align="center"
//               sx={{
//                 fontWeight: "bold",
//                 color: "#154c79",
//                 fontSize: isMobile ? "11px" : "12px",
//                 mb: 0.5,
//               }}
//             >
//               {day}
//             </Typography>
//           </Grid>
//         ))}
//         {days.map((day, index) => (
//           <Grid item xs={12 / 7} key={`day-${index}`}>
//             {day}
//           </Grid>
//         ))}
//       </Grid>
//     );
//   };

//   // Steps content
//   const steps = [
//     {
//       label: t.selectDates,
//       description: t.step1Desc,
//       icon: <CalendarTodayIcon />,
//     },
//     {
//       label: t.selectShifts,
//       description: t.step2Desc,
//       icon: <ScheduleIcon />,
//     },
//     {
//       label: t.selectLocation,
//       description: t.step3Desc,
//       icon: <LocationOnIcon />,
//     },
//     {
//       label: t.selectEmployees,
//       description: t.step4Desc,
//       icon: <PeopleIcon />,
//     },
//     {
//       label: t.reviewAssign,
//       description: t.step5Desc,
//       icon: <AssignmentIcon />,
//     },
//   ];

//   // Calculate summary statistics
//   const totalAssignments = useMemo(() => {
//     return selectedDates.length * selectedShifts.length * selectedEmployees.length;
//   }, [selectedDates, selectedShifts, selectedEmployees]);

//   // Export PDF functions
//   const handleExportSummaryPDF = async () => {
//     if (exporting || allRosterDetails.length === 0) return;

//     try {
//       setExporting(true);
//       setExportProgress(10);

//       const doc = new jsPDF("p", "mm", "a4");
//       const pageWidth = doc.internal.pageSize.getWidth();

//       setExportProgress(30);

//       // Title
//       doc.setFontSize(20);
//       doc.setFont("helvetica", "bold");
//       doc.text(t.reportTitle, pageWidth / 2, 20, { align: "center" });

//       setExportProgress(50);

//       // Generate table
//       autoTable(doc, {
//         startY: 40,
//         head: [[t.workDate, t.employeeName, t.serviceNo, t.shift, t.location, t.time]],
//         body: allRosterDetails.slice(0, 100).map((item) => [
//           formatDateDisplay(item.WorkDate),
//           item.Name || "N/A",
//           item.service_no || "N/A",
//           item.shift_name || "N/A",
//           item.LocName || "N/A",
//           `${item.StartTime || ""} - ${item.EndTime || ""}`,
//         ]),
//         styles: {
//           fontSize: 9,
//           cellPadding: 4,
//         },
//         headStyles: {
//           fillColor: [21, 76, 121],
//           textColor: 255,
//           fontStyle: "bold",
//         },
//         alternateRowStyles: {
//           fillColor: [245, 248, 252],
//         },
//       });

//       setExportProgress(80);

//       // Footer
//       const pageCount = doc.internal.getNumberOfPages();
//       for (let i = 1; i <= pageCount; i++) {
//         doc.setPage(i);
//         doc.setFontSize(10);
//         doc.setTextColor(128, 128, 128);
//         doc.text(
//           `${t.page} ${i} ${t.of} ${pageCount}`,
//           pageWidth - 20,
//           doc.internal.pageSize.getHeight() - 10,
//           { align: "right" }
//         );
//         doc.text(
//           `${t.generatedOn} ${new Date().toLocaleDateString()}`,
//           20,
//           doc.internal.pageSize.getHeight() - 10
//         );
//       }

//       setExportProgress(100);

//       // Save PDF
//       const filename = language === "si"
//         ? `රෝස්ටර්_නියමයන්_වාර්තා_${formatDate(new Date())}.pdf`
//         : `Roster_Assignments_${formatDate(new Date())}.pdf`;

//       doc.save(filename);

//       showSnackbar(t.pdfSuccess, "success");

//       setTimeout(() => {
//         setExporting(false);
//         setExportProgress(0);
//       }, 1000);
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       showSnackbar(t.pdfError, "error");
//       setExporting(false);
//       setExportProgress(0);
//     }
//   };

//   // Tabs content
//   const renderTabContent = () => {
//     switch (tabValue) {
//       case 0: // Create Roster
//         return (
//           <Box sx={{ mt: 3 }}>
//             <Stepper activeStep={activeStep} orientation={isMobile ? "vertical" : "horizontal"} sx={{ mb: 4 }}>
//               {steps.map((step, index) => (
//                 <Step key={step.label}>
//                   <StepLabel
//                     StepIconComponent={() => (
//                       <Avatar
//                         sx={{
//                           bgcolor: activeStep >= index ? "#154c79" : "#e0e0e0",
//                           color: activeStep >= index ? "white" : "#616161",
//                           width: 32,
//                           height: 32,
//                         }}
//                       >
//                         {step.icon}
//                       </Avatar>
//                     )}
//                   >
//                     <Typography variant="body2" sx={{ fontWeight: "bold", color: "#154c79" }}>
//                       {step.label}
//                     </Typography>
//                     {!isMobile && (
//                       <Typography variant="caption" sx={{ color: "#757575" }}>
//                         {step.description}
//                       </Typography>
//                     )}
//                   </StepLabel>
//                 </Step>
//               ))}
//             </Stepper>

//             {/* Step Content */}
//             <Box sx={{ mt: 4 }}>
//               {activeStep === 0 && (
//                 <Card>
//                   <CardContent>
//                     <Typography variant="h6" sx={{ mb: 2, color: "#154c79" }}>
//                       {t.selectDates}
//                     </Typography>

//                     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//                       <Button
//                         onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1))}
//                         variant="outlined"
//                         size="small"
//                         startIcon={<ArrowBackIcon />}
//                       >
//                         {t.previous}
//                       </Button>
//                       <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79" }}>
//                         {getMonthName()}
//                       </Typography>
//                       <Button
//                         onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1))}
//                         variant="outlined"
//                         size="small"
//                         endIcon={<ArrowForwardIcon />}
//                       >
//                         {t.nextMonth}
//                       </Button>
//                     </Box>

//                     {renderCalendar()}

//                     {selectedDates.length > 0 && (
//                       <Box sx={{ mt: 3 }}>
//                         <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#154c79" }}>
//                           {t.selected} {t.dates} ({selectedDates.length})
//                         </Typography>
//                         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                           {selectedDates.sort().map((date) => (
//                             <Chip
//                               key={date}
//                               label={formatDateDisplay(date)}
//                               onDelete={() => handleDateSelection(new Date(date))}
//                               color="primary"
//                               size="small"
//                               sx={{ fontWeight: "bold" }}
//                             />
//                           ))}
//                         </Box>
//                       </Box>
//                     )}

//                     <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
//                       <Button disabled variant="outlined">
//                         {t.back}
//                       </Button>
//                       <Button
//                         variant="contained"
//                         onClick={() => setActiveStep(1)}
//                         disabled={selectedDates.length === 0}
//                         endIcon={<ArrowForwardIcon />}
//                       >
//                         {t.next}: {t.selectShifts}
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               )}

//               {activeStep === 1 && (
//                 <Card>
//                   <CardContent>
//                     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//                       <Typography variant="h6" sx={{ color: "#154c79" }}>
//                         {t.selectShifts}
//                       </Typography>
//                       <Button
//                         startIcon={<AddIcon />}
//                         variant="outlined"
//                         size="small"
//                         onClick={() => setOpenAddScheduleDialog(true)}
//                       >
//                         {t.addNewShift}
//                       </Button>
//                     </Box>

//                     {loadingShifts ? (
//                       <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
//                         <CircularProgress sx={{ color: "#154c79" }} />
//                         <Typography variant="body2" sx={{ mt: 1, color: "#666" }}>
//                           {t.loadingShifts}
//                         </Typography>
//                       </Box>
//                     ) : shifts && shifts.length > 0 ? (
//                       <Grid container spacing={2}>
//                         {shifts.map((shift) => (
//                           <Grid item xs={12} sm={6} md={4} key={shift.shift_code}>
//                             <ShiftCard
//                               selected={selectedShifts.some((s) => s.shift_code === shift.shift_code)}
//                               onClick={() => handleShiftSelection(shift)}
//                             >
//                               <CardContent>
//                                 <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#154c79" }}>
//                                   {shift.shift_name}
//                                 </Typography>
//                                 <Typography variant="body2" sx={{ color: "#546e7a", mb: 1 }}>
//                                   {t.shiftCode}: {shift.shift_code}
//                                 </Typography>
//                                 <Typography variant="body2" sx={{ color: "#154c79", fontWeight: "bold" }}>
//                                   <AccessTimeIcon sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }} />
//                                   {shift.StartTime} - {shift.EndTime}
//                                 </Typography>
//                                 <Chip
//                                   label={shift.status === "A" ? t.active : t.inactive}
//                                   size="small"
//                                   color={shift.status === "A" ? "success" : "default"}
//                                   sx={{ mt: 1 }}
//                                 />
//                               </CardContent>
//                             </ShiftCard>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     ) : (
//                       <Box sx={{ textAlign: "center", p: 4 }}>
//                         <ScheduleIcon sx={{ fontSize: 48, color: "#e0e0e0", mb: 2 }} />
//                         <Typography variant="body1" sx={{ color: "#666", mb: 2 }}>
//                           {t.noShifts}
//                         </Typography>
//                         <Button
//                           startIcon={<AddIcon />}
//                           variant="contained"
//                           size="small"
//                           onClick={() => setOpenAddScheduleDialog(true)}
//                         >
//                           {t.addNewShift}
//                         </Button>
//                       </Box>
//                     )}

//                     {selectedShifts.length > 0 && (
//                       <Box sx={{ mt: 3 }}>
//                         <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#154c79" }}>
//                           {t.selected} {t.shifts} ({selectedShifts.length})
//                         </Typography>
//                         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                           {selectedShifts.map((shift) => (
//                             <Chip
//                               key={shift.shift_code}
//                               label={`${shift.shift_name} (${shift.StartTime}-${shift.EndTime})`}
//                               onDelete={() => handleShiftSelection(shift)}
//                               color="primary"
//                               size="medium"
//                               sx={{ fontWeight: "bold" }}
//                             />
//                           ))}
//                         </Box>
//                       </Box>
//                     )}

//                     <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
//                       <Button variant="outlined" onClick={() => setActiveStep(0)} startIcon={<ArrowBackIcon />}>
//                         {t.back}
//                       </Button>
//                       <Button
//                         variant="contained"
//                         onClick={() => setActiveStep(2)}
//                         disabled={selectedShifts.length === 0}
//                         endIcon={<ArrowForwardIcon />}
//                       >
//                         {t.next}: {t.selectLocation}
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               )}

//               {activeStep === 2 && (
//                 <Card>
//                   <CardContent>
//                     <Typography variant="h6" sx={{ mb: 3, color: "#154c79" }}>
//                       {t.selectLocation}
//                     </Typography>

//                     {loadingLocations ? (
//                       <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
//                         <CircularProgress sx={{ color: "#154c79" }} />
//                         <Typography variant="body2" sx={{ mt: 1, color: "#666" }}>
//                           {t.loadingLocations}
//                         </Typography>
//                       </Box>
//                     ) : locations && locations.length > 0 ? (
//                       <Grid container spacing={2}>
//                         {locations.map((location) => (
//                           <Grid item xs={12} sm={6} md={4} key={location.loc_code}>
//                             <LocationCard
//                               selected={selectedLocation === location.loc_code}
//                               onClick={() => handleLocationChange(location.loc_code)}
//                             >
//                               <CardContent>
//                                 <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                                   <Avatar sx={{ bgcolor: "#154c79" }}>
//                                     <LocationOnIcon />
//                                   </Avatar>
//                                   <Box sx={{ flex: 1 }}>
//                                     <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
//                                       {location.loc_name}
//                                     </Typography>
//                                     <Typography variant="body2" sx={{ color: "#546e7a", fontSize: "0.8rem" }}>
//                                       {t.location}: {location.loc_code}
//                                     </Typography>
//                                     {employeesByLocation[location.loc_code] && (
//                                       <Typography variant="caption" sx={{ color: "#2e7d32", display: "block", mt: 0.5 }}>
//                                         {employeesByLocation[location.loc_code].length} {t.employees}
//                                       </Typography>
//                                     )}
//                                   </Box>
//                                 </Box>
//                               </CardContent>
//                             </LocationCard>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     ) : (
//                       <Box sx={{ textAlign: "center", p: 4 }}>
//                         <LocationOnIcon sx={{ fontSize: 48, color: "#e0e0e0", mb: 2 }} />
//                         <Typography variant="body1" sx={{ color: "#666", mb: 1 }}>
//                           {t.noLocationsFound}
//                         </Typography>
//                         <Typography variant="body2" sx={{ color: "#999", mb: 3 }}>
//                           Please check API connection and try again.
//                         </Typography>
//                         <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
//                           <Button 
//                             variant="outlined" 
//                             onClick={() => dispatch(fetchLocations())}
//                             startIcon={<RefreshIcon />}
//                           >
//                             {t.retry}
//                           </Button>
//                           <Button 
//                             variant="contained" 
//                             onClick={handleTestAPIConnectivity}
//                             startIcon={<WarningIcon />}
//                           >
//                             {t.testAPI}
//                           </Button>
//                         </Box>
//                       </Box>
//                     )}

//                     <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
//                       <Button variant="outlined" onClick={() => setActiveStep(1)} startIcon={<ArrowBackIcon />}>
//                         {t.back}
//                       </Button>
//                       <Button
//                         variant="contained"
//                         onClick={() => setActiveStep(3)}
//                         disabled={!selectedLocation}
//                         endIcon={<ArrowForwardIcon />}
//                       >
//                         {t.next}: {t.selectEmployees}
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               )}

//               {activeStep === 3 && (
//                 <Card>
//                   <CardContent>
//                     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//                       <Typography variant="h6" sx={{ color: "#154c79" }}>
//                         {t.selectEmployees} - {locations.find((l) => l.loc_code === selectedLocation)?.loc_name || selectedLocation}
//                       </Typography>
//                       <Button variant="outlined" size="small" onClick={handleSelectAllEmployees}>
//                         {selectedEmployees.length === filteredEmployees.length ? t.deselectAll : t.selectAll}
//                       </Button>
//                     </Box>

//                     <TextField
//                       fullWidth
//                       placeholder={t.searchEmployees}
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                       sx={{ mb: 3 }}
//                       InputProps={{
//                         startAdornment: <SearchIcon sx={{ mr: 1, color: "#9e9e9e" }} />,
//                         endAdornment: searchTerm && (
//                           <IconButton size="small" onClick={() => setSearchTerm("")}>
//                             <ClearIcon />
//                           </IconButton>
//                         ),
//                       }}
//                     />

//                     {loadingEmployees ? (
//                       <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
//                         <CircularProgress sx={{ color: "#154c79" }} />
//                         <Typography variant="body2" sx={{ mt: 1, color: "#666" }}>
//                           {t.loadingEmployees}
//                         </Typography>
//                       </Box>
//                     ) : filteredEmployees.length === 0 ? (
//                       <Alert severity="info">
//                         {searchTerm ? "No employees match your search." : "No employees found for this location."}
//                       </Alert>
//                     ) : (
//                       <Grid container spacing={2}>
//                         {filteredEmployees.map((employee) => (
//                           <Grid item xs={12} sm={6} md={4} key={employee.service_no}>
//                             <EmployeeCard onClick={() => handleEmployeeSelection(employee)}>
//                               <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                                 <Avatar sx={{ bgcolor: "#154c79" }}>
//                                   {employee.Name?.charAt(0) || "E"}
//                                 </Avatar>
//                                 <Box sx={{ flex: 1 }}>
//                                   <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#154c79" }}>
//                                     {employee.Name}
//                                   </Typography>
//                                   <Typography variant="caption" sx={{ color: "#546e7a", display: "block" }}>
//                                     {t.serviceNo}: {employee.service_no}
//                                   </Typography>
//                                   <Typography variant="caption" sx={{ color: "#757575", display: "block" }}>
//                                     {employee.Designation} - {employee.Department}
//                                   </Typography>
//                                 </Box>
//                                 {selectedEmployees.some((e) => e.service_no === employee.service_no) ? (
//                                   <CheckCircleIcon sx={{ color: "#2e7d32" }} />
//                                 ) : null}
//                               </Box>
//                             </EmployeeCard>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     )}

//                     {selectedEmployees.length > 0 && (
//                       <Box sx={{ mt: 3 }}>
//                         <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#154c79" }}>
//                           {t.selected} {t.employees} ({selectedEmployees.length})
//                         </Typography>
//                         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                           {selectedEmployees.map((employee) => (
//                             <Chip
//                               key={employee.service_no}
//                               label={`${employee.Name} (${employee.service_no})`}
//                               onDelete={() => handleEmployeeSelection(employee)}
//                               color="primary"
//                               size="small"
//                               avatar={<Avatar sx={{ bgcolor: "#154c79", width: 24, height: 24 }}>
//                                 {employee.Name?.charAt(0)}
//                               </Avatar>}
//                             />
//                           ))}
//                         </Box>
//                       </Box>
//                     )}

//                     <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
//                       <Button variant="outlined" onClick={() => setActiveStep(2)} startIcon={<ArrowBackIcon />}>
//                         {t.back}
//                       </Button>
//                       <Button
//                         variant="contained"
//                         onClick={() => setActiveStep(4)}
//                         disabled={selectedEmployees.length === 0}
//                         endIcon={<ArrowForwardIcon />}
//                       >
//                         {t.next}: {t.reviewAssign}
//                       </Button>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               )}

//               {activeStep === 4 && (
//                 <Card>
//                   <CardContent>
//                     <Typography variant="h6" sx={{ mb: 3, color: "#154c79" }}>
//                       {t.reviewAssign}
//                     </Typography>

//                     <Grid container spacing={2} sx={{ mb: 3 }}>
//                       <Grid item xs={12} md={4}>
//                         <Card sx={{ bgcolor: "rgba(232, 245, 233, 0.5)", border: "1px solid #c8e6c9" }}>
//                           <CardContent>
//                             <Typography variant="subtitle2" sx={{ color: "#2e7d32", mb: 1, fontWeight: "bold" }}>
//                               {t.dates}
//                             </Typography>
//                             <Typography variant="h4" sx={{ fontWeight: "bold", color: "#2e7d32" }}>
//                               {selectedDates.length}
//                             </Typography>
//                             <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                               {selectedDates.slice(0, 3).map((date) => (
//                                 <Chip
//                                   key={date}
//                                   label={formatDateDisplay(date)}
//                                   size="small"
//                                   sx={{ bgcolor: "#e8f5e9", color: "#2e7d32" }}
//                                 />
//                               ))}
//                               {selectedDates.length > 3 && (
//                                 <Chip label={`+${selectedDates.length - 3}`} size="small" />
//                               )}
//                             </Box>
//                           </CardContent>
//                         </Card>
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <Card sx={{ bgcolor: "rgba(227, 242, 253, 0.5)", border: "1px solid #bbdefb" }}>
//                           <CardContent>
//                             <Typography variant="subtitle2" sx={{ color: "#1565c0", mb: 1, fontWeight: "bold" }}>
//                               {t.shifts}
//                             </Typography>
//                             <Typography variant="h4" sx={{ fontWeight: "bold", color: "#1565c0" }}>
//                               {selectedShifts.length}
//                             </Typography>
//                             <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                               {selectedShifts.slice(0, 2).map((shift) => (
//                                 <Chip
//                                   key={shift.shift_code}
//                                   label={shift.shift_name}
//                                   size="small"
//                                   sx={{ bgcolor: "#e3f2fd", color: "#1565c0" }}
//                                 />
//                               ))}
//                               {selectedShifts.length > 2 && (
//                                 <Chip label={`+${selectedShifts.length - 2}`} size="small" />
//                               )}
//                             </Box>
//                           </CardContent>
//                         </Card>
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <Card sx={{ bgcolor: "rgba(243, 229, 245, 0.5)", border: "1px solid #e1bee7" }}>
//                           <CardContent>
//                             <Typography variant="subtitle2" sx={{ color: "#7b1fa2", mb: 1, fontWeight: "bold" }}>
//                               {t.employees}
//                             </Typography>
//                             <Typography variant="h4" sx={{ fontWeight: "bold", color: "#7b1fa2" }}>
//                               {selectedEmployees.length}
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: "#7b1fa2", mt: 1 }}>
//                               {locations.find((l) => l.loc_code === selectedLocation)?.loc_name || selectedLocation}
//                             </Typography>
//                           </CardContent>
//                         </Card>
//                       </Grid>
//                     </Grid>

//                     <Alert severity="info" sx={{ mb: 3 }}>
//                       {t.totalAssignments}: <strong>{totalAssignments}</strong>
//                     </Alert>

//                     <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
//                       {/* <Button
//                         variant="outlined"
//                         onClick={() => setActiveStep(3)}
//                         startIcon={<ArrowBackIcon />}
//                         sx={{ flex: 1 }}
//                       >
//                         {t.back}
//                       </Button> */
//                       <Button
//                               variant="outlined"
//                               onClick={() => setActiveStep(3)}
//                               startIcon={<ArrowBackIcon />}
//                               disabled={postingRoster}
//                               sx={{ flex: 1 }}
//                             >
//                               {t.back}
//                             </Button>}
//                       <Button
//                               variant="outlined"
//                               color="secondary"
//                               onClick={resetForm}
//                               startIcon={<RefreshIcon />}
//                               disabled={postingRoster}
//                               sx={{ flex: 1 }}
//                             >
//                               {t.startOver}
//                             </Button>
//                       {/* <Button
//                         variant="contained"
//                         onClick={handleAssignRoster}
//                         disabled={postingRoster}
//                         startIcon={postingRoster ? <CircularProgress size={20} /> : <AssignmentIcon />}
//                         sx={{ flex: 2 }}
//                       >
//                         {postingRoster ? t.assigning : t.assignRoster}
//                       </Button> */<Button
//                                         variant="contained"
//                                         onClick={handleAssignRoster}
//                                         disabled={
//                                           postingRoster ||
//                                           selectedDates.length === 0 ||
//                                           selectedShifts.length === 0 ||
//                                           selectedEmployees.length === 0
//                                         }
//                                         startIcon={
//                                           postingRoster ? (
//                                             <CircularProgress size={20} color="inherit" />
//                                           ) : (
//                                             <AssignmentIcon />
//                                           )
//                                         }
//                                         sx={{ flex: 2 }}
//                                       >
//                                         {postingRoster ? t.assigning : t.assignRoster}
//                                       </Button>}
                      
//                     </Box>
//                   </CardContent>
//                 </Card>
//               )}
//             </Box>
//           </Box>
//         );

//       case 1: // View Assignments
//         return (
//           <Box sx={{ mt: 3 }}>
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//               <Typography variant="h6" sx={{ color: "#154c79" }}>
//                 {t.viewAssignments}
//               </Typography>
//               <Box sx={{ display: "flex", gap: 1 }}>
//                 <Button
//                   startIcon={<FilterListIcon />}
//                   variant="outlined"
//                   onClick={() => setOpenFilterDialog(true)}
//                   size="small"
//                 >
//                   {t.filter}
//                 </Button>
//                 <Button
//                   startIcon={<RefreshIcon />}
//                   variant="outlined"
//                   onClick={() => dispatch(fetchAllRosterDetails({}))}
//                   disabled={loadingAllRosterDetails}
//                   size="small"
//                 >
//                   {t.refresh}
//                 </Button>
//                 <Button
//                   startIcon={<PDFIcon />}
//                   variant="contained"
//                   onClick={handleExportSummaryPDF}
//                   disabled={exporting || loadingAllRosterDetails || allRosterDetails.length === 0}
//                   size="small"
//                   sx={{ backgroundColor: "#2e7d32", "&:hover": { backgroundColor: "#1b5e20" } }}
//                 >
//                   {t.exportPdf}
//                 </Button>
//               </Box>
//             </Box>

//             {loadingAllRosterDetails ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
//                 <CircularProgress sx={{ color: "#154c79" }} />
//                 <Typography variant="body2" sx={{ mt: 1, color: "#666", ml: 2 }}>
//                   {t.loading}
//                 </Typography>
//               </Box>
//             ) : allRosterDetails.length === 0 ? (
//               <Box sx={{ textAlign: "center", p: 6 }}>
//                 <ScheduleIcon sx={{ fontSize: 60, color: "#e0e0e0", mb: 2 }} />
//                 <Typography variant="h6" sx={{ color: "#666", mb: 1 }}>
//                   {t.noAssignments}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#999", mb: 3 }}>
//                   {t.createFirstRoster}
//                 </Typography>
//                 <Button
//                   variant="contained"
//                   onClick={() => setTabValue(0)}
//                   startIcon={<AddIcon />}
//                 >
//                   {t.createRoster}
//                 </Button>
//               </Box>
//             ) : (
//               <>
//                 <StyledTableContainer component={Paper}>
//                   <Table stickyHeader>
//                     <TableHead>
//                       <TableRow>
//                         <StyledTableCell>{t.workDate}</StyledTableCell>
//                         <StyledTableCell>{t.employeeName}</StyledTableCell>
//                         <StyledTableCell>{t.serviceNo}</StyledTableCell>
//                         <StyledTableCell>{t.shift}</StyledTableCell>
//                         <StyledTableCell>{t.time}</StyledTableCell>
//                         <StyledTableCell>{t.location}</StyledTableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {allRosterDetails
//                         .slice((page - 1) * rowsPerPage, page * rowsPerPage)
//                         .map((assignment, index) => (
//                           <StyledTableRow key={index} hover>
//                             <StyledTableCell>
//                               {formatDateDisplay(assignment.WorkDate)}
//                             </StyledTableCell>
//                             <StyledTableCell sx={{ fontWeight: "bold" }}>
//                               {assignment.Name}
//                             </StyledTableCell>
//                             <StyledTableCell>{assignment.service_no}</StyledTableCell>
//                             <StyledTableCell>
//                               <Chip
//                                 label={assignment.shift_name}
//                                 size="small"
//                                 color="primary"
//                                 variant="outlined"
//                                 sx={{ fontWeight: "bold" }}
//                               />
//                             </StyledTableCell>
//                             <StyledTableCell>
//                               {assignment.StartTime} - {assignment.EndTime}
//                             </StyledTableCell>
//                             <StyledTableCell>{assignment.LocName}</StyledTableCell>
//                           </StyledTableRow>
//                         ))}
//                     </TableBody>
//                   </Table>
//                 </StyledTableContainer>

//                 <Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 2 }}>
//                   <Pagination
//                     count={Math.ceil(allRosterDetails.length / rowsPerPage)}
//                     page={page}
//                     onChange={(e, value) => setPage(value)}
//                     color="primary"
//                     size={isMobile ? "small" : "medium"}
//                   />
//                 </Box>

//                 <Typography variant="body2" sx={{ color: "#757575", textAlign: "center", mb: 2 }}>
//                   {t.page} {page} {t.of} {Math.ceil(allRosterDetails.length / rowsPerPage)}
//                 </Typography>
//               </>
//             )}
//           </Box>
//         );

//       case 2: // Manage Shifts
//         return (
//           <Box sx={{ mt: 3 }}>
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//               <Typography variant="h6" sx={{ color: "#154c79" }}>
//                 {t.manageShifts}
//               </Typography>
//               <Button
//                 startIcon={<AddIcon />}
//                 variant="contained"
//                 onClick={() => setOpenAddScheduleDialog(true)}
//               >
//                 {t.addNewShift}
//               </Button>
//             </Box>

//             {loadingShifts ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
//                 <CircularProgress sx={{ color: "#154c79" }} />
//                 <Typography variant="body2" sx={{ mt: 1, color: "#666", ml: 2 }}>
//                   {t.loadingShifts}
//                 </Typography>
//               </Box>
//             ) : shifts.length === 0 ? (
//               <Box sx={{ textAlign: "center", p: 6 }}>
//                 <AccessTimeIcon sx={{ fontSize: 60, color: "#e0e0e0", mb: 2 }} />
//                 <Typography variant="h6" sx={{ color: "#666", mb: 1 }}>
//                   {t.noShifts}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#999", mb: 3 }}>
//                   Add your first shift to get started
//                 </Typography>
//                 <Button
//                   variant="contained"
//                   onClick={() => setOpenAddScheduleDialog(true)}
//                   startIcon={<AddIcon />}
//                 >
//                   {t.addNewShift}
//                 </Button>
//               </Box>
//             ) : (
//               <Grid container spacing={2}>
//                 {shifts.map((shift) => (
//                   <Grid item xs={12} sm={6} md={4} key={shift.shift_code}>
//                     <Card>
//                       <CardContent>
//                         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//                           <Box>
//                             <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79" }}>
//                               {shift.shift_name}
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: "#546e7a", mb: 1 }}>
//                               {t.shiftCode}: {shift.shift_code}
//                             </Typography>
//                             <Typography variant="body1" sx={{ color: "#154c79", fontWeight: "bold" }}>
//                               <AccessTimeIcon sx={{ fontSize: 16, verticalAlign: "middle", mr: 0.5 }} />
//                               {shift.StartTime} - {shift.EndTime}
//                             </Typography>
//                           </Box>
//                           <Chip
//                             label={shift.status === "A" ? t.active : t.inactive}
//                             color={shift.status === "A" ? "success" : "default"}
//                             size="small"
//                           />
//                         </Box>
//                         {shift.Duration && (
//                           <Typography variant="caption" sx={{ color: "#9e9e9e", display: "block", mt: 1 }}>
//                             {t.duration}: {shift.Duration}
//                           </Typography>
//                         )}
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             )}
//           </Box>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <PageContainer>
//         {/* Export Progress Backdrop */}
//         <ProgressBackdrop open={exporting}>
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               gap: 2,
//               p: 4,
//               bgcolor: "background.paper",
//               borderRadius: 2,
//               boxShadow: 24,
//               maxWidth: 400,
//               width: "100%",
//             }}
//           >
//             <CircularProgress size={60} thickness={4} sx={{ color: "#154c79" }} />
//             <Typography variant="h6" color="primary" fontWeight="bold">
//               {exporting ? t.exporting : "Preparing report..."}
//             </Typography>
//             <Box sx={{ width: "100%", mt: 2 }}>
//               <LinearProgress
//                 variant="determinate"
//                 value={exportProgress}
//                 sx={{
//                   height: 10,
//                   borderRadius: 5,
//                   backgroundColor: "#e0e0e0",
//                   "& .MuiLinearProgress-bar": {
//                     backgroundColor: tabValue === 1 ? "#2e7d32" : "#154c79",
//                   },
//                 }}
//               />
//               <Typography variant="body2" color="text.secondary" align="center" mt={1}>
//                 {exportProgress}%
//               </Typography>
//             </Box>
//           </Box>
//         </ProgressBackdrop>

//         {/* Success/Error Snackbar */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={4000}
//           onClose={closeSnackbar}
//           anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//         >
//           <AlertComponent onClose={closeSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
//             {snackbar.message}
//           </AlertComponent>
//         </Snackbar>

//         {/* Debug Button */}
//         {debugMode && (
//   <Button
//     variant="outlined"
//     size="small"
//     onClick={() => {
//       console.log("=== DEBUG INFO ===");
//       console.log("Locations state:", locations);
//       console.log("Shifts state:", shifts);
//       console.log("Employees by location:", employeesByLocation);
//       console.log("All roster details:", allRosterDetails);
//       console.log("===================");
      
//       // Test direct API call
//       fetch("https://daladamaligawa.dockyardsoftware.com/UserDetails/Locations")
//         .then(res => res.json())
//         .then(data => console.log("Direct API response:", data))
//         .catch(err => console.error("Direct API error:", err));
//     }}
//     sx={{
//       position: "fixed",
//       bottom: 80,
//       right: 16,
//       zIndex: 1000,
//       backgroundColor: "white",
//       borderColor: "#ff9800",
//       color: "#ff9800",
//     }}
//     startIcon={<WarningIcon />}
//   >
//     Debug Info
//   </Button>
// )}

//         {/* Header */}
//         <StickyHeader>
//           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//             <Box>
//               <Typography
//                 sx={{
//                   fontSize: "20px",
//                   fontWeight: 700,
//                   color: "#154c79",
//                   lineHeight: 1.2,
//                 }}
//               >
//                 {t.title}
//               </Typography>
//               <Typography
//                 sx={{
//                   fontSize: "14px",
//                   color: "#546e7a",
//                   fontWeight: 400,
//                 }}
//               >
//                 {t.subtitle}
//               </Typography>
//             </Box>

//             {/* Language Selector */}
//             <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//               <Tooltip title={t.debug}>
//                 <IconButton
//                   onClick={() => setDebugMode(!debugMode)}
//                   sx={{
//                     backgroundColor: debugMode ? "#ff9800" : "#f0f0f0",
//                     color: debugMode ? "white" : "#154c79",
//                     "&:hover": {
//                       backgroundColor: debugMode ? "#f57c00" : "#e0e0e0",
//                     },
//                     width: "36px",
//                     height: "36px",
//                   }}
//                 >
//                   <ErrorIcon fontSize="small" />
//                 </IconButton>
//               </Tooltip>
              
//               <Tooltip title={t.language}>
//                 <IconButton
//                   onClick={handleLanguageMenuOpen}
//                   sx={{
//                     backgroundColor: language === "si" ? "#154c79" : "#f0f0f0",
//                     color: language === "si" ? "white" : "#154c79",
//                     "&:hover": {
//                       backgroundColor: language === "si" ? "#0D47A1" : "#e0e0e0",
//                     },
//                     width: "40px",
//                     height: "40px",
//                   }}
//                 >
//                   {language === "si" ? (
//                     <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>සිං</Typography>
//                   ) : (
//                     <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>EN</Typography>
//                   )}
//                 </IconButton>
//               </Tooltip>

//               <Menu
//                 anchorEl={anchorEl}
//                 open={Boolean(anchorEl)}
//                 onClose={handleLanguageMenuClose}
//                 PaperProps={{
//                   sx: {
//                     mt: 1,
//                     minWidth: 120,
//                     borderRadius: "8px",
//                     boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                   },
//                 }}
//               >
//                 <MenuItem
//                   onClick={() => handleLanguageChange("en")}
//                   selected={language === "en"}
//                   sx={{
//                     backgroundColor: language === "en" ? "rgba(21, 76, 121, 0.08)" : "transparent",
//                     "&:hover": {
//                       backgroundColor: "rgba(21, 76, 121, 0.12)",
//                     },
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <LanguageIcon sx={{ fontSize: 18, color: "#154c79" }} />
//                     <Typography sx={{ fontWeight: language === "en" ? 600 : 400 }}>English</Typography>
//                   </Box>
//                 </MenuItem>
//                 <MenuItem
//                   onClick={() => handleLanguageChange("si")}
//                   selected={language === "si"}
//                   sx={{
//                     backgroundColor: language === "si" ? "rgba(21, 76, 121, 0.08)" : "transparent",
//                     "&:hover": {
//                       backgroundColor: "rgba(21, 76, 121, 0.12)",
//                     },
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <TranslateIcon sx={{ fontSize: 18, color: "#154c79" }} />
//                     <Typography sx={{ fontWeight: language === "si" ? 600 : 400 }}>සිංහල</Typography>
//                   </Box>
//                 </MenuItem>
//               </Menu>
//             </Box>
//           </Box>

//           {/* Tabs */}
//           <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//             <Box sx={{ display: "flex", gap: 1 }}>
//               <Button
//                 variant={tabValue === 0 ? "contained" : "outlined"}
//                 onClick={() => setTabValue(0)}
//                 startIcon={<AddIcon />}
//                 sx={{
//                   flex: 1,
//                   borderRadius: "8px",
//                   textTransform: "none",
//                   fontWeight: "bold",
//                   backgroundColor: tabValue === 0 ? "#154c79" : "transparent",
//                   color: tabValue === 0 ? "#fff" : "#154c79",
//                   borderColor: "#154c79",
//                   "&:hover": {
//                     backgroundColor: tabValue === 0 ? "#0D47A1" : "rgba(21, 76, 121, 0.08)",
//                   },
//                 }}
//               >
//                 {t.createRoster}
//               </Button>
//               <Button
//                 variant={tabValue === 1 ? "contained" : "outlined"}
//                 onClick={() => setTabValue(1)}
//                 startIcon={<VisibilityIcon />}
//                 sx={{
//                   flex: 1,
//                   borderRadius: "8px",
//                   textTransform: "none",
//                   fontWeight: "bold",
//                   backgroundColor: tabValue === 1 ? "#154c79" : "transparent",
//                   color: tabValue === 1 ? "#fff" : "#154c79",
//                   borderColor: "#154c79",
//                   "&:hover": {
//                     backgroundColor: tabValue === 1 ? "#0D47A1" : "rgba(21, 76, 121, 0.08)",
//                   },
//                 }}
//               >
//                 {t.viewAssignments}
//               </Button>
//               <Button
//                 variant={tabValue === 2 ? "contained" : "outlined"}
//                 onClick={() => setTabValue(2)}
//                 startIcon={<ScheduleIcon />}
//                 sx={{
//                   flex: 1,
//                   borderRadius: "8px",
//                   textTransform: "none",
//                   fontWeight: "bold",
//                   backgroundColor: tabValue === 2 ? "#154c79" : "transparent",
//                   color: tabValue === 2 ? "#fff" : "#154c79",
//                   borderColor: "#154c79",
//                   "&:hover": {
//                     backgroundColor: tabValue === 2 ? "#0D47A1" : "rgba(21, 76, 121, 0.08)",
//                   },
//                 }}
//               >
//                 {t.manageShifts}
//               </Button>
//             </Box>
//           </Box>
//         </StickyHeader>

//         <ScrollableContent>{renderTabContent()}</ScrollableContent>

//         {/* Add Schedule Dialog */}
//         <Dialog
//           open={openAddScheduleDialog}
//           onClose={() => setOpenAddScheduleDialog(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>
//             <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79" }}>
//               {t.addNewShift}
//             </Typography>
//           </DialogTitle>
//           <DialogContent>
//             <Box sx={{ pt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
//               <TextField
//                 fullWidth
//                 label={t.shiftCode}
//                 value={newSchedule.shift_code}
//                 onChange={(e) => setNewSchedule({ ...newSchedule, shift_code: e.target.value })}
//                 required
//                 size="small"
//               />
//               <TextField
//                 fullWidth
//                 label={t.shiftName}
//                 value={newSchedule.shift_name}
//                 onChange={(e) => setNewSchedule({ ...newSchedule, shift_name: e.target.value })}
//                 required
//                 size="small"
//               />
//               <Box sx={{ display: "flex", gap: 2 }}>
//                 <TextField
//                   fullWidth
//                   label={t.startTime}
//                   type="time"
//                   value={newSchedule.StartTime}
//                   onChange={(e) => setNewSchedule({ ...newSchedule, StartTime: e.target.value })}
//                   InputLabelProps={{ shrink: true }}
//                   required
//                   size="small"
//                 />
//                 <TextField
//                   fullWidth
//                   label={t.endTime}
//                   type="time"
//                   value={newSchedule.EndTime}
//                   onChange={(e) => setNewSchedule({ ...newSchedule, EndTime: e.target.value })}
//                   InputLabelProps={{ shrink: true }}
//                   required
//                   size="small"
//                 />
//               </Box>
//             </Box>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpenAddScheduleDialog(false)}>{t.cancel}</Button>
//             <Button
//               onClick={handleAddSchedule}
//               variant="contained"
//               disabled={postingSchedule}
//               startIcon={postingSchedule ? <CircularProgress size={20} /> : <AddIcon />}
//             >
//               {postingSchedule ? t.adding : t.addShift}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Filter Dialog */}
//         <Dialog
//           open={openFilterDialog}
//           onClose={() => setOpenFilterDialog(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>
//             <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79" }}>
//               {t.filter}
//             </Typography>
//           </DialogTitle>
//           <DialogContent>
//             <Box sx={{ pt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>{t.location}</InputLabel>
//                 <Select
//                   value={filters.location}
//                   onChange={(e) => setFilters({ ...filters, location: e.target.value })}
//                   label={t.location}
//                 >
//                   <MenuItem value="">{t.allLocations}</MenuItem>
//                   {locations && locations.map((location) => (
//                     <MenuItem key={location.loc_code} value={location.loc_code}>
//                       {location.loc_name} ({location.loc_code})
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               <TextField
//                 fullWidth
//                 label={t.employeeNo}
//                 value={filters.employeeNo}
//                 onChange={(e) => setFilters({ ...filters, employeeNo: e.target.value })}
//                 size="small"
//               />

//               <FormControl fullWidth size="small">
//                 <InputLabel>{t.shift}</InputLabel>
//                 <Select
//                   value={filters.shiftCode}
//                   onChange={(e) => setFilters({ ...filters, shiftCode: e.target.value })}
//                   label={t.shift}
//                 >
//                   <MenuItem value="">{t.allShifts}</MenuItem>
//                   {shifts.map((shift) => (
//                     <MenuItem key={shift.shift_code} value={shift.shift_code}>
//                       {shift.shift_name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               <DatePicker
//                 label={t.workDate}
//                 value={filters.workDate}
//                 onChange={(date) => setFilters({ ...filters, workDate: date })}
//                 slotProps={{
//                   textField: {
//                     fullWidth: true,
//                     size: "small",
//                   },
//                 }}
//               />
//             </Box>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleResetFilters}>{t.clear}</Button>
//             <Button onClick={() => setOpenFilterDialog(false)}>{t.cancel}</Button>
//             <Button onClick={handleApplyFilters} variant="contained">
//               {t.applyFilters}
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </PageContainer>
//     </LocalizationProvider>
//   );
// };

// export default RosterManagement;



import React, { useState, useEffect, useMemo } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Alert,
  LinearProgress,
  Backdrop,
  IconButton,
  Tooltip,
  Chip,
  Avatar,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Pagination,
  Stepper,
  Step,
  StepLabel,
  Menu,
  InputAdornment,
  Collapse,
  Divider,
} from "@mui/material";
import {
  Add as AddIcon,
  Visibility as VisibilityIcon,
  CalendarToday as CalendarTodayIcon,
  Schedule as ScheduleIcon,
  LocationOn as LocationOnIcon,
  People as PeopleIcon,
  Assignment as AssignmentIcon,
  FilterList as FilterListIcon,
  Refresh as RefreshIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  PictureAsPdf as PDFIcon,
  ArrowBack as ArrowBackIcon,
  Translate as TranslateIcon,
  Language as LanguageIcon,
  CheckCircle as CheckCircleIcon,
  AccessTime as AccessTimeIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  EventNote as EventNoteIcon,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useTheme, useMediaQuery } from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLocations,
  fetchEmployeesByLocation,
  fetchShifts,
  postRoster,
  postSchedule,
  fetchAllRosterDetails,
  setSelectedDates,
  setSelectedShifts,
  setSelectedLocation,
  clearSelectedEmployees,
  testAPIConnectivity,
} from "../actions/RosterActions";

// Import HeaderBannerPage
import HeaderBannerPage from "../components/HeaderBannerPage";

// MUI Alert component for Snackbar
const AlertComponent = React.forwardRef(function AlertComponent(props, ref) {
  return <Alert elevation={6} ref={ref} variant="filled" {...props} />;
});

// ------------ Translation Texts ------------
const translations = {
  en: {
    title: "Roster Management System",
    subtitle: "Create and manage employee duty rosters",
    createRoster: "Create Roster",
    viewAssignments: "View Assignments",
    manageShifts: "Manage Shifts",
    selectDates: "Select Dates",
    selectShifts: "Select Shifts",
    selectLocation: "Select Location",
    selectEmployees: "Select Employees",
    reviewAssign: "Review & Assign",
    step1Desc: "Choose dates for the roster",
    step2Desc: "Choose time shifts",
    step3Desc: "Select work location",
    step4Desc: "Select employees to assign",
    step5Desc: "Review and confirm assignment",
    datePicker: "Select Date",
    location: "Location",
    allLocations: "All Locations",
    shift: "Shift",
    allShifts: "All Shifts",
    employee: "Employee",
    serviceNo: "Service No",
    searchEmployees: "Search employees...",
    searchShifts: "Search shifts...",
    searchLocations: "Search locations...",
    selectAll: "Select All",
    deselectAll: "Deselect All",
    selected: "Selected",
    employees: "Employees",
    dates: "Dates",
    shifts: "Shifts",
    assignRoster: "Assign Roster",
    assigning: "Assigning...",
    rosterAssigned: "Roster assigned successfully!",
    assignmentFailed: "Failed to assign roster",
    startOver: "Start Over",
    back: "Back",
    next: "Next",
    addNewShift: "Add New Shift",
    shiftCode: "Shift Code",
    shiftName: "Shift Name",
    startTime: "Start Time",
    endTime: "End Time",
    addShift: "Add Shift",
    adding: "Adding...",
    shiftAdded: "Shift added successfully!",
    shiftFailed: "Failed to add shift",
    filter: "Filter",
    clear: "Clear",
    applyFilters: "Apply Filters",
    noData: "No data available",
    noAssignments: "No roster assignments found",
    loading: "Loading...",
    loadingLocations: "Loading locations...",
    loadingShifts: "Loading shifts...",
    loadingEmployees: "Loading employees...",
    exportPdf: "Export PDF",
    exporting: "Exporting...",
    pdfSuccess: "PDF exported successfully!",
    pdfError: "Failed to export PDF",
    reportTitle: "Roster Assignments Report",
    reportDate: "Report Date",
    page: "Page",
    of: "of",
    generatedOn: "Generated on",
    language: "Language",
    totalAssignments: "Total Assignments",
    filterByDate: "Filter by Date",
    filterByLocation: "Filter by Location",
    filterByEmployee: "Filter by Employee",
    filterByShift: "Filter by Shift",
    totalStrength: "Total Employees",
    attendance: "Present",
    absent: "Absent",
    employeeName: "Employee Name",
    position: "Position",
    department: "Department",
    workDate: "Work Date",
    time: "Time",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    refresh: "Refresh",
    noShifts: "No shifts available",
    createFirstRoster: "Create your first roster assignment",
    welcomeMessage: "Welcome to Roster Management",
    summary: "Summary",
    details: "Details",
    calendar: "Calendar",
    list: "List",
    week: "Week",
    month: "Month",
    today: "Today",
    previous: "Previous",
    nextMonth: "Next",
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    actions: "Actions",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    areYouSure: "Are you sure?",
    thisActionCannotBeUndone: "This action cannot be undone.",
    yes: "Yes",
    no: "No",
    success: "Success",
    error: "Error",
    info: "Information",
    warning: "Warning",
    debug: "Debug",
    testAPI: "Test API",
    apiTestSuccess: "API connectivity test successful!",
    apiTestFailed: "API connectivity test failed",
    noLocationsFound: "No locations found. Please check API connection.",
    retry: "Retry",
    showMore: "Show More",
    showLess: "Show Less",
    assignments: "Assignments",
    viewDetails: "View Details",
    employeeDetails: "Employee Details",
    assignedShifts: "Assigned Shifts",
    noShiftsAssigned: "No shifts assigned",
    progress: "Progress",
    rosterProgress: "Roster Progress",
    changeLanguage: "Change Language",
    shiftDetails: "Shift Details",
    locationDetails: "Location Details",
    employeeList: "Employee List",
    expandAll: "Expand All",
    collapseAll: "Collapse All",
    viewEmployees: "View Employees",
    assignedTo: "Assigned to",
    viewAssignmentsByShift: "View Assignments by Shift",
    date: "Date",
    count: "Count",
  },
  si: {
    title: "රෝස්ටර් කළමනාකරණ පද්ධතිය",
    subtitle: "සේවක රෝස්ටර් නිර්මාණය සහ කළමනාකරණය",
    createRoster: "රෝස්ටර් සාදන්න",
    viewAssignments: "නියමයන් බලන්න",
    manageShifts: "පැය කළමනාකරණය",
    selectDates: "දින තෝරන්න",
    selectShifts: "පැය තෝරන්න",
    selectLocation: "ස්ථානය තෝරන්න",
    selectEmployees: "සේවකයන් තෝරන්න",
    reviewAssign: "සමාලෝචනය සහ නියම කරන්න",
    step1Desc: "රෝස්ටර් සඳහා දින තෝරන්න",
    step2Desc: "කාල පැය තෝරන්න",
    step3Desc: "වැඩ ස්ථානය තෝරන්න",
    step4Desc: "නියම කිරීම සඳහා සේවකයන් තෝරන්න",
    step5Desc: "සමාලෝචනය කර තහවුරු කරන්න",
    datePicker: "දිනය තෝරන්න",
    location: "ස්ථානය",
    allLocations: "සියලු ස්ථාන",
    shift: "පැය",
    allShifts: "සියලු පැය",
    employee: "සේවකයා",
    serviceNo: "සේවා අංකය",
    searchEmployees: "සේවකයන් සොයන්න...",
    searchShifts: "පැය සොයන්න...",
    searchLocations: "ස්ථාන සොයන්න...",
    selectAll: "සියල්ල තෝරන්න",
    deselectAll: "සියල්ල ඉවත් කරන්න",
    selected: "තෝරාගත්",
    employees: "සේවකයන්",
    dates: "දින",
    shifts: "පැය",
    assignRoster: "රෝස්ටර් නියම කරන්න",
    assigning: "නියම කරමින්...",
    rosterAssigned: "රෝස්ටර් සාර්ථකව නියම කරන ලදී!",
    assignmentFailed: "රෝස්ටර් නියම කිරීම අසාර්ථක විය",
    startOver: "යලි ආරම්භ කරන්න",
    back: "ආපසු",
    next: "ඊළඟ",
    addNewShift: "නව පැයක් එකතු කරන්න",
    shiftCode: "පැය කේතය",
    shiftName: "පැය නම",
    startTime: "ආරම්භක වේලාව",
    endTime: "අවසන් වේලාව",
    addShift: "පැය එකතු කරන්න",
    adding: "එකතු කරමින්...",
    shiftAdded: "පැය සාර්ථකව එකතු කරන ලදී!",
    shiftFailed: "පැය එකතු කිරීම අසාර්ථක විය",
    filter: "පෙරහන",
    clear: "මකන්න",
    applyFilters: "පෙරහන යොදන්න",
    noData: "දත්ත නොමැත",
    noAssignments: "රෝස්ටර් නියමයන් නොමැත",
    loading: "පූරණය වෙමින්...",
    loadingLocations: "ස්ථාන පූරණය වෙමින්...",
    loadingShifts: "පැය පූරණය වෙමින්...",
    loadingEmployees: "සේවකයන් පූරණය වෙමින්...",
    exportPdf: "PDF බාගත කරන්න",
    exporting: "PDF බාගත කරමින්...",
    pdfSuccess: "PDF සාර්ථකව බාගත කරන ලදී!",
    pdfError: "PDF බාගත කිරීම අසාර්ථක විය",
    reportTitle: "රෝස්ටර් නියමයන් වාර්තාව",
    reportDate: "වාර්තා දිනය",
    page: "පිටුව",
    of: "යි",
    generatedOn: "සෑදූ දිනය",
    language: "භාෂාව",
    totalAssignments: "මුළු නියමයන්",
    filterByDate: "දිනය අනුව පෙරහන්",
    filterByLocation: "ස්ථානය අනුව පෙරහන්",
    filterByEmployee: "සේවකයා අනුව පෙරහන්",
    filterByShift: "පැය අනුව පෙරහන්",
    totalStrength: "මුළු සේවකයන්",
    attendance: "පැමිණි",
    absent: "පැමිණ නැත",
    employeeName: "සේවකයාගේ නම",
    position: "තනතුර",
    department: "විධානය",
    workDate: "වැඩ දිනය",
    time: "වේලාව",
    status: "තත්ත්වය",
    active: "සක්‍රිය",
    inactive: "අක්‍රිය",
    refresh: "නැවත පූරණය කරන්න",
    noShifts: "පැය නොමැත",
    createFirstRoster: "ඔබගේ පළමු රෝස්ටර් නියමය සාදන්න",
    welcomeMessage: "රෝස්ටර් කළමනාකරණයට සාදරයෙන් පිළිගනිමු",
    summary: "සාරාංශය",
    details: "විස්තර",
    calendar: "දින දර්ශනය",
    list: "ලැයිස්තුව",
    week: "සතිය",
    month: "මාසය",
    today: "අද",
    previous: "පෙර",
    nextMonth: "ඊළඟ",
    sun: "ඉරි",
    mon: "සඳු",
    tue: "අඟ",
    wed: "බදා",
    thu: "බ්‍රහ",
    fri: "සිකු",
    sat: "සෙන",
    actions: "ක්‍රියා",
    save: "සුරකින්න",
    cancel: "අවලංගු කරන්න",
    confirm: "තහවුරු කරන්න",
    areYouSure: "ඔබට විශ්වාසද?",
    thisActionCannotBeUndone: "මෙම ක්‍රියාව අහෝසි කළ නොහැක.",
    yes: "ඔව්",
    no: "නැත",
    success: "සාර්ථකයි",
    error: "දෝෂය",
    info: "තොරතුරු",
    warning: "අවවාදය",
    debug: "දෝෂ නිරාකරණය",
    testAPI: "API පරීක්ෂා කරන්න",
    apiTestSuccess: "API සම්බන්ධතා පරීක්ෂාව සාර්ථකයි!",
    apiTestFailed: "API සම්බන්ධතා පරීක්ෂාව අසාර්ථක විය",
    noLocationsFound: "ස්ථාන හමු නොවීය. API සම්බන්ධතාව පරීක්ෂා කරන්න.",
    retry: "නැවත උත්සාහ කරන්න",
    showMore: "තවත් පෙන්වන්න",
    showLess: "අඩුවෙන් පෙන්වන්න",
    assignments: "නියමයන්",
    viewDetails: "විස්තර බලන්න",
    employeeDetails: "සේවක විස්තර",
    assignedShifts: "නියම කළ පැය",
    noShiftsAssigned: "පැය නියම කර නැත",
    progress: "ප්‍රගතිය",
    rosterProgress: "රෝස්ටර් ප්‍රගතිය",
    changeLanguage: "භාෂාව වෙනස් කරන්න",
    shiftDetails: "පැය විස්තර",
    locationDetails: "ස්ථාන විස්තර",
    employeeList: "සේවක ලැයිස්තුව",
    expandAll: "සියල්ල පුළුල් කරන්න",
    collapseAll: "සියල්ල හකුලන්න",
    viewEmployees: "සේවකයන් බලන්න",
    assignedTo: "නියම කරන ලදි",
    viewAssignmentsByShift: "පැය අනුව නියමයන් බලන්න",
    date: "දිනය",
    count: "ගණන",
  },
};

// ------------ Main Container ------------
const PageContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  minHeight: "100vh",
  backgroundColor: "#f8fafc",
  fontFamily: "'Poppins', sans-serif",
}));

// ------------ Content Area ------------
const ContentArea = styled(Box)(({ theme }) => ({
  padding: "8px 12px",
  flex: 1,
  overflowY: "auto",
  backgroundColor: "#FFFFFF",
  [theme.breakpoints.down("sm")]: {
    padding: "6px 8px",
  },
}));

// ------------ Progress Container ------------
const ProgressContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  padding: "12px 16px",
  marginBottom: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  border: "1px solid #e0e0e0",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "10px 12px",
    marginBottom: "10px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },
}));

// ------------ Main Card Container ------------
const MainCardContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  padding: "16px",
  marginBottom: "80px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  minHeight: "400px",
  [theme.breakpoints.down("sm")]: {
    padding: "12px",
    marginBottom: "70px",
  },
}));

// ------------ Bottom Navigation ------------
const BottomNavigation = styled(Box)(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "#ffffff",
  padding: "10px 16px",
  boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
  zIndex: 1000,
  display: "flex",
  gap: "12px",
  justifyContent: "space-between",
  borderTop: "2px solid #e0e0e0",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "calc(100% - 24px)",
    margin: "0 auto 8px",
    left: "50%",
    transform: "translateX(-50%)",
    borderRadius: "8px",
    border: "2px solid #e0e0e0",
    bottom: "8px",
  },
}));

// ------------ Summary Card ------------
const SummaryCard = styled(Box)(({ theme, color }) => ({
  background: `linear-gradient(135deg, ${color}15 0%, ${color}25 100%)`,
  border: `1px solid ${color}40`,
  padding: "8px 10px",
  borderRadius: "6px",
  textAlign: "center",
  fontWeight: 600,
  color: color,
  flex: 1,
  minWidth: 0,
}));

// ------------ Employee Card ------------
const EmployeeCard = styled(Card)(({ theme }) => ({
  padding: "8px 10px",
  borderRadius: "6px",
  marginBottom: "6px",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
  backgroundColor: "#fff",
  border: "1px solid #e0e0e0",
  transition: "all 0.2s ease",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "rgba(21, 76, 121, 0.04)",
    transform: "translateY(-1px)",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    borderColor: "#154c79",
  },
}));

// ------------ Compact Calendar Container ------------
const CompactCalendarContainer = styled(Box)(({ theme }) => ({
  maxWidth: "600px",
  margin: "0 auto",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
  },
}));

// ------------ Calendar Day ------------
const CalendarDay = styled(Paper)(({ theme, selected, today }) => ({
  aspectRatio: "1",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  borderRadius: "6px",
  backgroundColor: selected ? "#154c79" : today ? "#e8f0fa" : "#ffffff",
  color: selected ? "#ffffff" : today ? "#154c79" : "#424242",
  fontWeight: selected || today ? "bold" : "normal",
  border: today ? "2px solid #154c79" : "1px solid #e0e0e0",
  transition: "all 0.2s ease",
  fontSize: "0.75rem",
  "&:hover": {
    backgroundColor: selected ? "#0D47A1" : "#f5f5f5",
    transform: "scale(1.05)",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.7rem",
  },
}));

// ------------ Shift Card ------------
const ShiftCard = styled(Card)(({ theme, selected }) => ({
  cursor: "pointer",
  border: selected ? "2px solid #154c79" : "1px solid #e0e0e0",
  backgroundColor: selected ? "rgba(21, 76, 121, 0.08)" : "#ffffff",
  transition: "all 0.2s ease",
  borderRadius: "6px",
  "&:hover": {
    borderColor: "#154c79",
    transform: "translateY(-1px)",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
}));

// ------------ Location Card ------------
const LocationCard = styled(Card)(({ theme, selected }) => ({
  cursor: "pointer",
  border: selected ? "2px solid #154c79" : "1px solid #e0e0e0",
  backgroundColor: selected ? "rgba(21, 76, 121, 0.08)" : "#ffffff",
  transition: "all 0.2s ease",
  borderRadius: "6px",
  "&:hover": {
    borderColor: "#154c79",
    transform: "translateY(-1px)",
  },
}));

// ------------ Scrollable Container ------------
const ScrollableContainer = styled(Box)(({ theme }) => ({
  maxHeight: "400px",
  overflowY: "auto",
  paddingRight: "8px",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#888",
    borderRadius: "3px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#555",
  },
  [theme.breakpoints.down("sm")]: {
    maxHeight: "350px",
  },
}));

// ------------ Table Container ------------
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: "6px",
  boxShadow: "0px 2px 4px rgba(0,0,0,0.05)",
  border: "1px solid #d1d9e6",
  backgroundColor: "#ffffff",
  overflow: "hidden",
  "&::-webkit-scrollbar": {
    width: "4px",
    height: "4px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#888",
    borderRadius: "2px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#555",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  padding: "8px 6px",
  fontSize: "12px",
  textAlign: "center",
  "&.MuiTableCell-head": {
    backgroundColor: "#154c79",
    color: "#ffffff",
    fontWeight: 600,
    borderBottom: "none",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  transition: "all 0.15s ease",
  "&:nth-of-type(odd)": {
    backgroundColor: "rgba(243, 246, 250, 0.6)",
  },
  "&:hover": {
    backgroundColor: "rgba(21, 76, 121, 0.06)",
    cursor: "pointer",
  },
}));

// ------------ Shift Assignment Row ------------
const ShiftAssignmentRow = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  padding: "12px",
  marginBottom: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  border: "1px solid #e0e0e0",
  "&:hover": {
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
}));

// ------------ Progress Backdrop ------------
const ProgressBackdrop = styled(Backdrop)(({ theme }) => ({
  color: "#fff",
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "rgba(0, 0, 0, 0.7)",
}));

// ------------ Tabs Container ------------
const TabsContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  padding: "8px",
  marginBottom: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  border: "1px solid #e0e0e0",
  [theme.breakpoints.down("sm")]: {
    marginBottom: "10px",
    padding: "6px",
  },
}));

const RosterManagement = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Redux state
  const {
    locations = [],
    loadingLocations,
    employeesByLocation = {},
    loadingEmployees,
    shifts = [],
    loadingShifts,
    postingRoster,
    postingSchedule,
    allRosterDetails = [],
    loadingAllRosterDetails,
    selectedDates: reduxSelectedDates = [],
    selectedShifts: reduxSelectedShifts = [],
    selectedLocation: reduxSelectedLocation,
  } = useSelector((state) => state.roster || {});

  // State variables
  const [activeStep, setActiveStep] = useState(0);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDates, setSelectedDatesState] = useState([]);
  const [selectedShifts, setSelectedShiftsState] = useState([]);
  const [selectedLocation, setSelectedLocationState] = useState(null);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchShiftTerm, setSearchShiftTerm] = useState("");
  const [searchLocationTerm, setSearchLocationTerm] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [page, setPage] = useState(1);
  const [language, setLanguage] = useState("en");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openAddScheduleDialog, setOpenAddScheduleDialog] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [newSchedule, setNewSchedule] = useState({
    shift_code: "",
    shift_name: "",
    StartTime: "09:00",
    EndTime: "17:00",
    status: "A",
  });
  const [filters, setFilters] = useState({
    location: "",
    employeeNo: "",
    shiftCode: "",
    workDate: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [exporting, setExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);
  const [expandedShift, setExpandedShift] = useState(null);
  const [expandedShifts, setExpandedShifts] = useState({});

  const rowsPerPage = isMobile ? 5 : 10;
  const t = translations[language];

  // Fixed date formatting
  const formatDate = (dateObj) => {
    if (!dateObj) return "";
    const d = new Date(dateObj);
    if (isNaN(d.getTime())) {
      if (typeof dateObj === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateObj)) {
        return dateObj;
      }
      return "";
    }
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString(language === "si" ? "si-LK" : "en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const getMonthName = () => {
    return currentDate.toLocaleDateString(language === "si" ? "si-LK" : "en-US", {
      month: "long",
      year: "numeric",
    });
  };

  // Load initial data
  useEffect(() => {
    dispatch(fetchLocations());
    dispatch(fetchShifts());
    dispatch(fetchAllRosterDetails({}));
  }, [dispatch]);

  // Sync with Redux state
  useEffect(() => {
    if (reduxSelectedDates) setSelectedDatesState(reduxSelectedDates);
    if (reduxSelectedShifts) setSelectedShiftsState(reduxSelectedShifts);
    if (reduxSelectedLocation) setSelectedLocationState(reduxSelectedLocation);
  }, [reduxSelectedDates, reduxSelectedShifts, reduxSelectedLocation]);

  // Filter employees based on search
  useEffect(() => {
    if (selectedLocation && employeesByLocation[selectedLocation]) {
      const employees = employeesByLocation[selectedLocation];
      if (searchTerm) {
        const filtered = employees.filter(
          (emp) =>
            (emp.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            emp.service_no?.includes(searchTerm))
        );
        setFilteredEmployees(filtered);
      } else {
        setFilteredEmployees(employees);
      }
    } else {
      setFilteredEmployees([]);
    }
  }, [searchTerm, selectedLocation, employeesByLocation]);

  // Filter shifts based on search
  const filteredShifts = useMemo(() => {
    if (!searchShiftTerm) return shifts;
    return shifts.filter(
      (shift) =>
        shift.shift_name?.toLowerCase().includes(searchShiftTerm.toLowerCase()) ||
        shift.shift_code?.toLowerCase().includes(searchShiftTerm.toLowerCase())
    );
  }, [shifts, searchShiftTerm]);

  // Filter locations based on search
  const filteredLocations = useMemo(() => {
    if (!searchLocationTerm) return locations;
    return locations.filter(
      (location) =>
        location.loc_name?.toLowerCase().includes(searchLocationTerm.toLowerCase()) ||
        location.loc_code?.toLowerCase().includes(searchLocationTerm.toLowerCase())
    );
  }, [locations, searchLocationTerm]);

  // Handle date selection
  const handleDateSelection = (date) => {
    if (!date) return;
    const dateStr = formatDate(date);
    if (!dateStr) return;
    
    const newDates = selectedDates.includes(dateStr)
      ? selectedDates.filter((d) => d !== dateStr)
      : [...selectedDates, dateStr];
    
    setSelectedDatesState(newDates);
    dispatch(setSelectedDates(newDates));
  };

  const handleShiftSelection = (shift) => {
    if (!shift) return;
    const newShifts = selectedShifts.includes(shift)
      ? selectedShifts.filter((s) => s !== shift)
      : [...selectedShifts, shift];

    setSelectedShiftsState(newShifts);
    dispatch(setSelectedShifts(newShifts));
  };

  const handleLocationChange = (locationCode) => {
    if (!locationCode) return;
    setSelectedLocationState(locationCode);
    dispatch(setSelectedLocation(locationCode));
    dispatch(fetchEmployeesByLocation(locationCode));
    setSelectedEmployees([]);
    setSearchTerm("");
  };

  const handleEmployeeSelection = (employee) => {
    if (!employee || !employee.service_no) return;
    
    const isSelected = selectedEmployees.some(
      (emp) => emp.service_no === employee.service_no
    );

    if (isSelected) {
      setSelectedEmployees(
        selectedEmployees.filter((emp) => emp.service_no !== employee.service_no)
      );
    } else {
      setSelectedEmployees([...selectedEmployees, employee]);
    }
  };

  const handleSelectAllEmployees = () => {
    if (selectedEmployees.length === filteredEmployees.length) {
      setSelectedEmployees([]);
    } else {
      setSelectedEmployees([...filteredEmployees]);
    }
  };

  // Handle assign roster
  const handleAssignRoster = async () => {
    if (selectedDates.length === 0 || selectedShifts.length === 0 || selectedEmployees.length === 0) {
      showSnackbar("Please select dates, shifts, and employees", "error");
      return;
    }

    if (postingRoster) {
      console.warn("Assignment already in progress, ignoring duplicate click");
      return;
    }

    const rosterData = [];
    
    selectedEmployees.forEach((employee) => {
      selectedDates.forEach((dateStr) => {
        selectedShifts.forEach((shift) => {
          rosterData.push({
            service_no: employee.service_no,
            WorkDate: dateStr,
            shift_code: shift.shift_code,
          });
        });
      });
    });

    try {
      const result = await dispatch(postRoster(rosterData));

      if (result?.success) {
        showSnackbar(
          `${t.rosterAssigned} (${rosterData.length} entries assigned)`,
          "success"
        );

        setSelectedDatesState([]);
        setSelectedShiftsState([]);
        setSelectedEmployees([]);
        setSearchTerm("");
        setActiveStep(0);

        setTimeout(() => {
          setTabValue(1);
        }, 1500);
      } else {
        const errorMsg = result?.error || t.assignmentFailed;
        showSnackbar(errorMsg, "error");
      }
    } catch (error) {
      console.error("Roster assignment error:", error);
      const errorMessage = error?.message || t.assignmentFailed;
      showSnackbar(errorMessage, "error");
    }
  };

  const handleAddSchedule = async () => {
    if (!newSchedule.shift_code || !newSchedule.shift_name) {
      showSnackbar("Please enter shift code and name", "error");
      return;
    }

    try {
      const result = await dispatch(postSchedule([newSchedule]));
      if (result.success) {
        showSnackbar(t.shiftAdded, "success");
        setNewSchedule({
          shift_code: "",
          shift_name: "",
          StartTime: "09:00",
          EndTime: "17:00",
          status: "A",
        });
        setOpenAddScheduleDialog(false);
      } else {
        showSnackbar(result.error || t.shiftFailed, "error");
      }
    } catch (error) {
      console.error("Error in handleAddSchedule:", error);
      showSnackbar(t.shiftFailed, "error");
    }
  };

  const handleApplyFilters = () => {
    const filterParams = {
      loc: filters.location || "",
      sno: filters.employeeNo || "",
      scode: filters.shiftCode || "",
      wdate: filters.workDate ? formatDate(filters.workDate) : "",
    };
    
    dispatch(fetchAllRosterDetails(filterParams));
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters({
      location: "",
      employeeNo: "",
      shiftCode: "",
      workDate: null,
    });
    dispatch(fetchAllRosterDetails({}));
  };

  const resetForm = () => {
    setSelectedDatesState([]);
    setSelectedShiftsState([]);
    setSelectedLocationState(null);
    setSelectedEmployees([]);
    setSearchTerm("");
    setActiveStep(0);
    dispatch(setSelectedDates([]));
    dispatch(setSelectedShifts([]));
    dispatch(setSelectedLocation(null));
    dispatch(clearSelectedEmployees());
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleTestAPIConnectivity = async () => {
    try {
      const result = await dispatch(testAPIConnectivity());
      if (result.success) {
        showSnackbar(t.apiTestSuccess, "success");
        dispatch(fetchLocations());
        dispatch(fetchShifts());
        dispatch(fetchAllRosterDetails({}));
      } else {
        showSnackbar(result.error || t.apiTestFailed, "error");
      }
    } catch (error) {
      showSnackbar(t.apiTestFailed, "error");
    }
  };

  // Language menu handlers
  const handleLanguageMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    handleLanguageMenuClose();
  };

  // Calendar rendering - Compact version for desktop
  const renderCalendar = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();

    const days = [];

    // Empty cells for first week
    for (let i = 0; i < firstDay; i++) {
      days.push(<Box key={`empty-${i}`} sx={{ aspectRatio: "1" }} />);
    }

    // Days of month
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const dateStr = formatDate(date);
      const isSelected = selectedDates.includes(dateStr);
      const today = new Date();
      const isToday = date.getDate() === today.getDate() && 
                     date.getMonth() === today.getMonth() && 
                     date.getFullYear() === today.getFullYear();

      days.push(
        <CalendarDay
          key={day}
          selected={isSelected}
          today={isToday}
          onClick={() => handleDateSelection(date)}
        >
          {day}
        </CalendarDay>
      );
    }

    return (
      <CompactCalendarContainer>
        <Grid container spacing={0.5}>
          {[
            language === "si" ? ["ඉ", "ස", "අ", "බ", "බ්‍ර", "සි", "සෙ"] : ["S", "M", "T", "W", "T", "F", "S"]
          ].flat().map((day) => (
            <Grid item xs={12 / 7} key={day}>
              <Typography
                align="center"
                sx={{
                  fontWeight: "bold",
                  color: "#154c79",
                  fontSize: isMobile ? "10px" : "11px",
                  mb: 0.5,
                }}
              >
                {day}
              </Typography>
            </Grid>
          ))}
          {days.map((day, index) => (
            <Grid item xs={12 / 7} key={`day-${index}`}>
              {day}
            </Grid>
          ))}
        </Grid>
      </CompactCalendarContainer>
    );
  };

  // Steps content
  const steps = [
    {
      label: t.selectDates,
      description: t.step1Desc,
      icon: <CalendarTodayIcon fontSize="small" />,
    },
    {
      label: t.selectShifts,
      description: t.step2Desc,
      icon: <ScheduleIcon fontSize="small" />,
    },
    {
      label: t.selectLocation,
      description: t.step3Desc,
      icon: <LocationOnIcon fontSize="small" />,
    },
    {
      label: t.selectEmployees,
      description: t.step4Desc,
      icon: <PeopleIcon fontSize="small" />,
    },
    {
      label: t.reviewAssign,
      description: t.step5Desc,
      icon: <AssignmentIcon fontSize="small" />,
    },
  ];

  // Calculate progress percentage
  const progressPercentage = useMemo(() => {
    if (tabValue !== 0) return 0;
    
    let progress = 0;
    if (selectedDates.length > 0) progress += 20;
    if (selectedShifts.length > 0) progress += 20;
    if (selectedLocation) progress += 20;
    if (selectedEmployees.length > 0) progress += 20;
    if (activeStep === 4) progress += 20;
    
    return progress;
  }, [selectedDates, selectedShifts, selectedLocation, selectedEmployees, activeStep, tabValue]);

  // Render progress bar
  const renderProgressBar = () => {
    if (tabValue !== 0) return null;
    
    return (
      <ProgressContainer>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#154c79", fontSize: "12px" }}>
            {t.rosterProgress}
          </Typography>
          <LinearProgress
            variant="determinate"
            value={progressPercentage}
            sx={{
              width: isMobile ? "150px" : "200px",
              height: 8,
              borderRadius: 4,
              backgroundColor: "#e8f0fa",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#154c79",
                borderRadius: 4,
              },
            }}
          />
          <Typography variant="caption" sx={{ color: "#154c79", fontWeight: "bold", fontSize: "11px", minWidth: "40px" }}>
            {progressPercentage}%
          </Typography>
        </Box>
        <Tooltip title={t.changeLanguage}>
          <IconButton
            onClick={handleLanguageMenuOpen}
            sx={{
              backgroundColor: language === "si" ? "#154c79" : "#e0e0e0",
              color: language === "si" ? "#ffffff" : "#154c79",
              "&:hover": {
                backgroundColor: language === "si" ? "#0D47A1" : "#d0d0d0",
              },
              width: "36px",
              height: "36px",
            }}
          >
            {language === "si" ? (
              <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>සිං</Typography>
            ) : (
              <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>EN</Typography>
            )}
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleLanguageMenuClose}
          PaperProps={{
            sx: {
              mt: 0.5,
              minWidth: 100,
              borderRadius: "6px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            },
          }}
        >
          <MenuItem
            onClick={() => handleLanguageChange("en")}
            selected={language === "en"}
            sx={{
              backgroundColor: language === "en" ? "rgba(21, 76, 121, 0.08)" : "transparent",
              "&:hover": {
                backgroundColor: "rgba(21, 76, 121, 0.12)",
              },
              py: 0.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LanguageIcon sx={{ fontSize: 16, color: "#154c79" }} />
              <Typography sx={{ fontWeight: language === "en" ? 600 : 400, fontSize: "12px" }}>
                English
              </Typography>
            </Box>
          </MenuItem>
          <MenuItem
            onClick={() => handleLanguageChange("si")}
            selected={language === "si"}
            sx={{
              backgroundColor: language === "si" ? "rgba(21, 76, 121, 0.08)" : "transparent",
              "&:hover": {
                backgroundColor: "rgba(21, 76, 121, 0.12)",
              },
              py: 0.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <TranslateIcon sx={{ fontSize: 16, color: "#154c79" }} />
              <Typography sx={{ fontWeight: language === "si" ? 600 : 400, fontSize: "12px" }}>
                සිංහල
              </Typography>
            </Box>
          </MenuItem>
        </Menu>
      </ProgressContainer>
    );
  };

  // Render summary cards
  const renderSummaryCards = () => {
    const totalEmployees = selectedEmployees.length;
    const totalShifts = selectedShifts.length;
    const totalDates = selectedDates.length;

    return (
      <Box sx={{ display: "flex", justifyContent: "center", gap: "8px", mt: 2 }}>
        <SummaryCard color="#0E3C66">
          <Typography sx={{ fontSize: "10px", fontWeight: 500, mb: 0.2 }}>
            {t.dates}
          </Typography>
          <Typography sx={{ fontSize: "18px", fontWeight: 800 }}>
            {totalDates}
          </Typography>
        </SummaryCard>

        <SummaryCard color="#004d40">
          <Typography sx={{ fontSize: "10px", fontWeight: 500, mb: 0.2 }}>
            {t.shifts}
          </Typography>
          <Typography sx={{ fontSize: "18px", fontWeight: 800 }}>
            {totalShifts}
          </Typography>
        </SummaryCard>

        <SummaryCard color="#b71c1c">
          <Typography sx={{ fontSize: "10px", fontWeight: 500, mb: 0.2 }}>
            {t.employees}
          </Typography>
          <Typography sx={{ fontSize: "18px", fontWeight: 800 }}>
            {totalEmployees}
          </Typography>
        </SummaryCard>
      </Box>
    );
  };

  // Group assignments by shift
  const assignmentsByShift = useMemo(() => {
    const grouped = {};
    allRosterDetails.forEach((assignment) => {
      const shiftKey = assignment.shift_code;
      if (!grouped[shiftKey]) {
        grouped[shiftKey] = {
          shift_name: assignment.shift_name,
          shift_code: assignment.shift_code,
          StartTime: assignment.StartTime,
          EndTime: assignment.EndTime,
          assignments: [],
          employees: new Set(),
          dates: new Set(),
        };
      }
      grouped[shiftKey].assignments.push(assignment);
      grouped[shiftKey].employees.add(assignment.service_no);
      grouped[shiftKey].dates.add(assignment.WorkDate);
    });
    return grouped;
  }, [allRosterDetails]);

  // Toggle shift expansion
  const toggleShiftExpansion = (shiftCode) => {
    setExpandedShifts(prev => ({
      ...prev,
      [shiftCode]: !prev[shiftCode]
    }));
  };

  // Tabs content
  const renderTabContent = () => {
    switch (tabValue) {
      case 0: // Create Roster
        return (
          <Box>
            {/* Stepper - Always horizontal */}
            <Stepper 
              activeStep={activeStep} 
              orientation="horizontal"
              sx={{ 
                mb: 2,
                "& .MuiStepLabel-label": {
                  fontSize: "11px",
                },
                "& .MuiStep-root": {
                  padding: "4px",
                }
              }}
            >
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel
                    StepIconComponent={() => (
                      <Avatar
                        sx={{
                          bgcolor: activeStep >= index ? "#154c79" : "#e0e0e0",
                          color: activeStep >= index ? "white" : "#616161",
                          width: 28,
                          height: 28,
                          fontSize: "0.8rem",
                        }}
                      >
                        {step.icon}
                      </Avatar>
                    )}
                  >
                    <Typography variant="caption" sx={{ color: "#757575", fontSize: "10px", display: { xs: "none", sm: "block" } }}>
                      {step.description}
                    </Typography>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>

            {/* Step Content */}
            <Box sx={{ mt: 1 }}>
              {activeStep === 0 && (
                <Card sx={{ borderRadius: "6px" }}>
                  <CardContent sx={{ p: 2 }}>
                    <Typography variant="h6" sx={{ mb: 2, color: "#154c79", fontSize: "14px" }}>
                      {t.selectDates}
                    </Typography>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <Button
                        onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1))}
                        variant="outlined"
                        size="small"
                        startIcon={<ArrowBackIcon fontSize="small" />}
                        sx={{ fontSize: "11px", minWidth: "auto" }}
                      >
                        {t.previous}
                      </Button>
                      <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79", fontSize: "14px" }}>
                        {getMonthName()}
                      </Typography>
                      <Button
                        onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1))}
                        variant="outlined"
                        size="small"
                        endIcon={<ArrowForwardIcon fontSize="small" />}
                        sx={{ fontSize: "11px", minWidth: "auto" }}
                      >
                        {t.nextMonth}
                      </Button>
                    </Box>

                    {renderCalendar()}

                    {selectedDates.length > 0 && (
                      <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#154c79", fontSize: "12px" }}>
                          {t.selected} {t.dates} ({selectedDates.length})
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {selectedDates.sort().map((date) => (
                            <Chip
                              key={date}
                              label={formatDateDisplay(date)}
                              onDelete={() => handleDateSelection(new Date(date))}
                              color="primary"
                              size="small"
                              sx={{ fontWeight: "bold", fontSize: "10px" }}
                            />
                          ))}
                        </Box>
                      </Box>
                    )}

                    {renderSummaryCards()}
                  </CardContent>
                </Card>
              )}

              {activeStep === 1 && (
                <Card sx={{ borderRadius: "6px" }}>
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <Typography variant="h6" sx={{ color: "#154c79", fontSize: "14px" }}>
                        {t.selectShifts}
                      </Typography>
                      <Button
                        startIcon={<AddIcon fontSize="small" />}
                        variant="outlined"
                        size="small"
                        onClick={() => setOpenAddScheduleDialog(true)}
                        sx={{ fontSize: "11px", minWidth: "auto" }}
                      >
                        {t.addNewShift}
                      </Button>
                    </Box>

                    {/* Search Bar */}
                    <TextField
                      fullWidth
                      placeholder={t.searchShifts}
                      value={searchShiftTerm}
                      onChange={(e) => setSearchShiftTerm(e.target.value)}
                      sx={{ mb: 2 }}
                      size="small"
                      InputProps={{
                        startAdornment: <SearchIcon sx={{ mr: 1, color: "#9e9e9e", fontSize: "18px" }} />,
                        endAdornment: searchShiftTerm && (
                          <IconButton size="small" onClick={() => setSearchShiftTerm("")} sx={{ p: 0.5 }}>
                            <ClearIcon sx={{ fontSize: "16px" }} />
                          </IconButton>
                        ),
                      }}
                    />

                    {loadingShifts ? (
                      <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                        <CircularProgress sx={{ color: "#154c79" }} size={24} />
                        <Typography variant="body2" sx={{ mt: 1, color: "#666", ml: 1, fontSize: "11px" }}>
                          {t.loadingShifts}
                        </Typography>
                      </Box>
                    ) : filteredShifts && filteredShifts.length > 0 ? (
                      <ScrollableContainer>
                        <Grid container spacing={1}>
                          {filteredShifts.map((shift) => (
                            <Grid item xs={12} sm={6} md={4} key={shift.shift_code}>
                              <ShiftCard
                                selected={selectedShifts.some((s) => s.shift_code === shift.shift_code)}
                                onClick={() => handleShiftSelection(shift)}
                              >
                                <CardContent sx={{ p: 1.5 }}>
                                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                    <Box sx={{ flex: 1 }}>
                                      <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#154c79", fontSize: "12px" }}>
                                        {shift.shift_name}
                                      </Typography>
                                      <Typography variant="body2" sx={{ color: "#546e7a", mb: 0.5, fontSize: "10px" }}>
                                        {t.shiftCode}: {shift.shift_code}
                                      </Typography>
                                      <Typography variant="body2" sx={{ color: "#154c79", fontWeight: "bold", fontSize: "11px" }}>
                                        <AccessTimeIcon sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }} />
                                        {shift.StartTime} - {shift.EndTime}
                                      </Typography>
                                    </Box>
                                    <Chip
                                      label={shift.status === "A" ? t.active : t.inactive}
                                      size="small"
                                      color={shift.status === "A" ? "success" : "default"}
                                      sx={{ fontSize: "9px", height: "20px" }}
                                    />
                                  </Box>
                                </CardContent>
                              </ShiftCard>
                            </Grid>
                          ))}
                        </Grid>
                      </ScrollableContainer>
                    ) : (
                      <Box sx={{ textAlign: "center", p: 3 }}>
                        <ScheduleIcon sx={{ fontSize: 40, color: "#e0e0e0", mb: 1 }} />
                        <Typography variant="body1" sx={{ color: "#666", mb: 1, fontSize: "12px" }}>
                          {t.noShifts}
                        </Typography>
                        <Button
                          startIcon={<AddIcon />}
                          variant="contained"
                          size="small"
                          onClick={() => setOpenAddScheduleDialog(true)}
                          sx={{ fontSize: "11px" }}
                        >
                          {t.addNewShift}
                        </Button>
                      </Box>
                    )}

                    {selectedShifts.length > 0 && (
                      <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#154c79", fontSize: "12px" }}>
                          {t.selected} {t.shifts} ({selectedShifts.length})
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {selectedShifts.map((shift) => (
                            <Chip
                              key={shift.shift_code}
                              label={`${shift.shift_name}`}
                              onDelete={() => handleShiftSelection(shift)}
                              color="primary"
                              size="small"
                              sx={{ fontWeight: "bold", fontSize: "10px" }}
                            />
                          ))}
                        </Box>
                      </Box>
                    )}

                    {renderSummaryCards()}
                  </CardContent>
                </Card>
              )}

              {activeStep === 2 && (
                <Card sx={{ borderRadius: "6px" }}>
                  <CardContent sx={{ p: 2 }}>
                    <Typography variant="h6" sx={{ mb: 2, color: "#154c79", fontSize: "14px" }}>
                      {t.selectLocation}
                    </Typography>

                    {/* Search Bar */}
                    <TextField
                      fullWidth
                      placeholder={t.searchLocations}
                      value={searchLocationTerm}
                      onChange={(e) => setSearchLocationTerm(e.target.value)}
                      sx={{ mb: 2 }}
                      size="small"
                      InputProps={{
                        startAdornment: <SearchIcon sx={{ mr: 1, color: "#9e9e9e", fontSize: "18px" }} />,
                        endAdornment: searchLocationTerm && (
                          <IconButton size="small" onClick={() => setSearchLocationTerm("")} sx={{ p: 0.5 }}>
                            <ClearIcon sx={{ fontSize: "16px" }} />
                          </IconButton>
                        ),
                      }}
                    />

                    {loadingLocations ? (
                      <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                        <CircularProgress sx={{ color: "#154c79" }} size={24} />
                        <Typography variant="body2" sx={{ mt: 1, color: "#666", ml: 1, fontSize: "11px" }}>
                          {t.loadingLocations}
                        </Typography>
                      </Box>
                    ) : filteredLocations && filteredLocations.length > 0 ? (
                      <ScrollableContainer>
                        <Grid container spacing={1}>
                          {filteredLocations.map((location) => (
                            <Grid item xs={12} sm={6} md={4} key={location.loc_code}>
                              <LocationCard
                                selected={selectedLocation === location.loc_code}
                                onClick={() => handleLocationChange(location.loc_code)}
                              >
                                <CardContent sx={{ p: 1.5 }}>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                    <Avatar sx={{ bgcolor: "#154c79", width: 32, height: 32 }}>
                                      <LocationOnIcon sx={{ fontSize: 16 }} />
                                    </Avatar>
                                    <Box sx={{ flex: 1 }}>
                                      <Typography variant="subtitle1" sx={{ fontWeight: "bold", fontSize: "12px" }}>
                                        {location.loc_name}
                                      </Typography>
                                      <Typography variant="body2" sx={{ color: "#546e7a", fontSize: "10px" }}>
                                        {t.location}: {location.loc_code}
                                      </Typography>
                                      {employeesByLocation[location.loc_code] && (
                                        <Typography variant="caption" sx={{ color: "#2e7d32", display: "block", mt: 0.5, fontSize: "9px" }}>
                                          {employeesByLocation[location.loc_code].length} {t.employees}
                                        </Typography>
                                      )}
                                    </Box>
                                  </Box>
                                </CardContent>
                              </LocationCard>
                            </Grid>
                          ))}
                        </Grid>
                      </ScrollableContainer>
                    ) : (
                      <Box sx={{ textAlign: "center", p: 3 }}>
                        <LocationOnIcon sx={{ fontSize: 40, color: "#e0e0e0", mb: 1 }} />
                        <Typography variant="body1" sx={{ color: "#666", mb: 1, fontSize: "12px" }}>
                          {t.noLocationsFound}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 1, justifyContent: "center", flexWrap: "wrap" }}>
                          <Button 
                            variant="outlined" 
                            onClick={() => dispatch(fetchLocations())}
                            startIcon={<RefreshIcon fontSize="small" />}
                            size="small"
                            sx={{ fontSize: "11px" }}
                          >
                            {t.retry}
                          </Button>
                          <Button 
                            variant="contained" 
                            onClick={handleTestAPIConnectivity}
                            startIcon={<MenuIcon fontSize="small" />}
                            size="small"
                            sx={{ fontSize: "11px" }}
                          >
                            {t.testAPI}
                          </Button>
                        </Box>
                      </Box>
                    )}

                    {renderSummaryCards()}
                  </CardContent>
                </Card>
              )}

              {activeStep === 3 && (
                <Card sx={{ borderRadius: "6px" }}>
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <Typography variant="h6" sx={{ color: "#154c79", fontSize: "14px" }}>
                        {t.selectEmployees} - {locations.find((l) => l.loc_code === selectedLocation)?.loc_name || selectedLocation}
                      </Typography>
                      <Button variant="outlined" size="small" onClick={handleSelectAllEmployees} sx={{ fontSize: "11px", minWidth: "auto" }}>
                        {selectedEmployees.length === filteredEmployees.length ? t.deselectAll : t.selectAll}
                      </Button>
                    </Box>

                    <TextField
                      fullWidth
                      placeholder={t.searchEmployees}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      sx={{ mb: 2 }}
                      size="small"
                      InputProps={{
                        startAdornment: <SearchIcon sx={{ mr: 1, color: "#9e9e9e", fontSize: "18px" }} />,
                        endAdornment: searchTerm && (
                          <IconButton size="small" onClick={() => setSearchTerm("")} sx={{ p: 0.5 }}>
                            <ClearIcon sx={{ fontSize: "16px" }} />
                          </IconButton>
                        ),
                      }}
                    />

                    {loadingEmployees ? (
                      <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                        <CircularProgress sx={{ color: "#154c79" }} size={24} />
                        <Typography variant="body2" sx={{ mt: 1, color: "#666", ml: 1, fontSize: "11px" }}>
                          {t.loadingEmployees}
                        </Typography>
                      </Box>
                    ) : filteredEmployees.length === 0 ? (
                      <Alert severity="info" sx={{ fontSize: "11px", py: 0.5 }}>
                        {searchTerm ? "No employees match your search." : "No employees found for this location."}
                      </Alert>
                    ) : (
                      <ScrollableContainer>
                        <Grid container spacing={1}>
                          {filteredEmployees.map((employee) => (
                            <Grid item xs={12} sm={6} md={4} key={employee.service_no}>
                              <EmployeeCard onClick={() => handleEmployeeSelection(employee)}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                  <Avatar sx={{ bgcolor: "#154c79", width: 32, height: 32, fontSize: "14px" }}>
                                    {employee.Name?.charAt(0) || "E"}
                                  </Avatar>
                                  <Box sx={{ flex: 1 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#154c79", fontSize: "12px" }}>
                                      {employee.Name}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: "#546e7a", display: "block", fontSize: "10px" }}>
                                      {t.serviceNo}: {employee.service_no}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: "#757575", display: "block", fontSize: "9px" }}>
                                      {employee.Designation} - {employee.Department}
                                    </Typography>
                                  </Box>
                                  {selectedEmployees.some((e) => e.service_no === employee.service_no) ? (
                                    <CheckCircleIcon sx={{ color: "#2e7d32", fontSize: "20px" }} />
                                  ) : null}
                                </Box>
                              </EmployeeCard>
                            </Grid>
                          ))}
                        </Grid>
                      </ScrollableContainer>
                    )}

                    {selectedEmployees.length > 0 && (
                      <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#154c79", fontSize: "12px" }}>
                          {t.selected} {t.employees} ({selectedEmployees.length})
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {selectedEmployees.map((employee) => (
                            <Chip
                              key={employee.service_no}
                              label={`${employee.Name}`}
                              onDelete={() => handleEmployeeSelection(employee)}
                              color="primary"
                              size="small"
                              sx={{ fontWeight: "bold", fontSize: "10px" }}
                            />
                          ))}
                        </Box>
                      </Box>
                    )}

                    {renderSummaryCards()}
                  </CardContent>
                </Card>
              )}

              {activeStep === 4 && (
                <Card sx={{ borderRadius: "6px" }}>
                  <CardContent sx={{ p: 2 }}>
                    <Typography variant="h6" sx={{ mb: 2, color: "#154c79", fontSize: "14px" }}>
                      {t.reviewAssign}
                    </Typography>

                    <Grid container spacing={1} sx={{ mb: 2 }}>
                      <Grid item xs={12} md={4}>
                        <Card sx={{ bgcolor: "rgba(232, 245, 233, 0.5)", border: "1px solid #c8e6c9" }}>
                          <CardContent sx={{ p: 1.5 }}>
                            <Typography variant="subtitle2" sx={{ color: "#2e7d32", mb: 0.5, fontWeight: "bold", fontSize: "11px" }}>
                              {t.dates}
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: "bold", color: "#2e7d32", fontSize: "24px" }}>
                              {selectedDates.length}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Card sx={{ bgcolor: "rgba(227, 242, 253, 0.5)", border: "1px solid #bbdefb" }}>
                          <CardContent sx={{ p: 1.5 }}>
                            <Typography variant="subtitle2" sx={{ color: "#1565c0", mb: 0.5, fontWeight: "bold", fontSize: "11px" }}>
                              {t.shifts}
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: "bold", color: "#1565c0", fontSize: "24px" }}>
                              {selectedShifts.length}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Card sx={{ bgcolor: "rgba(243, 229, 245, 0.5)", border: "1px solid #e1bee7" }}>
                          <CardContent sx={{ p: 1.5 }}>
                            <Typography variant="subtitle2" sx={{ color: "#7b1fa2", mb: 0.5, fontWeight: "bold", fontSize: "11px" }}>
                              {t.employees}
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: "bold", color: "#7b1fa2", fontSize: "24px" }}>
                              {selectedEmployees.length}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>

                    <Alert severity="info" sx={{ mb: 2, fontSize: "11px", py: 0.5 }}>
                      {t.totalAssignments}: <strong>{selectedDates.length * selectedShifts.length * selectedEmployees.length}</strong>
                    </Alert>
                  </CardContent>
                </Card>
              )}
            </Box>
          </Box>
        );

      case 1: // View Assignments - Redesigned with shift grouping
        return (
          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography variant="h6" sx={{ color: "#154c79", fontSize: "14px" }}>
                {t.viewAssignmentsByShift}
              </Typography>
              <Box sx={{ display: "flex", gap: 0.5 }}>
                <Button
                  startIcon={<FilterListIcon fontSize="small" />}
                  variant="outlined"
                  onClick={() => setOpenFilterDialog(true)}
                  size="small"
                  sx={{ fontSize: "11px", minWidth: "auto", px: 1 }}
                >
                  {t.filter}
                </Button>
                <Button
                  startIcon={<RefreshIcon fontSize="small" />}
                  variant="outlined"
                  onClick={() => dispatch(fetchAllRosterDetails({}))}
                  disabled={loadingAllRosterDetails}
                  size="small"
                  sx={{ fontSize: "11px", minWidth: "auto", px: 1 }}
                >
                  {t.refresh}
                </Button>
                <Button
                  startIcon={<PDFIcon fontSize="small" />}
                  variant="contained"
                  onClick={handleExportSummaryPDF}
                  disabled={exporting || loadingAllRosterDetails || allRosterDetails.length === 0}
                  size="small"
                  sx={{ 
                    fontSize: "11px", 
                    minWidth: "auto", 
                    px: 1,
                    backgroundColor: "#2e7d32", 
                    "&:hover": { backgroundColor: "#1b5e20" } 
                  }}
                >
                  {t.exportPdf}
                </Button>
              </Box>
            </Box>

            {loadingAllRosterDetails ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                <CircularProgress sx={{ color: "#154c79" }} size={30} />
                <Typography variant="body2" sx={{ mt: 1, color: "#666", ml: 1, fontSize: "11px" }}>
                  {t.loading}
                </Typography>
              </Box>
            ) : allRosterDetails.length === 0 ? (
              <Box sx={{ textAlign: "center", p: 4 }}>
                <ScheduleIcon sx={{ fontSize: 50, color: "#e0e0e0", mb: 1.5 }} />
                <Typography variant="h6" sx={{ color: "#666", mb: 1, fontSize: "13px" }}>
                  {t.noAssignments}
                </Typography>
                <Typography variant="body2" sx={{ color: "#999", mb: 2, fontSize: "11px" }}>
                  {t.createFirstRoster}
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => setTabValue(0)}
                  startIcon={<AddIcon fontSize="small" />}
                  size="small"
                  sx={{ fontSize: "11px" }}
                >
                  {t.createRoster}
                </Button>
              </Box>
            ) : (
              <Box>
                {Object.entries(assignmentsByShift).map(([shiftCode, shiftData]) => (
                  <Box key={shiftCode} sx={{ mb: 2 }}>
                    <ShiftAssignmentRow>
                      <Box 
                        sx={{ 
                          display: "flex", 
                          justifyContent: "space-between", 
                          alignItems: "center",
                          cursor: "pointer"
                        }}
                        onClick={() => toggleShiftExpansion(shiftCode)}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                          <Avatar sx={{ bgcolor: "#154c79", width: 36, height: 36 }}>
                            <ScheduleIcon sx={{ fontSize: 18 }} />
                          </Avatar>
                          <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#154c79", fontSize: "14px" }}>
                              {shiftData.shift_name}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#546e7a", fontSize: "11px" }}>
                              {shiftData.StartTime} - {shiftData.EndTime} | {t.assignedTo}: {shiftData.employees.size} {t.employees} | {t.dates}: {shiftData.dates.size}
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Chip
                            label={`${shiftData.assignments.length} ${t.assignments}`}
                            size="small"
                            color="primary"
                            sx={{ fontWeight: "bold", fontSize: "10px" }}
                          />
                          {expandedShifts[shiftCode] ? (
                            <KeyboardArrowUpIcon sx={{ color: "#154c79" }} />
                          ) : (
                            <KeyboardArrowDownIcon sx={{ color: "#154c79" }} />
                          )}
                        </Box>
                      </Box>

                      <Collapse in={expandedShifts[shiftCode]}>
                        <Box sx={{ mt: 2, pt: 2, borderTop: "1px solid #e0e0e0" }}>
                          <TableContainerStyled component={Paper}>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell>{t.workDate}</StyledTableCell>
                                  <StyledTableCell>{t.employeeName}</StyledTableCell>
                                  <StyledTableCell>{t.serviceNo}</StyledTableCell>
                                  <StyledTableCell>{t.location}</StyledTableCell>
                                  <StyledTableCell>{t.time}</StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {shiftData.assignments
                                  .slice((page - 1) * rowsPerPage, page * rowsPerPage)
                                  .map((assignment, index) => (
                                    <StyledTableRow key={index} hover>
                                      <StyledTableCell>
                                        {formatDateDisplay(assignment.WorkDate)}
                                      </StyledTableCell>
                                      <StyledTableCell sx={{ fontWeight: "bold", fontSize: "11px" }}>
                                        {assignment.Name}
                                      </StyledTableCell>
                                      <StyledTableCell>{assignment.service_no}</StyledTableCell>
                                      <StyledTableCell sx={{ fontSize: "11px" }}>{assignment.LocName}</StyledTableCell>
                                      <StyledTableCell>
                                        {assignment.StartTime} - {assignment.EndTime}
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainerStyled>

                          {shiftData.assignments.length > rowsPerPage && (
                            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                              <Pagination
                                count={Math.ceil(shiftData.assignments.length / rowsPerPage)}
                                page={page}
                                onChange={(e, value) => setPage(value)}
                                color="primary"
                                size="small"
                                siblingCount={isMobile ? 0 : 1}
                              />
                            </Box>
                          )}
                        </Box>
                      </Collapse>
                    </ShiftAssignmentRow>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        );

      case 2: // Manage Shifts
        return (
          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography variant="h6" sx={{ color: "#154c79", fontSize: "14px" }}>
                {t.manageShifts}
              </Typography>
              <Button
                startIcon={<AddIcon fontSize="small" />}
                variant="contained"
                onClick={() => setOpenAddScheduleDialog(true)}
                size="small"
                sx={{ fontSize: "11px" }}
              >
                {t.addNewShift}
              </Button>
            </Box>

            {loadingShifts ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                <CircularProgress sx={{ color: "#154c79" }} size={30} />
                <Typography variant="body2" sx={{ mt: 1, color: "#666", ml: 1, fontSize: "11px" }}>
                  {t.loadingShifts}
                </Typography>
              </Box>
            ) : shifts.length === 0 ? (
              <Box sx={{ textAlign: "center", p: 4 }}>
                <AccessTimeIcon sx={{ fontSize: 50, color: "#e0e0e0", mb: 1.5 }} />
                <Typography variant="h6" sx={{ color: "#666", mb: 1, fontSize: "13px" }}>
                  {t.noShifts}
                </Typography>
                <Typography variant="body2" sx={{ color: "#999", mb: 2, fontSize: "11px" }}>
                  Add your first shift to get started
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => setOpenAddScheduleDialog(true)}
                  startIcon={<AddIcon fontSize="small" />}
                  size="small"
                  sx={{ fontSize: "11px" }}
                >
                  {t.addNewShift}
                </Button>
              </Box>
            ) : (
              <ScrollableContainer>
                <Grid container spacing={1}>
                  {shifts.map((shift) => (
                    <Grid item xs={12} sm={6} md={4} key={shift.shift_code}>
                      <Card>
                        <CardContent sx={{ p: 1.5 }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <Box>
                              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79", fontSize: "12px" }}>
                                {shift.shift_name}
                              </Typography>
                              <Typography variant="body2" sx={{ color: "#546e7a", mb: 0.5, fontSize: "10px" }}>
                                {t.shiftCode}: {shift.shift_code}
                              </Typography>
                              <Typography variant="body1" sx={{ color: "#154c79", fontWeight: "bold", fontSize: "11px" }}>
                                <AccessTimeIcon sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }} />
                                {shift.StartTime} - {shift.EndTime}
                              </Typography>
                            </Box>
                            <Chip
                              label={shift.status === "A" ? t.active : t.inactive}
                              color={shift.status === "A" ? "success" : "default"}
                              size="small"
                              sx={{ fontSize: "9px", height: "20px" }}
                            />
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </ScrollableContainer>
            )}
          </Box>
        );

      default:
        return null;
    }
  };

  // Export PDF function
  const handleExportSummaryPDF = async () => {
    if (exporting || allRosterDetails.length === 0) return;

    try {
      setExporting(true);
      setExportProgress(10);

      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();

      setExportProgress(30);

      // Title
      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text(t.reportTitle, pageWidth / 2, 20, { align: "center" });

      setExportProgress(50);

      // Generate table
      autoTable(doc, {
        startY: 40,
        head: [[t.workDate, t.employeeName, t.serviceNo, t.shift, t.location, t.time]],
        body: allRosterDetails.slice(0, 100).map((item) => {
          const displayDate = formatDateDisplay(item.WorkDate);
          return [
            displayDate,
            item.Name || "N/A",
            item.service_no || "N/A",
            item.shift_name || "N/A",
            item.LocName || "N/A",
            `${item.StartTime || ""} - ${item.EndTime || ""}`,
          ];
        }),
        styles: {
          fontSize: 8,
          cellPadding: 3,
        },
        headStyles: {
          fillColor: [21, 76, 121],
          textColor: 255,
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [245, 248, 252],
        },
      });

      setExportProgress(80);

      // Footer
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(9);
        doc.setTextColor(128, 128, 128);
        doc.text(
          `${t.page} ${i} ${t.of} ${pageCount}`,
          pageWidth - 15,
          doc.internal.pageSize.getHeight() - 10,
          { align: "right" }
        );
        doc.text(
          `${t.generatedOn} ${new Date().toLocaleDateString()}`,
          15,
          doc.internal.pageSize.getHeight() - 10
        );
      }

      setExportProgress(100);

      // Save PDF
      const filename = language === "si"
        ? `රෝස්ටර්_නියමයන්_වාර්තා_${formatDate(new Date())}.pdf`
        : `Roster_Assignments_${formatDate(new Date())}.pdf`;

      doc.save(filename);

      showSnackbar(t.pdfSuccess, "success");

      setTimeout(() => {
        setExporting(false);
        setExportProgress(0);
      }, 1000);
    } catch (error) {
      console.error("Error generating PDF:", error);
      showSnackbar(t.pdfError, "error");
      setExporting(false);
      setExportProgress(0);
    }
  };

  // Render bottom navigation buttons
  const renderBottomNavigation = () => {
    if (tabValue === 0) {
      return (
        <>
          {activeStep > 0 && (
            <Button
              variant="outlined"
              onClick={() => setActiveStep(activeStep - 1)}
              startIcon={<ArrowBackIcon />}
              fullWidth
              size="small"
              sx={{ fontSize: "11px", py: 1 }}
            >
              {t.back}
            </Button>
          )}
          {activeStep < 4 ? (
            <Button
              variant="contained"
              onClick={() => setActiveStep(activeStep + 1)}
              disabled={
                (activeStep === 0 && selectedDates.length === 0) ||
                (activeStep === 1 && selectedShifts.length === 0) ||
                (activeStep === 2 && !selectedLocation) ||
                (activeStep === 3 && selectedEmployees.length === 0)
              }
              endIcon={<ArrowForwardIcon />}
              fullWidth
              size="small"
              sx={{ fontSize: "11px", py: 1 }}
            >
              {t.next}
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={handleAssignRoster}
              disabled={postingRoster}
              startIcon={postingRoster ? <CircularProgress size={16} /> : <AssignmentIcon />}
              fullWidth
              size="small"
              sx={{ fontSize: "11px", py: 1, backgroundColor: "#2e7d32" }}
            >
              {postingRoster ? t.assigning : t.assignRoster}
            </Button>
          )}
        </>
      );
    }
    return null;
  };

  // Render tabs
  const renderTabs = () => {
    const tabs = [
      { label: t.createRoster, icon: <AddIcon fontSize="small" />, value: 0 },
      { label: t.viewAssignments, icon: <VisibilityIcon fontSize="small" />, value: 1 },
      { label: t.manageShifts, icon: <ScheduleIcon fontSize="small" />, value: 2 },
    ];

    return (
      <TabsContainer>
        <Box sx={{ display: "flex", gap: "8px" }}>
          {tabs.map((tab) => (
            <Button
              key={tab.value}
              variant={tabValue === tab.value ? "contained" : "outlined"}
              onClick={() => {
                setTabValue(tab.value);
                if (tab.value !== 0) setActiveStep(0);
              }}
              startIcon={tab.icon}
              sx={{
                flex: 1,
                borderRadius: "6px",
                textTransform: "none",
                fontWeight: "bold",
                backgroundColor: tabValue === tab.value ? "#154c79" : "transparent",
                color: tabValue === tab.value ? "#fff" : "#154c79",
                borderColor: "#154c79",
                fontSize: isMobile ? "10px" : "11px",
                py: 0.5,
                minHeight: "40px",
                "&:hover": {
                  backgroundColor: tabValue === tab.value ? "#0D47A1" : "rgba(21, 76, 121, 0.08)",
                },
              }}
            >
              {tab.label}
            </Button>
          ))}
        </Box>
      </TabsContainer>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <PageContainer>
        {/* Export Progress Backdrop */}
        <ProgressBackdrop open={exporting}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.5,
              p: 3,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              maxWidth: 350,
              width: "100%",
            }}
          >
            <CircularProgress size={50} thickness={4} sx={{ color: "#154c79" }} />
            <Typography variant="h6" color="primary" fontWeight="bold" sx={{ fontSize: "14px" }}>
              {exporting ? t.exporting : "Preparing report..."}
            </Typography>
            <Box sx={{ width: "100%", mt: 1.5 }}>
              <LinearProgress
                variant="determinate"
                value={exportProgress}
                sx={{
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: "#e0e0e0",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "#2e7d32",
                  },
                }}
              />
              <Typography variant="body2" color="text.secondary" align="center" mt={0.5} sx={{ fontSize: "10px" }}>
                {exportProgress}%
              </Typography>
            </Box>
          </Box>
        </ProgressBackdrop>

        {/* Success/Error Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={closeSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <AlertComponent onClose={closeSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
            {snackbar.message}
          </AlertComponent>
        </Snackbar>

        {/* Header Banner Page */}
        <HeaderBannerPage />

        {/* Main Content Area */}
        <ContentArea>
          {/* Progress Bar */}
          {renderProgressBar()}

          {/* Tabs */}
          {renderTabs()}

          {/* Main Content */}
          <MainCardContainer>
            {renderTabContent()}
          </MainCardContainer>
        </ContentArea>

        {/* Bottom Navigation */}
        <BottomNavigation>
          {renderBottomNavigation()}
        </BottomNavigation>

        {/* Add Schedule Dialog */}
        <Dialog
          open={openAddScheduleDialog}
          onClose={() => setOpenAddScheduleDialog(false)}
          maxWidth="sm"
          fullWidth
          fullScreen={isMobile}
        >
          <DialogTitle>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79", fontSize: "14px" }}>
              {t.addNewShift}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ pt: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
              <TextField
                fullWidth
                label={t.shiftCode}
                value={newSchedule.shift_code}
                onChange={(e) => setNewSchedule({ ...newSchedule, shift_code: e.target.value })}
                required
                size="small"
                sx={{ "& .MuiInputBase-input": { fontSize: "13px" } }}
              />
              <TextField
                fullWidth
                label={t.shiftName}
                value={newSchedule.shift_name}
                onChange={(e) => setNewSchedule({ ...newSchedule, shift_name: e.target.value })}
                required
                size="small"
                sx={{ "& .MuiInputBase-input": { fontSize: "13px" } }}
              />
              <Box sx={{ display: "flex", gap: 1.5 }}>
                <TextField
                  fullWidth
                  label={t.startTime}
                  type="time"
                  value={newSchedule.StartTime}
                  onChange={(e) => setNewSchedule({ ...newSchedule, StartTime: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  required
                  size="small"
                  sx={{ "& .MuiInputBase-input": { fontSize: "13px" } }}
                />
                <TextField
                  fullWidth
                  label={t.endTime}
                  type="time"
                  value={newSchedule.EndTime}
                  onChange={(e) => setNewSchedule({ ...newSchedule, EndTime: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  required
                  size="small"
                  sx={{ "& .MuiInputBase-input": { fontSize: "13px" } }}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenAddScheduleDialog(false)} size="small" sx={{ fontSize: "11px" }}>
              {t.cancel}
            </Button>
            <Button
              onClick={handleAddSchedule}
              variant="contained"
              disabled={postingSchedule}
              startIcon={postingSchedule ? <CircularProgress size={16} /> : <AddIcon />}
              size="small"
              sx={{ fontSize: "11px" }}
            >
              {postingSchedule ? t.adding : t.addShift}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Filter Dialog */}
        <Dialog
          open={openFilterDialog}
          onClose={() => setOpenFilterDialog(false)}
          maxWidth="sm"
          fullWidth
          fullScreen={isMobile}
        >
          <DialogTitle>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#154c79", fontSize: "14px" }}>
              {t.filter}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ pt: 1, display: "flex", flexDirection: "column", gap: 1.5 }}>
              <FormControl fullWidth size="small">
                <InputLabel sx={{ fontSize: "13px" }}>{t.location}</InputLabel>
                <Select
                  value={filters.location}
                  onChange={(e) => setFilters({ ...filters, location: e.target.value })}
                  label={t.location}
                  sx={{ fontSize: "13px" }}
                >
                  <MenuItem value="" sx={{ fontSize: "13px" }}>{t.allLocations}</MenuItem>
                  {locations && locations.map((location) => (
                    <MenuItem key={location.loc_code} value={location.loc_code} sx={{ fontSize: "13px" }}>
                      {location.loc_name} ({location.loc_code})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                fullWidth
                label={t.employeeNo}
                value={filters.employeeNo}
                onChange={(e) => setFilters({ ...filters, employeeNo: e.target.value })}
                size="small"
                sx={{ "& .MuiInputBase-input": { fontSize: "13px" } }}
              />

              <FormControl fullWidth size="small">
                <InputLabel sx={{ fontSize: "13px" }}>{t.shift}</InputLabel>
                <Select
                  value={filters.shiftCode}
                  onChange={(e) => setFilters({ ...filters, shiftCode: e.target.value })}
                  label={t.shift}
                  sx={{ fontSize: "13px" }}
                >
                  <MenuItem value="" sx={{ fontSize: "13px" }}>{t.allShifts}</MenuItem>
                  {shifts.map((shift) => (
                    <MenuItem key={shift.shift_code} value={shift.shift_code} sx={{ fontSize: "13px" }}>
                      {shift.shift_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <DatePicker
                label={t.workDate}
                value={filters.workDate}
                onChange={(date) => setFilters({ ...filters, workDate: date })}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    sx: { "& .MuiInputBase-input": { fontSize: "13px" } },
                  },
                }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleResetFilters} size="small" sx={{ fontSize: "11px" }}>
              {t.clear}
            </Button>
            <Button onClick={() => setOpenFilterDialog(false)} size="small" sx={{ fontSize: "11px" }}>
              {t.cancel}
            </Button>
            <Button onClick={handleApplyFilters} variant="contained" size="small" sx={{ fontSize: "11px" }}>
              {t.applyFilters}
            </Button>
          </DialogActions>
        </Dialog>
      </PageContainer>
    </LocalizationProvider>
  );
};

export default RosterManagement;